import { Component, Renderer2, OnInit, ViewChild } from '@angular/core';
import * as L from "leaflet";
import 'leaflet-draw';
import 'leaflet.marker.slideto';
import 'leaflet-geometryutil';
import 'leaflet.markercluster';
import 'leaflet.markercluster.freezable';
import 'leaflet-fontawesome-markers';
import 'leaflet.icon.glyph';
import { Chart } from 'chart.js';
import { PolygonService } from '../../services/polygon.service';
import { CovidDoctor } from "../../services/covidDoctor.service";
import { CovidMedicalConsultantsService } from "../../services/covidMedicalConsultants.service";
import { CovidPharmacyService } from "../../services/covidPharmacy.service";
import { CovidHospitalsService } from "../../services/covidHospitals.service";
import { CovidLabsService } from "../../services/covidLabs.service";
import * as turf from '@turf/turf';
import { stringify } from 'wellknown/wellknown.js';
import { backend_url } from "../../config/url.config";
import { NgxSpinnerService } from 'ngx-spinner';
import archive_entidades from '../../../assets/entidades.json';
import archive_loc_urb from '../../../assets/loc_urb.json';
//import silhueta_de_ciudades from '../../../assets/ciudades.json';
import silhueta_de_ciudades from '../../../assets/ciudades_regiones.json';
import regiones_union from '../../../assets/regiones_union.json';
import archive_municipio from '../../../assets/municipios.json';
//import COVID_casos_positivos from '../../../assets/COVID_casos_positivos.json';
import hospitals_cdmx_disp from '../../../assets/hospitals_cdmx_disp.json';
//import COVID_casos_sospechosos from '../../../assets/COVID_casos_sospechosos.json';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { Options } from 'ng5-slider';
import { scaleLinear } from 'd3-scale';
import { scaleSqrt } from 'd3-scale';
import * as introJs from 'intro.js/intro.js';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { NgSelectModule, NgOption } from '@ng-select/ng-select';

import * as plotty from 'plotty';
import { GeoTIFF } from 'geotiff';
import 'geotiff-layer-leaflet/dist/geotiff-layer-leaflet';
import 'geotiff-layer-leaflet/src/geotiff-layer-leaflet-plotty';
import 'geotiff-layer-leaflet/src/geotiff-layer-leaflet-vector-arrows';


declare let $: any;

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})

export class MapComponent implements OnInit {
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();
  public map;
  public infoLayers: Array<{
    id: string, type: string, name: string, layer: string, label: string, logo: string,
    active: boolean, src: string, display: boolean, disabled: boolean, opacity: boolean, left: number, right: number,
    visible: boolean
  }>;
  public rendererTableSedesa: boolean = false;
  public statusControlMap: boolean = false;
  public statusControlMapWms: boolean = false;
  public statusControlMapWmsState: boolean = false;
  public statusControlMapWmsEntity: boolean = false;
  public statusControlMapWmsMunicipality: boolean = false;
  public statusMapMode: boolean = false;
  public statusMapModeExposition: boolean = false;
  public select_municipality;
  public dataEntityName = 'México';
  public estadoCOVID = 'México';
  public current_state;
  public current_municipality;
  public current_locality;
  public current_urban_region;
  public current_metropolitan_zone;
  public legendWms = [];
  public showLayerWms = false;
  public showLegendAreaExposition = false;
  public select_state;
  public select_locality;
  public select_metropolitan;
  public select_urban_areas;
  public select_ageb;
  public drag_inside_polygon;
  public showIntrojs: boolean = false;
  public showModalActive: boolean = false;
  public showRedSedesaButton: boolean = false;
  public showTweetChart: boolean = false;
  public showProjectionChart: boolean = false;
  public showLegend: boolean = false;
  public showLegendByMunicipalities: boolean = false;
  public showLegendHospitalsCovid: boolean = false;
  public showLegendHospitalsSedesa: boolean = false;
  public showLegendHospitalsDisponibility: boolean = false;
  public showRegionLegend: boolean = false;
  public nivelPolygons = 'Country';
  public info;
  public cdmx_mode = false;
  public public_mode = false;
  public cdmx_mode_bounds = {};
  public yuc_mode = false;
  public yuc_mode_bounds = {};

  public zoneExposition = [];
  public zoneCovid = [];
  public zoneGeoJsonExposition = undefined;

  public accesibility_layer = undefined;

  public select_ws = undefined;
  public status_wms = {
    country: undefined,
    states: undefined,
    urbanAreas: undefined
  }

  public showlegendInfo = {
    covid: false,
    projection2020: false,
    mortality: false,
    mortalityLocation: false,
    poverty: false,
    generalData: false,
  }

  public COVID_casos_por_estado = {}
  public COVID_casos_por_fecha = {}

  public layer = {
    select_state: undefined,
    select_metropolitan: undefined,
    select_municipality: undefined,
    select_locality: undefined,
    select_ageb: undefined
  }

  public polygons = {
    select_country: undefined,
    select_state: undefined,
    select_categories: undefined,
    select_urban_areas: undefined,
    select_metropolitan: undefined,
    select_municipality: undefined,
    select_locality: undefined,
    select_ageb: undefined
  }

  public covidGeoJson = {
    "pharmacies": undefined,
    "publicDoctors": undefined,
    "privateDoctors": undefined,
    "labs": undefined,
    "hospitalsCDMX": undefined
  }

  public markerClusters = {}
  public mortalityChart = undefined;
  public populationChart = undefined;
  public projectionChart = undefined;
  public vulnerabilityChart = undefined;
  public povertyChart = undefined;
  public infraChart = undefined;
  public hospitalsChart = undefined;
  public ventilatorsChart = undefined;
  public infraestructureChart = undefined;
  public mortalityRateChart = undefined;
  public covidAgesChart = undefined;
  public vulnerabilityStateChart = undefined;

  public infraInfoCountry = [];
  public chartOptions = {
    legend: {
      display: false
    },
    scale: {
      angleLines: {
        color: "#1A202C"
      },
      gridLines: {
        color: "#1A202C"
      },
      ticks: {
        display: false
        //backdropColor: 'rgba(255, 0, 0, 0.75)'
      },
      pointLabels: {
        fontColor: "#1A202C",
        fontSize: 10
      }
    }
  };


  public hospitalSedesa = []
  public hospitalSedesaActivo = []
  public hospitalSedesaDesignado = []
  public auxHospitalSedesa = []
  public cdmxModeSedesa = undefined
  public infoLayerSedesa = [
    {
      id: 'sedesa',
      type: 'sedesa',
      name: 'Hospitales Covid de la red SEDESA',
      layer: 'sedesa',
      label: 'Hospitales COVID SEDESA',
      logo: '',
      active: false,
      src: '../../../assets/iconoHospitalB.png',
      display: false,
      disabled: true,
      opacity: false,
      left: 100,
      right: 200
    },
    {
      id: 'sedesaTemp',
      type: 'sedesaTemp',
      name: 'Unidades Médicas temporales de la red SEDESA',
      layer: 'sedesaTemp',
      label: 'Unidades médicas temporales',
      logo: '',
      active: false,
      src: '../../../assets/iconoHospitalB.png',
      display: false,
      disabled: true,
      opacity: false,
      left: 100,
      right: 200
    },
  ]

  public casesLegendHospitalsSedesaCovid = [
    {
      label: 'Hospital Covid designado',
      name: "INSTITUTO MEXICANO DEL SEGURO SOCIAL",
      enable: true,
      marker: [],
      icon: backend_url + '/covid_pins/pin_hospital_sedesa_covid_activo.png'
    },
    {
      label: 'Hospital SEDESA',
      name: "INSTITUTO MEXICANO DEL SEGURO SOCIAL",
      enable: true,
      marker: [],
      icon: backend_url + '/covid_pins/pin_hospital_sedesa_covid_designado.png'
    }
  ];

  public generalData = {
    /* pharmacies: {
      title: 'Farmacias',
      total: 0,
      clusterized: true,
      type: 'pharmacies',
      logo: 'fas fa-pills',
      src: ''
    },
    publicDoctors: {
      title: 'Consultorios públicos',
      total: 0,
      clusterized: true,
      type: 'publicDoctors',
      logo: 'fas fa-hospital',
      src: ''
    },
    privateDoctors: {
      title: 'Consultorios privados',
      total: 0,
      clusterized: true,
      type: 'privateDoctors',
      logo: 'fas fa-clinic-medical',
      src: ''
    }, */
    labs: {
      title: 'Laboratorios COVID',
      total: 0,
      clusterized: true,
      type: 'labs',
      logo: 'fas fa-microscope',
      src: '',
      children: [],
      showChildren: false
    },
    covidHospitals: {
      title: 'Hospitales COVID',
      total: 0,
      clusterized: true,
      type: 'covidHospitals',
      logo: '',
      src: '../../../assets/hospital_covid_gris_400px.png',
      children: [],
      showChildren: false
    },
    sedesa: {
      title: 'Red SEDESA',
      total: 0,
      clusterized: true,
      type: 'sedesa',
      logo: '',
      src: '../../../assets/hospital_covid_gris_400px.png',
      children: [],
      showChildren: false
    },
    /*     publicHospitals: {
          title: 'Hospitales públicos',
          total: 0,
          clusterized: true,
          type: 'publicHospitals',
          logo: 'fas fa-hospital-symbol',
          src: '',
          children: [],
          showChildren: false
        },
        privateHospitals: {
          title: 'Hospitales privados',
          total: 0,
          clusterized: true,
          type: 'privateHospitals',
          logo: 'fas fa-hospital-alt',
          src: '',
          children: [],
          showChildren: false
        }, */
    ventilators: {
      title: 'Ventiladores SS',
      total: 0,
      clusterized: true,
      type: 'ventilators',
      logo: 'icon-ventilator',
      src: '',
      children: [],
      showChildren: false
    },
    ventilatorsClues: {
      title: 'Ventiladores CLUES',
      total: 0,
      clusterized: true,
      type: 'ventilators',
      logo: 'icon-ventilator',
      src: '',
      children: [],
      showChildren: false
    },
    camas: {
      title: 'Camas',
      total: 0,
      clusterized: true,
      type: 'beds',
      logo: 'fas fa-bed',
      src: '',
      children: [],
      showChildren: false
    },
    camasUci: {
      title: 'Camas uci',
      total: 0,
      clusterized: true,
      type: 'beds',
      logo: 'fas fa-procedures',
      src: '',
      children: [],
      showChildren: false
    },
    carpas: {
      title: 'Carpas de triage',
      total: 0,
      clusterized: true,
      type: 'carpas',
      logo: 'fas fa-store',
      src: '',
      children: [],
      showChildren: false
    },
    medicos: {
      title: 'Médicos',
      total: 0,
      clusterized: true,
      type: 'medicos',
      logo: 'fas fa-user-md',
      src: '',
      children: [],
      showChildren: false
    }/* ,
    access: {
      title: 'Accesibilidad',
      total: 0,
      clusterized: true,
      type: 'access',
      logo: 'fas fa-briefcase-medical',
      src: '',
      children: [],
      showChildren: false
    }	 */
  };



  public redSedesa = {
    labs: {
      title: 'Laboratorios COVID',
      total: 0,
      clusterized: true,
      type: 'labs',
      logo: 'fas fa-microscope',
      src: '',
      children: [],
      showChildren: false
    },
    aux: {
      title: 'auxiliar',
    },
    sedesa: {
      title: 'Hospitales Red SEDESA',
      total: 0,
      clusterized: true,
      type: 'sedesa',
      logo: '',
      src: '../../../assets/hospital_covid_gris_400px.png',
      children: [],
      showChildren: false
    },
    carpas: {
      title: 'Carpas de triage',
      total: 0,
      clusterized: true,
      type: 'carpas',
      logo: 'fas fa-store',
      src: '',
      children: [],
      showChildren: false
    },
    ventilators: {
      title: 'Ventiladores disponibles',
      total: 0,
      clusterized: true,
      type: 'ventilators',
      logo: 'icon-ventilator',
      src: '',
      children: [],
      showChildren: false
    },
    camas: {
      title: 'Camas',
      total: 0,
      clusterized: true,
      type: 'beds',
      logo: 'fas fa-bed',
      src: '',
      children: [],
      showChildren: false
    },
    recursosHum: {
      title: 'Recursos humanos',
      total: 0,
      clusterized: true,
      type: 'recursosHum',
      logo: 'fas fa-user-md',
      src: '',
      children: [],
      showChildren: false
    },
    consultorios: {
      title: 'Consultorios',
      total: 0,
      clusterized: true,
      type: 'consultorios',
      logo: 'fas fa-first-aid',
      src: '',
      children: [],
      showChildren: false
    }
  };

  public sedesaOtrasInstituciones = {
    ventilatorsClues: {
      title: 'Ventiladores totales',
      total: 0,
      clusterized: true,
      type: 'ventilators',
      logo: 'icon-ventilator',
      src: '',
      children: [],
      showChildren: false
    }
  }


  public covidData = {}
  public casosCovidNacional = { 'casosCOVID': {} }
  public covidCasesByState = {}
  public covidCasesByOrigin = {}


  public pobData = {
    pobTotal: {
      title: 'Población total',
      type: 'poblacion',
      total: 0,
      src: '',
      logo: 'fas fa-users',
      tooltip: 'Número de población total al censo del año 2010'
    },
    under5: {
      title: 'Menores de 5 años',
      type: 'poblacion',
      total: 0,
      logo: 'icon-kids',
      tooltip: 'Población menor a 5 años de edad'
    },
    over65: {
      title: 'Mayores de 65 años',
      type: 'poblacion',
      total: 0,
      logo: 'icon-old',
      tooltip: 'Población mayor a 65 años de edad'
    }

  };


  public populationChartData = [
    {
      title: "Mayores de 65 años",
      count: 0
    },
    {
      title: "Menores de 5 años",
      count: 0
    },
    {
      title: "Resto de la población",
      count: 0
    }
  ];

  public pobData2020 = {
    projection2020: {
      title: 'Proyección a 2020 total',
      type: 'poblacion',
      total: 0,
      logo: 'icon-grafica',
      tooltip: 'Proyección del número de población al año 2020'
    },
    projection2020under4: {
      title: 'Menores de 4 años',
      type: 'poblacion',
      total: 0,
      logo: 'icon-grafica',
      tooltip: 'Proyección del número de población menores a 4 años de edad'
    },
    projection2020over60: {
      title: 'Mayores a 60 años',
      type: 'poblacion',
      total: 0,
      logo: 'icon-grafica',
      tooltip: 'Proyección del número de población mayores a 60 años de edad'
    },

  };

  public projectionChartData = [
    {
      title: "Mayores de 60 años",
      count: 0
    },
    {
      title: "Menores de 4 años",
      count: 0
    },
    {
      title: "Resto de la población",
      count: 0
    }
  ];

  public vulData = {
    insabi: {
      type: 'health',
      title: 'INSABI',
      total: 0,
      logo: 'icon-insabi',
      tooltip: 'Total de personas que tienen derecho a recibir servicios médicos en la secretaría de salud, mediante el sistema de protección en salud (INSABI).'
    },
    imss: {
      type: 'health',
      title: 'IMSS',
      total: 0,
      logo: 'icon-imss',
      tooltip: 'Total de personas que tienen derecho a recibir servicios médicos en el Instituto Mexicano del Seguro Social (IMSS).'
    },
    issste: {
      type: 'health',
      title: 'ISSSTE',
      total: 0,
      logo: 'icon-issste',
      tooltip: 'Total de personas que tienen derecho a recibir servicios médicos en el Instituto de Seguridad y Servicios Sociales para los Trabajadores del Estado  (ISSSTE).'
    },
  };

  public mortalityData = {
    gradoCancer: {
      type: 'mortality',
      title: 'Mortalidad por cáncer',
      total: 0,
      logo: 'icon-cancer',
      tooltip: 'Grado de mortalidad por cáncer'
    },
    gradoCardiacas: {
      type: 'mortality',
      title: 'Mortalidad cardiaca',
      total: 0,
      logo: 'icon-cardio',
      tooltip: 'Grado de mortalidad por afecciones cardiacas'
    },
    gradoDiabetes: {
      type: 'mortality',
      title: 'Mortalidad por diabetes',
      total: 0,
      logo: 'icon-azucar',
      tooltip: 'Grado de mortalidad por diabetes'
    },
    gradoPulmonares: {
      type: 'mortality',
      title: 'Mortalidad pulmonar',
      total: 0,
      logo: 'icon-pulmon',
      tooltip: 'Grado de mortalidad por afecciones pulmonares'
    }
  };

  public povertyData = {
    pobreza: {
      type: 'poverty',
      title: 'Pobreza',
      total: 0,
      logo: 'icon-poverty',
      tooltip: 'Porcentaje de personas en pobreza'
    },
    pobrezaExtrema: {
      type: 'poverty',
      title: 'Pobreza extrema',
      total: 0,
      logo: 'icon-poverty',
      tooltip: 'Porcentaje de personas en pobreza extrema'
    },
    pobrezaSalud: {
      type: 'poverty',
      title: 'Carencia en salud',
      total: 0,
      logo: 'icon-poverty',
      tooltip: 'Porcentaje de personas sin acceso a servicios de salud'
    },
    pobrezaServicio: {
      type: 'poverty',
      title: 'Carencia en servicios',
      total: 0,
      logo: 'icon-poverty',
      tooltip: 'Porcentaje de personas con carencias de acceso a servicios básicos'
    },
    pobrezaAlimentos: {
      type: 'poverty',
      title: 'Carencia en alimentos',
      total: 0,
      logo: 'icon-poverty',
      tooltip: 'Porcentaje de personas con carencias de acceso a alimentos'
    }
  }

  public expositionData = {
    exposicion: {
      type: 'poverty',
      title: 'General',
      total: 0,
      logo: 'fas fa-exclamation-triangle',
      tooltip: 'Vulnerabilidad general',
      label: ''
    },
    exposicionSalud: {
      type: 'poverty',
      title: 'Por salud',
      total: 0,
      logo: 'fas fa-exclamation-triangle',
      tooltip: 'Vulnerabilidad por condiciones de salud',
      label: ''
    },
    exposicionInfra: {
      type: 'poverty',
      title: 'Por infraestructura',
      total: 0,
      logo: 'fas fa-exclamation-triangle',
      tooltip: 'Vulnerabilidad por carencia de infraestructura',
      label: ''
    }
  }

  public vulnerabilityStateData = {
    muyalto: {
      type: 'poverty',
      title: 'Muy alto',
      total: 0,
      logo: 'fas fa-exclamation-triangle',
      tooltip: 'Porcentaje de población con vulnerabilidad muy alta',
      label: ''
    },
    alto: {
      type: 'poverty',
      title: 'Alto',
      total: 0,
      logo: 'fas fa-exclamation-triangle',
      tooltip: 'Porcentaje de población con vulnerabilidad alta',
      label: ''
    },
    medio: {
      type: 'poverty',
      title: 'Medio',
      total: 0,
      logo: 'fas fa-exclamation-triangle',
      tooltip: 'Porcentaje de población con vulnerabilidad media',
      label: ''
    },
    bajo: {
      type: 'poverty',
      title: 'Bajo',
      total: 0,
      logo: 'fas fa-exclamation-triangle',
      tooltip: 'Porcentaje de población con vulnerabilidad baja',
      label: ''
    },
    muybajo: {
      type: 'poverty',
      title: 'Muy bajo',
      total: 0,
      logo: 'fas fa-exclamation-triangle',
      tooltip: 'Porcentaje de población con vulnerabilidad muy baja',
      label: ''
    },
  }


  public vulnerabilityStateChartData = [
    {
      title: "Muy alta",
      count: 0
    },
    {
      title: "Alta",
      count: 0
    },
    {
      title: "Media",
      count: 0
    },
    {
      title: "Baja",
      count: 0
    },
    {
      title: "Muy baja",
      count: 0
    }
  ];

  public vulDataAgeb = {
    povRange: {
      type: 'poverty',
      title: 'Rango de pobreza',
      min: 0,
      max: 0,
      total: 0,
      logo: 'icon-poverty',
      tooltip: 'Rango de pobreza.'
    }
  }

  public vulnerabilityChartData = [
    {
      title: "No derechohabientes",
      count: 0
    },
    {
      title: "Población INSABI",
      count: 0
    },
    {
      title: "Resto de la población",
      count: 0
    }
  ];

  public povertyChartData = [
    {
      title: "Pobreza",
      count: 0
    },
    {
      title: "Pobreza extrema",
      count: 0
    },
    {
      title: "Carencia en salud",
      count: 0
    },
    {
      title: "Carencia en servicios",
      count: 0
    },
    {
      title: "Carencia en alimentos",
      count: 0
    }
  ];


  public infraestructureChartData = [];

  public hospitalsChartData = [];

  public ventilatorsChartData = [];

  public hospitalsChartData_aux = [];
  public ventilatorsChartData_aux = [];

  public mortalityRateChartData = [
    {
      "name": "Cancer",
      "value": 0,
      "color": "#0f1dd9"
    }, {
      "name": "Cardiaca",
      "value": 0,
      "color": "#d90f0f"
    }, {
      "name": "Diabetes",
      "value": 0,
      "color": "#0fd3d9"
    }, {
      "name": "Pulmonar",
      "value": 0,
      "color": "#088a22"
    }
  ]


  public aux_generalData = JSON.parse(JSON.stringify(this.generalData));
  public aux_pobData = JSON.parse(JSON.stringify(this.pobData));
  public aux_pobData2020 = JSON.parse(JSON.stringify(this.pobData2020));
  public aux_vulData = JSON.parse(JSON.stringify(this.vulData));
  public aux_povData = JSON.parse(JSON.stringify(this.povertyData));
  public aux_mortalityData = JSON.parse(JSON.stringify(this.mortalityData));
  public aux_expositionData = JSON.parse(JSON.stringify(this.expositionData));
  public aux_redSedesa = JSON.parse(JSON.stringify(this.redSedesa));
  public aux_sedesaOtrasInstituciones = JSON.parse(JSON.stringify(this.sedesaOtrasInstituciones));

  public poblChart = {
    title: 'Población',
    type: 'PieChart',
    data: [
      ['Mayores de 65 años', 0],
      ['Menores de 5 años', 0],
      ['Resto de la población', 0]
    ],
    options: {
      chartArea: {
        width: '100%',
        height: '90%'
      },
      pieSliceBorderColor: '#E2E8F0',
      backgroundColor: 'transparent',
      colors: ['#FC8181', '#F6AD55', '#68D391'],
      width: 220,
      height: 120,
      pieSliceText: 'none'
    }
  };

  public sinDerechoHabienteChart = {
    title: 'DerechoHabiente',
    type: 'PieChart',
    data: [
      ['No derechohabientes', 0],
      ['INSABI', 0],
      ['Resto de la población', 0]
    ],
    options: {
      chartArea: {
        width: '70%',
        height: '60%'
      },
      width: 220,
      height: 120,
      pieSliceText: 'none'
    }
  };

  public casesAreaExposition = [
    {
      label: "Muy alto",
      min: -2.15,
      max: -1.04,
      color: "#662404"
    },
    {
      label: "Alto",
      min: -1.04,
      max: -0.79,
      color: "#cc4b07"
    },
    {
      label: "Medio",
      min: -0.79,
      max: -0.43,
      color: "#fb9929"
    },
    {
      label: "Bajo",
      min: -0.43,
      max: -0.05,
      color: "#ffe28b"
    },
    {
      label: "Muy bajo",
      min: -0.05,
      max: 2.45,
      color: "#ffffe4"
    }
  ];
  public casesLegend = [
    {
      label: 'Positivos de 1 a 2,000',
      color: '#E7B1B1'
    },
    {
      label: 'Positivos de 2,001 a 3,000',
      color: '#D98282'
    },
    {
      label: 'Positivos de 3,001 a 5,000',
      color: '#D47373'
    },
    {
      label: 'Positivos de 5,001 a 7,000',
      color: '#CF6363'
    },
    {
      label: 'Positivos de 7,001 a 10,000',
      color: '#CA5353'
    },
    {
      label: 'Positivos mayor a 10,000',
      color: '#AC3535'
    }
  ];

  public casesLegendByMunicipalities = [
    {
      label: '0 casos positivos',
      color: '#FFFFFF'
    },
    {
      label: 'Positivos de 1 a 50',
      color: '#ffd7d7'
    },
    {
      label: 'Positivos de 51 a 2,000',
      color: '#E7B1B1'
    },
    {
      label: 'Positivos de 2,001 a 3,000',
      color: '#D98282'
    },
    {
      label: 'Positivos de 3,001 a 5,000',
      color: '#D47373'
    },
    {
      label: 'Positivos de 5,001 a 7,000',
      color: '#CF6363'
    },
    {
      label: 'Positivos de 7,001 a 10,000',
      color: '#CA5353'
    },
    {
      label: 'Positivos mayor a 10,000',
      color: '#AC3535'
    }
  ];

  public casesLegendHospitalsCovid = [
    {
      label: 'IMSS',
      name: "INSTITUTO MEXICANO DEL SEGURO SOCIAL",
      enable: true,
      marker: [],
      icon: backend_url + '/covid_pins/pin_hospital_covid_imss.png'
    },
    {
      label: 'ISSSTE',
      name: "INSTITUTO DE SEGURIDAD Y SERVICIOS SOCIALES PARA LOS TRABAJADORES DEL ESTADO",
      enable: true,
      marker: [],
      icon: backend_url + '/covid_pins/pin_hospital_covid_issste.png'
    },
    {
      label: 'Secretaría de salud',
      name: "SECRETARIA DE SALUD",
      enable: true,
      marker: [],
      icon: backend_url + '/covid_pins/pin_hospital_covid_ss.png'
    },
    {
      label: 'SEDENA',
      name: "SECRETARIA DE LA DEFENSA NACIONAL",
      enable: true,
      marker: [],
      icon: backend_url + '/covid_pins/pin_hospital_covid_sedena.png'
    },
    {
      label: 'SEMAR',
      name: "SECRETARIA DE MARINA",
      enable: true,
      marker: [],
      icon: backend_url + '/covid_pins/pin_hospital_covid_semar.png'
    },
    // {
    //   label: 'Covid activo',
    //   name: "INSTITUTO MEXICANO DEL SEGURO SOCIAL",
    //   enable: true,
    //   marker: [],
    //   icon: backend_url + '/covid_pins/pin_hospital_covid_activo.png'
    // },
    // {
    //   label: 'Covid designado',
    //   name: "INSTITUTO MEXICANO DEL SEGURO SOCIAL",
    //   enable: true,
    //   marker: [],
    //   icon: backend_url + '/covid_pins/pin_hospital_covid_designado.png'
    // }
  ];

  public casesLegendHospitalsDisponibility = [
    {
      label: 'Disponibiliad alta',
      name: "Hospitales con disponibilidad alta",
      enable: true,
      marker: [],
      icon: backend_url + '/covid_pins/pin_disponible.png'
    },
    {
      label: 'Disponibiliad media',
      name: "Hospitales con disponibiblidad media",
      enable: true,
      marker: [],
      icon: backend_url + '/covid_pins/pin_disponible_media.png'
    },
    {
      label: 'Sin disponibilidad',
      name: "Hospitales sin disponibilidad",
      enable: true,
      marker: [],
      icon: backend_url + '/covid_pins/pin_disponible_no.png'
    }
  ];

  public regionLegend = [
    {
      label: 'Centro Norte',
      color: '#585C5F'
    },
    {
      label: 'Golfo Oriente',
      color: '#aaaeb1'
    },
    {
      label: 'Centro Occidente',
      color: '#aab7c0'
    },
    {
      label: 'Noroeste',
      color: '#6d9ab7'
    },
    {
      label: 'Frontera Norte',
      color: '#5591da'
    },
    {
      label: 'Península de Yucatán',
      color: '#1b1464'
    },
    {
      label: 'Megalópolis',
      color: '#3C5667'
    },
    {
      label: 'Noreste',
      color: '#302972'
    },
    {
      label: 'Golfo',
      color: '#433c7f'
    }
  ]

  public showInfraTab = false;
  public showCovidTab = true;
  public showVulTab = false;

  public showPopTab = true;
  public showTwitterTab = false;
  public showWMSTab = false;

  public covidTotal = 0;

  public controlMouseDown = false;

  public covidChartData = [];

  public rangeOptions: Options = {
    floor: 0,
    ceil: 100,
    readOnly: true,
    translate: (value: number): string => {
      return value + '%';
    }
  };

  public emptyInfrastructure = false;

  introJS = introJs();

  public selectedMunicipality: any;
  public allMunicipality: Array<{ id: string, name: string, municipio_cvegeo: string, entidad_cvegeo: string }>;

  constructor(
    private polygonService: PolygonService,
    private covidDoctor: CovidDoctor,
    private covidMedicalConsultantsService: CovidMedicalConsultantsService,
    private covidPharmacyService: CovidPharmacyService,
    private covidHospitalsService: CovidHospitalsService,
    private covidLabsService: CovidLabsService,
    private renderer: Renderer2,
    private spinner: NgxSpinnerService,
    private router: Router,
    public auth: AuthService
  ) {

    if (window.location.href.includes("cdmx")) {
      if (!this.auth.isAuthenticated()) {
        this.router.navigate(['login']);
      }
    }

    let that = this
    this.markerClusters = {
      "pharmacies": new L.MarkerClusterGroup({
        polygonOptions: {
          color: "#d0736d"
        },
        iconCreateFunction: function (cluster) {
          return that.createNormalIcon(cluster, 'pharmacies');
        }
      }),
      "publicDoctors": new L.MarkerClusterGroup({
        polygonOptions: {
          color: "#0cd3b3"
        },
        iconCreateFunction: function (cluster) {
          return that.createNormalIcon(cluster, 'publicDoctors');
        }
      }),
      "privateDoctors": new L.MarkerClusterGroup({
        polygonOptions: {
          color: "#c264d5"
        },
        iconCreateFunction: function (cluster) {
          return that.createNormalIcon(cluster, 'privateDoctors');
        }
      }),
      "labs": new L.MarkerClusterGroup({
        polygonOptions: {
          color: "#bfb441"
        },
        iconCreateFunction: function (cluster) {
          return that.createNormalIcon(cluster, 'labs');
        }
      }),
      "covidHospitals": new L.MarkerClusterGroup({
        polygonOptions: {
          color: "#fe0615"
        },
        iconCreateFunction: function (cluster) {
          return that.createNormalIcon(cluster, 'covidHospitals');
        }
      }),
      "hospitalsCDMX": new L.MarkerClusterGroup({
        polygonOptions: {
          color: "#7ea72a"
        },
        iconCreateFunction: function (cluster) {
          return that.createNormalIcon(cluster, 'covidHospitals');
        }
      }),
      "sedesa": new L.MarkerClusterGroup({
        polygonOptions: {
          color: "#0cd3b3"
        },
        iconCreateFunction: function (cluster) {
          return that.createNormalIcon(cluster, 'sedesa');
        }
      }),
      "sedesaTemp": new L.MarkerClusterGroup({
        polygonOptions: {
          color: "#0cd3b3"
        },
        iconCreateFunction: function (cluster) {
          return that.createNormalIcon(cluster, 'sedesa');
        }
      })
    }


    this.drag_inside_polygon = false;
    this.infoLayers = [
      /* {
        id: 'pharmacies',
        type: 'Farmacias',
        name: 'Información de Farmacias',
        layer: 'Farmacias',
        label: 'Farmacias',
        logo: 'fas fa-pills',
        active: false,
        src: '',
        display: false,
        disabled: true,
        opacity: false,
        left: 100,
        right: 200
      },
      {
        id: 'publicDoctors',
        type: 'DoctoresPublicos',
        name: 'Información de consultorios públicos',
        layer: 'Doctores publicos',
        label: 'Consultorios públicos',
        logo: 'fas fa-hospital',
        active: false,
        src: '',
        display: false,
        disabled: true,
        opacity: false,
        left: 100,
        right: 200
      },
      {
        id: 'privateDoctors',
        type: 'DoctoresPrivados',
        name: 'Información de consultorios privados',
        layer: 'Doctores privados',
        label: 'Consultorios privados',
        logo: 'fas fa-clinic-medical',
        active: false,
        src: '',
        display: false,
        disabled: true,
        opacity: false,
        left: 100,
        right: 200
      }, */
      {
        id: 'labs',
        type: 'labs',
        name: 'Información de laboratorios',
        layer: 'labs',
        label: 'Laboratorios',
        logo: 'fas fa-microscope',
        active: false,
        src: '',
        display: true,
        disabled: true,
        opacity: false,
        left: 100,
        right: 200,
        visible: false
      },
      {
        id: 'covidHospitals',
        type: 'HospitalesCovid',
        name: 'Información de hospitales COVID',
        layer: 'Hospitales COVID',
        label: 'Hospitales COVID',
        logo: '',
        active: false,
        src: '../../../assets/iconoHospitalB.png',
        display: true,
        disabled: true,
        opacity: false,
        left: 100,
        right: 200,
        visible: false
      },
      {
        id: 'sedesa',
        type: 'sedesa',
        name: 'Información de hospitales SEDESA',
        layer: 'sedesa',
        label: 'Red SEDESA',
        logo: '',
        active: false,
        src: '../../../assets/iconoHospitalB.png',
        display: false,
        disabled: true,
        opacity: false,
        left: 100,
        right: 200,
        visible: false
      },
      {
        id: 'publicHospitals',
        type: 'HospitalesPublicos',
        name: 'Información de hospitales publicos',
        layer: 'Hospitales privados',
        label: 'Consultorios privados',
        logo: 'fas fa-clinic-medical',
        active: false,
        src: '',
        display: false,
        disabled: true,
        opacity: false,
        left: 100,
        right: 200,
        visible: false
      },
      {
        id: 'privateHospitals',
        type: 'HospitalesPrivados',
        name: 'Información de hospitales privados',
        layer: 'Hospitales privados',
        label: 'Consultorios privados',
        logo: 'fas fa-clinic-medical',
        active: false,
        src: '',
        display: false,
        disabled: true,
        opacity: false,
        left: 100,
        right: 200,
        visible: false
      },
      {
        id: 'ventilators',
        type: 'ventilators',
        name: 'Información de ventiladores',
        layer: 'ventilators',
        label: 'ventilators',
        logo: 'fas fa-clinic-medical',
        active: false,
        src: backend_url + '/covid_pins/pin_cprivado.gif',
        display: false,
        disabled: true,
        opacity: false,
        left: 100,
        right: 200,
        visible: false
      },
      {
        id: 'ventilatorsClues',
        type: 'ventilators',
        name: 'Información de ventiladores',
        layer: 'ventilators',
        label: 'ventilators',
        logo: 'fas fa-clinic-medical',
        active: false,
        src: backend_url + '/covid_pins/pin_cprivado.gif',
        display: false,
        disabled: true,
        opacity: false,
        left: 100,
        right: 200,
        visible: false
      },
      {
        id: 'camas',
        type: 'ventilators',
        name: 'Información de ventiladores',
        layer: 'ventilators',
        label: 'ventilators',
        logo: 'fas fa-clinic-medical',
        active: false,
        src: backend_url + '/covid_pins/pin_cprivado.gif',
        display: false,
        disabled: true,
        opacity: false,
        left: 100,
        right: 200,
        visible: false
      },
      {
        id: 'camasUci',
        type: 'ventilators',
        name: 'Información de ventiladores',
        layer: 'ventilators',
        label: 'ventilators',
        logo: 'fas fa-clinic-medical',
        active: false,
        src: backend_url + '/covid_pins/pin_cprivado.gif',
        display: false,
        disabled: true,
        opacity: false,
        left: 100,
        right: 200,
        visible: false
      },
      {
        id: 'carpas',
        type: 'ventilators',
        name: 'Información de ventiladores',
        layer: 'ventilators',
        label: 'ventilators',
        logo: 'fas fa-clinic-medical',
        active: false,
        src: backend_url + '/covid_pins/pin_cprivado.gif',
        display: false,
        disabled: true,
        opacity: false,
        left: 100,
        right: 200,
        visible: false
      },
      {
        id: 'medicos',
        type: 'ventilators',
        name: 'Información de ventiladores',
        layer: 'ventilators',
        label: 'ventilators',
        logo: 'fas fa-clinic-medical',
        active: false,
        src: backend_url + '/covid_pins/pin_cprivado.gif',
        display: false,
        disabled: true,
        opacity: false,
        left: 100,
        right: 200,
        visible: false
      }

    ];
  }

  ngOnInit() {
    this.dtOptions = {
      dom: 'Blfrtip',
      buttons: [
        'excel'
      ],
      pagingType: 'full_numbers',
      pageLength: 4,
      language: {
        url: '//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json'
      }
    };
    this.introJS.setOptions({
      steps: [
        {
          intro: `
          <div>
            <i class="fas fa-info-circle fa-lg"></i>
            <span>Bienvenido al Explorador de Vulnerabilidad COVID-19 en México</span>
          </div>
          `,
          stepNumber: 0
        },
        {
          element: document.querySelector('#step1'),
          intro: `
          <div>
            <i class="fas fa-info-circle fa-lg"></i>
            <span>En esta parte puedes explorar por municipio el grado de vulnerabilidad a COVID-2019, al dar clic en el municipio de lado derecho aparecerán datos relevantes sobre el tema</span>
          </div>
          `,
          stepNumber: 1
        },
        {
          element: document.querySelector('#step1'),
          intro: `
          <div>
            <i class="fas fa-info-circle fa-lg"></i>
            <span>En esta sección puedes ver la información en tiempo real de Twitter de la secretaría de salud y otros medios oficiales</span>
          </div>
          `,
          stepNumber: 2
        },
        {
          element: document.querySelector('#step1'),
          intro: `
          <div>
            <i class="fas fa-info-circle fa-lg"></i>
            <span>Aquí puedes activar y desactivar en el mapa, las capas disponibles relacionadas con la vulnerabilidad a COVID-19</span>
          </div>
          `,
          stepNumber: 3
        },
        {
          element: document.querySelector('#step2'),
          intro: `
          <div>
            <i class="fas fa-info-circle fa-lg"></i>
            <span>Información actualizada diariamente sobre la evolución espacio temporal del virus</span>
          </div>
          `,
          stepNumber: 4
        },
        {
          element: document.querySelector('#step2'),
          intro: `
          <div>
            <i class="fas fa-info-circle fa-lg"></i>
            <span>En esta sección podrás explorar variables socioeconómicas y demográficas a nivel municipal</span>
          </div>
          `,
          stepNumber: 5
        },
        {
          element: document.querySelector('#step2'),
          intro: `
          <div>
            <i class="fas fa-info-circle fa-lg"></i>
            <span>Aquí encontrarás los factores de riesgo que son relevantes para incrementar la vulnerabilidad al virus</span>
          </div>
          `,
          stepNumber: 6
        },
        {
          element: document.querySelector('#step3'),
          intro: `
          <div>
            <i class="fas fa-info-circle fa-lg"></i>
            <span>Aquí podrás identificar dónde y cuantos hospitales y laboratorios COVID hay por municipio</span>
          </div>
          `,
          stepNumber: 7
        },
        {
          element: document.querySelector('#step4'),
          intro: `
          <div>
            <i class="fas fa-info-circle fa-lg"></i>
            <span>Aquí puedes activar y desactivar en el mapa, la vista por regiones urbanas</span>
          </div>
          `,
          stepNumber: 8
        },
        {
          element: document.querySelector('#step5'),
          intro: `
          <div>
            <i class="fas fa-info-circle fa-lg"></i>
            <span>Aquí puedes cambiar el estilo del mapa base</span>
          </div>
          `,
          stepNumber: 9
        },
        {
          element: document.querySelector('#step6'),
          intro: `
          <div>
            <i class="fas fa-info-circle fa-lg"></i>
            <span>Aquí puedes activar y desactivar en el mapa, la visualización de casos COVID por estado</span>
          </div>
          `,
          stepNumber: 10
        },
        {
          element: document.querySelector('#step7'),
          intro: `
          <div>
            <i class="fas fa-info-circle fa-lg"></i>
            <span>Aquí puedes volver a centrar el mapa en la pantalla</span>
          </div>
          `,
          stepNumber: 11
        },
        {
          element: document.querySelector('#step8'),
          intro: `
          <div>
            <i class="fas fa-info-circle fa-lg"></i>
            <span>Aquí puedes volver al inicio del mapa</span>
          </div>
          `,
          stepNumber: 12
        },
        {
          element: document.querySelector('#step9'),
          intro: `
          <div>
            <i class="fas fa-info-circle fa-lg"></i>
            <span>Aquí puedes volver a iniciar esta introducción</span>
          </div>
          `,
          stepNumber: 13
        }
      ],
      nextLabel: `Siguiente&nbsp;<i class="fas fa-arrow-right fa-xs"></i>`,
      prevLabel: '<i class="fas fa-arrow-left fa-xs"></i>&nbsp;Anterior',
      skipLabel: 'Saltar',
      doneLabel: 'Salir',
      showStepNumbers: false,
      exitOnOverlayClick: false,
      showProgress: true,
      disableInteraction: true
    });

    this.introJS.onbeforechange((target) => {
      let step = this.introJS._options.steps[this.introJS._currentStep].stepNumber;
      switch (step) {
        case 1:
          this.changeTab('pop');
          break;
        case 2:
          this.changeTab('twitter');
          break;
        case 3:
          this.changeTab('wms');
          break;
        case 4:
          this.changeTab('covid');
          break;
        case 5:
          this.changeTab('infra');
          break;
        case 6:
          this.changeTab('vul');
          break;
        case 7:
          this.infoLayers[0].visible = true;
          this.infoLayers[1].visible = true;
          break;
      }
    });

    this.introJS.onbeforeexit(() => {
      this.changeTab('pop');
      this.changeTab('covid');
      this.infoLayers[0].display = false;
      this.infoLayers[1].display = false;
      this.infoLayers[0].visible = true;
      this.infoLayers[1].visible = true;

      let actionContainer = document.querySelector('.action-container');
      actionContainer.classList.remove('tutorial');
    });

    $(() => {
      $('[data-toggle="tooltip"]').tooltip();
    });

    this.spinner.show();

    if (window.location.href.includes("cdmx")) {
      this.cdmx_mode = true;
      this.infoLayers[0].visible = true;
      this.infoLayers[1].visible = true;
      //this.infoLayers[2].visible = true;
    }

    if (window.location.href.includes("yuc")) {
      this.yuc_mode = true;
      this.infoLayers[0].visible = true;
      this.infoLayers[1].visible = true;
    }

    if (window.location.href.includes("public")) {
      this.public_mode = true;
    }

    this.initMap();
  }

  initMap() {
    let minZoomMap = 5;
    this.map = L.map('mapid', {
      center: [21.95774, -101.62595],
      zoom: 5,
      zoomControl: false
    });

    if (this.cdmx_mode) {
      minZoomMap = 9;

    }
    if (this.yuc_mode) {
      minZoomMap = 10;
    }

    const northEast = L.latLng(20.065747255438655, -98.59686665562256);
    const southWest = L.latLng(18.93533987380264, -99.64988958349386);
    const bounds = L.latLngBounds(southWest, northEast);

    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}.png',
      {
        minZoom: minZoomMap,
        attribution: '&copy; <a href="https://carto.com/">Carto</a> ' +
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(this.map);

    this.addControlMap();
    this.initControlMap(this.map);
    this.initControlMapWms(this.map);
    this.initControlMapWmsStates(this.map);
    this.initControlMapWmsMunicipality(this.map);


    if (this.cdmx_mode == false && this.yuc_mode == false) {
      //      this.loadInfoCOVID('NACIONAL', COVID_casos_positivos);
      this.loadGeoJsonCountry();
    } else {
      this.toggleMapMode();
    }


    if (this.cdmx_mode) { //carga el raster de accesibilidad de servicios de salud
      const escalaColors = scaleLinear()
        .domain([0, 50])
        //.domain([0, ])
        .range([0, 1]);

      //plotty.addColorScale("mycolorscale", ["#d7191c", '#fdae61' , "#ffffbf","#abdda4", "#2b83ba"], [escalaColors(2.53391), escalaColors(14.220318), escalaColors(25.939545), escalaColors(37.658772), escalaColors(49.3884)]);

      plotty.addColorScale("mycolorscale",
        ["#d7191c", '#ec6e43', "#fdb96e", "#fee7a4", "#e7f5b7", "#b7e1a7", "#74b6ad", "#2b83ba"],
        [escalaColors(2.533910), escalaColors(9.227409), escalaColors(15.920907), escalaColors(22.614406), escalaColors(29.307904), escalaColors(36.001403), escalaColors(42.694901), escalaColors(49.388400)]
      );

      this.accesibility_layer = new L.LeafletGeotiff(
        './assets/hosp_todos_zmvm.tif',
        {
          band: 0,
          name: 'raster_access_salud',
          opacity: 1,
          renderer: new L.LeafletGeotiff.Plotty({
            colorScale: 'mycolorscale',
            clampLow: false,
            clampHigh: false,
            displayMin: 0,
            displayMax: 50,
          })
        }
      );
      //).addTo(this.map);


      /* 		const color = this.accesibility_layer.options.renderer.getColorScale();
          const legend = L.control({position: 'bottomright'});
          legend.onAdd = function (map) {
            const div = L.DomUtil.create('div', 'info legend');
            div.innerHTML += '<h5>'+this.accesibility_layer.options.name+'</h5>';
          	
            // loop through our density intervals and generate a label with a colored square for each interval
            for (let i = 0; i < color.colors.length; i+=1) {
              div.innerHTML += '<i style="background:' + color.colors[i] + '"></i>';
              if(i === 0 ){div.innerHTML += this.accesibility_layer.options.renderer.options.displayMin;}
              if(i === color.colors.length-1){ div.innerHTML += this.accesibility_layer.options.renderer.options.displayMax; }
              div.innerHTML += ' <br>';
            }
      
            return div;
          };
          legend.onRemove = function (map){
            let div = L.DomUtil.remove('info legend');
          	
            return ;
          };
          legend.addTo(this.map); */


    }





  }

  addControlMap() {
    this.info = L.control();
    this.info.onAdd = function (map) {
      this._div = L.DomUtil.create('div', 'info'); // create a div with a class "info"
      this.update_states();
      return this._div;
    };

    this.info.update_states_covid = function (state = "", cases = 0) {
      if (state != "") {
        L.DomUtil.addClass(this._div, 'info')
        this._div.innerHTML = `<span class="place">Estado: ${state}</span>
                               <span class="cases">Casos Positivos: ${cases}</span>
                               <span class="action">Haz clic para más información</span>`
      }
      else {
        L.DomUtil.removeClass(this._div, 'info')
        this._div.innerHTML = ``
      }

    };

    this.info.update_states = function (state = "") {
      if (state != "") {
        L.DomUtil.addClass(this._div, 'info')
        this._div.innerHTML = `<span class="place">Estado: ${state}</span>
                               <span class="action">Haz clic para más información</span>`
      }
      else {
        L.DomUtil.removeClass(this._div, 'info')
        this._div.innerHTML = ``
      }

    };

    this.info.update_categories = function (category = "") {
      if (category != "") {
        L.DomUtil.addClass(this._div, 'info')
        this._div.innerHTML = `<span class="place">Región urbana: ${category}</span>
                               <span class="action">Haz clic para más información</span>`
      }
      else {
        L.DomUtil.removeClass(this._div, 'info')
        this._div.innerHTML = ``
      }

    };

    this.info.update_metropolitan = function (state = "") {
      if (state != "") {
        L.DomUtil.addClass(this._div, 'info')
        this._div.innerHTML = `<span class="place">Zona metropolitana: ${state}</span>
                               <span class="action">Haz clic para más información</span>`
      }
      else {
        L.DomUtil.removeClass(this._div, 'info')
        this._div.innerHTML = ``
      }

    };

    this.info.update_municipalities_covid = function (municipality = "", cases = 0) {
      if (municipality != "") {
        L.DomUtil.addClass(this._div, 'info')
        this._div.innerHTML = `<span class="place">Municipio: ${municipality}</span>
                               <span class="cases">Casos Positivos: ${cases}</span>
                               <span class="action">Haz clic para más información</span>`
      } else {
        L.DomUtil.removeClass(this._div, 'info')
        this._div.innerHTML = ``
      }
    };

    this.info.update_municipalities = function (municipality = "") {
      if (municipality != "") {
        L.DomUtil.addClass(this._div, 'info')
        this._div.innerHTML = `<span class="place">Municipio: ${municipality}</span>
                               <span class="action">Haz clic para más información</span>`
      } else {
        L.DomUtil.removeClass(this._div, 'info')
        this._div.innerHTML = ``
      }
    };

    this.info.update_localities = function (locality = "") {
      if (locality != "") {
        L.DomUtil.addClass(this._div, 'info')
        this._div.innerHTML = `<span class="place">Localidad: ${locality}</span>
                               <span class="action>Haz clic para más información</span>`
      } else {
        L.DomUtil.removeClass(this._div, 'info')
        this._div.innerHTML = ``
      }
    };

    this.info.update_ageb = function (ageb = "") {
      if (ageb != "") {
        L.DomUtil.addClass(this._div, 'info')
        this._div.innerHTML = `<span class="place">ageb: ${ageb}</span>
                               <span class="action>Haz clic para más información</span>`
      } else {
        L.DomUtil.removeClass(this._div, 'info')
        this._div.innerHTML = ``
      }
    };

    this.info.update_exponential = function (municipality = "", index_gen = "") {
      if (municipality != "") {
        L.DomUtil.addClass(this._div, 'info')
        this._div.innerHTML = `<span class="place">Municipio: ${municipality}</span>
                               <span class="cases">Factor de Riesgo: ${index_gen}</span>
                               <span class="action">Haz clic para más información</span>`
      } else {
        L.DomUtil.removeClass(this._div, 'info')
        this._div.innerHTML = ``
      }
    };

    this.info.setPosition("topleft");
    this.info.addTo(this.map);
  }

  createNormalIcon = function (cluster, type) {
    var markers = cluster.getAllChildMarkers();
    var n = markers.length;
    var className;
    var size;
    if (n < 100) {
      className = 'clustersmall' + type;
      size = 30;
    } else if (n < 200) {
      className = 'clustermedium' + type;
      size = 45;
    } else {
      className = 'clusterbig' + type;
      size = 60;
    }
    var clusterhtml = '<div align="center" style="white-space: nowrap;"> \
							<center>\
							  <canvas align="center" width="'+ size + '" height="' + size + '" style="opacity:0.9;"></canvas> \
							</center> \
							<div class="clusterTextPosition"> \
							  <span class="clusterText">'+ new Intl.NumberFormat('en-US').format(markers.length) + ' </span> \
							</div> \
						  </div>'

    var myIcon = new L.DivIcon({
      html: clusterhtml,
      className: className,
      iconSize: new L.Point(size, size)
    });

    return myIcon;
  }

  loadInfoCOVID(nombre_estado, COVID_casos) {
    this.covidData = {}
    this.covidCasesByState = {}
    this.covidCasesByOrigin = {}

    if (nombre_estado === 'NACIONAL') {
      this.COVID_casos_por_estado = {};
      this.COVID_casos_por_fecha = {};
      this.covidTotal = COVID_casos.length;
    }

    let contador_casos_por_procedencia = {}
    let cont_hombres = 0
    let cont_mujeres = 0
    let edad_minima = -1
    let edad_maxima = 0

    let edad_0_10 = 0
    let m_10 = 0
    let h_10 = 0

    let edad_11_20 = 0
    let m_20 = 0
    let h_20 = 0

    let edad_21_30 = 0
    let m_30 = 0
    let h_30 = 0

    let edad_31_40 = 0
    let m_40 = 0
    let h_40 = 0

    let edad_41_50 = 0
    let m_50 = 0
    let h_50 = 0

    let edad_51_60 = 0
    let m_60 = 0
    let h_60 = 0

    let edad_61_70 = 0
    let m_70 = 0
    let h_70 = 0

    let edad_71_80 = 0
    let m_80 = 0
    let h_80 = 0

    let edad_81_90 = 0
    let m_90 = 0
    let h_90 = 0

    let edad_91_mas = 0
    let m_91 = 0
    let h_91 = 0
    let arrayAge = [];


    if (COVID_casos.length == 0) { //no hay casos confirmados
      this.covidData['totalCases'] = {
        title: 'Casos confirmados totales',
        total: COVID_casos.length,
        logo: 'icono-corona'
      }
      return;
    }

    COVID_casos.forEach(casoPositivo => {
      //cuanta los casos de hombres y mujeres
      if (casoPositivo['Sexo'] == 'FEMENINO' || casoPositivo['Sexo'] == 'F')  //Femenino
        cont_mujeres++
      else
        cont_hombres++

      //actualiza edades máxima y mínima de contagio
      if (edad_minima < 0) {
        edad_minima = casoPositivo['Edad']
      }
      else {
        if (casoPositivo['Edad'] < edad_minima) {
          edad_minima = casoPositivo['Edad']
        }
      }

      if (edad_maxima == 0) {
        edad_maxima = casoPositivo['Edad']
      }
      else {
        if (casoPositivo['Edad'] > edad_maxima) {
          edad_maxima = casoPositivo['Edad']
        }
      }

      //cuenta casos por rango de edades
      if (casoPositivo['Edad'] <= 10) {
        edad_0_10++
        if (casoPositivo['Sexo'] == 'FEMENINO' || casoPositivo['Sexo'] == 'F') {  //Femenino
          m_10++
        }
        else {
          h_10++
        }

      } else if (casoPositivo['Edad'] <= 20) {
        edad_11_20++
        if (casoPositivo['Sexo'] == 'FEMENINO' || casoPositivo['Sexo'] == 'F') {  //Femenino
          m_20++
        }
        else {
          h_20++
        }
      } else if (casoPositivo['Edad'] <= 30) {
        edad_21_30++
        if (casoPositivo['Sexo'] == 'FEMENINO' || casoPositivo['Sexo'] == 'F') {  //Femenino
          m_30++
        }
        else {
          h_30++
        }
      } else if (casoPositivo['Edad'] <= 40) {
        edad_31_40++
        if (casoPositivo['Sexo'] == 'FEMENINO' || casoPositivo['Sexo'] == 'F') {  //Femenino
          m_40++
        }
        else {
          h_40++
        }

      } else if (casoPositivo['Edad'] <= 50) {
        edad_41_50++
        if (casoPositivo['Sexo'] == 'FEMENINO' || casoPositivo['Sexo'] == 'F') {  //Femenino
          m_50++
        }
        else {
          h_50++
        }
      } else if (casoPositivo['Edad'] <= 60) {
        edad_51_60++
        if (casoPositivo['Sexo'] == 'FEMENINO' || casoPositivo['Sexo'] == 'F') {  //Femenino
          m_60++
        }
        else {
          h_60++
        }
      } else if (casoPositivo['Edad'] <= 70) {
        edad_61_70++
        if (casoPositivo['Sexo'] == 'FEMENINO' || casoPositivo['Sexo'] == 'F') {  //Femenino
          m_70++
        }
        else {
          h_70++
        }

      } else if (casoPositivo['Edad'] <= 80) {
        edad_71_80++
        if (casoPositivo['Sexo'] == 'FEMENINO' || casoPositivo['Sexo'] == 'F') {  //Femenino
          m_80++
        }
        else {
          h_80++
        }

      } else if (casoPositivo['Edad'] <= 90) {
        edad_81_90++
        if (casoPositivo['Sexo'] == 'FEMENINO' || casoPositivo['Sexo'] == 'F') {  //Femenino
          m_90++
        }
        else {
          h_90++
        }
      } else {
        edad_91_mas++
        if (casoPositivo['Sexo'] == 'FEMENINO' || casoPositivo['Sexo'] == 'F') {  //Femenino
          m_91++
        }
        else {
          h_91++
        }
      }


      if (nombre_estado === 'NACIONAL') {
        //crea un objeto de casos por estado
        if (this.COVID_casos_por_estado[casoPositivo['Estado']] == null) {
          this.COVID_casos_por_estado[casoPositivo['Estado']] = []
          this.COVID_casos_por_estado[casoPositivo['Estado']].push(casoPositivo)
        }
        else {
          this.COVID_casos_por_estado[casoPositivo['Estado']].push(casoPositivo)
        }
      }

      //crea un objeto de casos por fecha
      if (this.COVID_casos_por_fecha[casoPositivo['Fecha_sintomas']] == null) {
        this.COVID_casos_por_fecha[casoPositivo['Fecha_sintomas']] = []
        this.COVID_casos_por_fecha[casoPositivo['Fecha_sintomas']].push(casoPositivo)
      }
      else {
        this.COVID_casos_por_fecha[casoPositivo['Fecha_sintomas']].push(casoPositivo)
      }

      //crea un objeto de casos por procedencia
      if (contador_casos_por_procedencia[casoPositivo['Procedencia']] == null) {
        contador_casos_por_procedencia[casoPositivo['Procedencia']] = 1
      }
      else {
        contador_casos_por_procedencia[casoPositivo['Procedencia']]++
      }
    });

    this.covidData['totalCases'] = {
      title: 'Casos confirmados',
      total: COVID_casos.length,
      logo: 'icon-corona'
    }

    this.covidData['totalGender'] = {
      title: 'Confirmados por sexo',
      totalMen: cont_hombres,
      totalWomen: cont_mujeres,
      menPct: cont_hombres * 100 / COVID_casos.length,
      womenPct: cont_mujeres * 100 / COVID_casos.length,
      logoMen: 'icon-male',
      logoWomen: 'icon-female',
      logo: 'fas fa-venus-mars'
    };
    /* this.covidData['totalMen'] = {
      title: 'Hombres confirmados',
      total: cont_hombres,
      logo: 'icon-male'
    }

    this.covidData['totalWomen'] = {
      title: 'Mujeres confirmadas',
      total: cont_mujeres,
      logo: 'icon-female'
    } */


    /*     this.covidData['minAge'] = {
          title: 'Edad mínima',
          total: edad_minima,
          logo: 'icon-baby'
        }
    
        this.covidData['maxAge'] = {
          title: 'Edad máxima',
          total: edad_maxima,
          logo: 'icon-male'
        } */

    this.covidData['minmaxAges'] = {
      title: 'Edades mínima y máxima',
      edadMinima: edad_minima,
      edadMaxima: edad_maxima,
      logoEdadMinima: 'icon-baby',
      logoEdadMaxima: 'icon-old',
      logo: 'fas fa-users'
    };

    /*     this.covidData['under18'] = {
          title: 'Entre 0 y 18 años',
          total: edad_0_18,
          logo: 'icon-young'
        }
    
        this.covidData['under30'] = {
          title: 'Entre 19 y 30 años',
          total: edad_19_30,
          logo: 'icon-mature'
        }
    
        this.covidData['under60'] = {
          title: 'Entre 31 y 60 años',
          total: edad_30_60,
          logo: 'icon-granny'
        }
    
        this.covidData['60plus'] = {
          title: 'Más de 60 años',
          total: edad_60_mas,
          logo: 'icon-old'
        } */

    if (nombre_estado === 'NACIONAL') {
      for (let [key, value] of Object.entries(this.COVID_casos_por_estado)) {
        let count = Object.keys(value).length
        this.covidCasesByState[key] = {
          title: key,
          total: count
        }
      }
    }

    for (let [key, value] of Object.entries(contador_casos_por_procedencia)) {
      this.covidCasesByOrigin[key] = {
        title: key,
        total: value
      }
    }

    arrayAge.push(
      {
        category: "0 a 10",
        value1: h_10,
        value2: m_10,
        total: h_10 + m_10
      },
      {
        category: "11 a 20",
        value1: h_20,
        value2: m_20,
        total: h_20 + m_20
      },
      {
        category: "21 a 30",
        value1: h_30,
        value2: m_30,
        total: h_30 + m_30
      },
      {
        category: "31 a 40",
        value1: h_40,
        value2: m_40,
        total: h_40 + m_40
      },
      {
        category: "41 a 50",
        value1: h_50,
        value2: m_50,
        total: h_50 + m_50
      },
      {
        category: "51 a 60",
        value1: h_60,
        value2: m_60,
        total: h_60 + m_60
      },
      {
        category: "61 a 70",
        value1: h_70,
        value2: m_70,
        total: h_70 + m_70
      },
      {
        category: "71 a 80",
        value1: h_80,
        value2: m_80,
        total: h_80 + m_80
      },
      {
        category: "81 a 90",
        value1: h_90,
        value2: m_90,
        total: h_90 + m_90
      },
      {
        category: "91 o más",
        value1: h_91,
        value2: m_91,
        total: h_91 + m_91
      }
    )

    this.initCovidAgesChart(arrayAge, COVID_casos.length)
  } //fin loadInfoCOVIDNacional()

  loadHospitalsCDMXDisp() {
    //console.log(hospitals_cdmx_disp)
    let array_hospitals_cdmx = []

    hospitals_cdmx_disp.forEach(hospital_cdmx => {
      let newHospitalCdmx = {
        "type": "Feature",
        "properties": {
          name: {
            title: 'Nombre',
            value: hospital_cdmx['title']
          },
          institution: {
            title: 'Institución',
            value: hospital_cdmx["institucion"]
          },
          disponibilidad: {
            title: 'Disponibilidad',
            value: hospital_cdmx["disponibilidad"]
          },
          icon: {
            title: 'Icono',
            value: hospital_cdmx["icon"]
          }
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            hospital_cdmx['position'].lon,
            hospital_cdmx['position'].lat
          ]
        },
      }
      array_hospitals_cdmx.push(newHospitalCdmx);
    });

    //console.log(array_hospitals_cdmx)
    //this.clearLayer('HospitalsCDMX');


    this.covidGeoJson['hospitalsCDMX'] = L.geoJSON(array_hospitals_cdmx, {
      pointToLayer: function (feature, latlng) {

        let icon;
        if (feature.properties['disponibilidad'].value == 'Disponibilidad alta')
          icon = backend_url + '/covid_pins/pin_disponible.png'
        if (feature.properties['disponibilidad'].value == 'Disponibilidad media')
          icon = backend_url + '/covid_pins/pin_disponible_media.png'
        if (feature.properties['disponibilidad'].value == 'Sin disponibilidad')
          icon = backend_url + '/covid_pins/pin_disponible_no.png'

        var iconoHospitalCDMX = new L.Icon({
          //iconUrl: feature.properties['icon'].value,
          //iconUrl: backend_url + '/covid_pins/' + feature.properties['icon'].value,
          iconUrl: icon,
          iconSize: [35, 45],
          //iconAnchor: [41, 41],
          popupAnchor: [0, -20],
          //shadowSize: [41, 41],
          //prefix: 'icon',
        });

        let logo;
        if (feature.properties['institution'].value == 'IMSS')
          logo = backend_url + '/logos/IMSS.png'
        if (feature.properties['institution'].value == 'ISSSTE')
          logo = backend_url + '/logos/ISSSTE.png'
        if (feature.properties['institution'].value == 'SEDESA')
          logo = backend_url + '/logos/SEDESA.png'
        if (feature.properties['institution'].value == 'EDOMEX')
          logo = backend_url + '/logos/EDOMEX.png'
        if (feature.properties['institution'].value == 'SSA')
          logo = backend_url + '/logos/SSA.png'


        let popupContent = '<div class="popup-wrapper">';

        popupContent += '<div style="text-align:center">  <img src="' + logo + '" height="100">  </div>';
        popupContent += '<br>';

        for (let propertie in feature.properties) {
          if (feature.properties[propertie].value !== null && feature.properties[propertie].title !== 'Icono') {
            popupContent += '<div class="popup-content">';
            popupContent += '<div class="popup-title">';
            popupContent += feature.properties[propertie].title + ':&nbsp;';
            popupContent += '</div>';
            popupContent += '<div class="popup-value">';
            popupContent += feature.properties[propertie].value;
            popupContent += '</div>';
            popupContent += '</div>';
          }
        }

        popupContent += '</div>';
        //console.log(latlng)
        return L.marker(latlng, {
          icon: iconoHospitalCDMX
        }).bindPopup(popupContent, { className: 'covid-popup' });
      }

    }).addTo(this.markerClusters['hospitalsCDMX']);
    //console.log(markerclusterHospitalsCDMX)

    //this.map.addLayer(this.markerClusters['hospitalsCDMX'])
    this.markerClusters['hospitalsCDMX'].disableClustering();








  }



  loadGeoJsonUrbanAreas() {
    let that = this;
    let state_style = {
      "color": "#6C3721",
      "fillColor": "#e36930",
      "opacity": 0.25,
      "weight": 1
    };

    let polygon_array = []
    silhueta_de_ciudades["features"].forEach(element => {
      if (that.cdmx_mode == true) {
        if (element['properties']['nom_ciudad'] == "Valle de México") {
          let newPolygon = {
            "type": "Feature",
            "properties": {
              "entidad_cvegeo": element['properties']['cve_sun'],
              "entidad_nombre": element['properties']['nom_ciudad'],
              "nom_reg": element['properties']['nom_reg'],
              "region_urbana_cve": element['properties']['region_urbana_cve']
            },
            "geometry": element.geometry
          }
          polygon_array.push(newPolygon);
        }
      } else if (that.yuc_mode == true) {
        if (element['properties']['nom_ciudad'] == "Mérida") {
          let newPolygon = {
            "type": "Feature",
            "properties": {
              "entidad_cvegeo": element['properties']['cve_sun'],
              "entidad_nombre": element['properties']['nom_ciudad'],
              "nom_reg": element['properties']['nom_reg'],
              "region_urbana_cve": element['properties']['region_urbana_cve']
            },
            "geometry": element.geometry
          }
          polygon_array.push(newPolygon);
        }
      } else {
        let newPolygon = {
          "type": "Feature",
          "properties": {
            "entidad_cvegeo": element['properties']['cve_sun'],
            "entidad_nombre": element['properties']['nom_ciudad'],
            "nom_reg": element['properties']['nom_reg'],
            "region_urbana_cve": element['properties']['region_urbana_cve']
          },
          "geometry": element.geometry
        }
        polygon_array.push(newPolygon);
      }
    });

    this.polygons["select_urban_areas"] = L.geoJSON(polygon_array, {
      style: state_style,
      onEachFeature: function (feature, layer) {
        layer.on('mouseover', (e) => {
          layer.setStyle({
            "color": "#6C3721",
            "fillColor": "#e36930",
            "opacity": 0.75,
            "weight": 1
          });
          let state = feature.properties.entidad_nombre
          that.info.update_metropolitan(state);
        });

        layer.on('mouseout', (e) => {
          layer.setStyle({
            "color": "#6C3721",
            "fillColor": "#e36930",
            "opacity": 0.25,
            "weight": 1
          });
          let state = feature.properties.entidad_nombre
          that.info.update_metropolitan();
        });

        layer.on('click', (e) => {
          that.spinner.show();
          that.map.flyToBounds(layer.getBounds(), { paddingBottomRight: [0, 0] })
          that.map.once('moveend', function (e) {
            that.loadGeoJsonMetropolitan(feature, layer, that)
          });
        });

        if (feature.properties.entidad_nombre == "Valle de México" && that.cdmx_mode == true) {
          that.spinner.show();
          that.cdmx_mode_bounds = layer.getBounds()
          that.map.flyToBounds(layer.getBounds(), { paddingBottomRight: [0, 0] })
          that.map.once('moveend', function (e) {
            that.map.setMaxBounds(layer.getBounds());
            that.loadGeoJsonMetropolitan(feature, layer, that)
            that.loadHospitalsCDMXDisp();
          });
        }

        if (feature.properties.entidad_nombre == "Mérida" && that.yuc_mode == true) {
          that.spinner.show();
          that.yuc_mode_bounds = layer.getBounds()
          that.map.flyToBounds(layer.getBounds(), { paddingBottomRight: [0, 0] })
          that.map.once('moveend', function (e) {
            that.map.setMaxBounds(layer.getBounds());
            that.loadGeoJsonMetropolitan(feature, layer, that)
          });
        }
      }
    }).addTo(this.map);
  };

  loadGeoJsonCategory() {
    let that = this;
    let state_style = {
      "color": "#6C3721",
      "fillColor": "#e36930",
      "opacity": 0.25,
      "weight": 1
    };
	
/* 	this.polygonService.getAllUrbanAreasExposition().subscribe(datas => {	
		console.log(datas)
	}); */
	

    this.polygonService.getCountryRegion().subscribe(data => {
		
//		console.log(data)
      this.updateInfra(data);
      this.updatePoblation(data);
      this.updateVunerability(data);
      //this.updateProjection2020(data);
      this.updatePoverty(data);
      //this.updateMortality(data);
      this.showlegendInfo["projection2020"] = false;
      this.showlegendInfo["poverty"] = false;
      this.showlegendInfo["mortality"] = false;
      this.showlegendInfo["covid"] = false;
      this.showlegendInfo["mortalityLocation"] = false;
      this.showlegendInfo["generalData"] = false;

      let polygon_array = []
      regiones_union["features"].forEach(element => {
        let newPolygon = {
          "type": "Feature",
          "properties": {
            "region_urbana_cve": element['properties']['region_urbana_cve'],
            "region_name_cve": element['properties']['region_name_cve'],
          },
          "geometry": element.geometry
        }
        polygon_array.push(newPolygon);
      });

      this.polygons["select_categories"] = L.geoJSON(polygon_array, {
        style: state_style,
        onEachFeature: function (feature, layer) {
          let colors = that.getColorByCategory(feature.properties.region_urbana_cve);
          layer.setStyle({
            "color": colors.color,
            'fillColor': colors.fillColor,
            "opacity": 0.5,
            "fillOpacity": 0.7,
            "weight": 1
          });

          layer.on('mouseover', (e) => {
            if (that.select_urban_areas == undefined || that.select_urban_areas.properties.region_urbana_cve != feature.properties.region_urbana_cve) {
              if (!that.showLayerWms && !that.showLegendAreaExposition) {
                if(this.nivelPolygons=="UrbanAreas"){
                  layer.setStyle({
                    "color": "#6C3721",
                    "fillColor": colors.fillColor,
                    "opacity": 1,
                    "fillOpacity": 0.7,
                    "weight": 2
                  });
                }else{
                  layer.setStyle({
                    "weight": 2
                  });
                }
              } else {
                layer.setStyle({
                  "weight": 2
                });
              }
              let state = feature.properties.region_name_cve
              that.info.update_categories(state);
            }
          });

          layer.on('mouseout', (e) => {
            if (that.select_urban_areas == undefined || that.select_urban_areas.properties.region_urbana_cve != feature.properties.region_urbana_cve) {
              if (!that.showLayerWms && !that.showLegendAreaExposition) {
                if(this.nivelPolygons=="UrbanAreas"){
                  layer.setStyle({
                    "color": colors.color,
                    "fillColor": colors.fillColor,
                    "opacity": 0.5,
                    "fillOpacity": 0.7,
                    "weight": 1
                  });
                }else{
                  layer.setStyle({
                    "weight": 1
                  });  
                }
              } else {
                layer.setStyle({
                  "weight": 1
                });
              }
              that.info.update_categories();
            }
          });


          layer.on('click', (e) => {
            if (that.select_urban_areas == undefined || that.select_urban_areas.properties.region_urbana_cve != feature.properties.region_urbana_cve) {
              that.select_locality = undefined;
              that.select_municipality = undefined;
              that.select_ageb = undefined;
              that.spinner.show();
              that.map.flyToBounds(layer.getBounds(), { padding: [200, 200], maxZoom: 8 })
              that.map.once('moveend', function (e) {
                that.loadGeoJsonUrbanAreasCategory(feature, layer, that)
              });
            }
          });
        },
      }).addTo(this.map);
    });
  };

  getColorByCategory(category) {
    let color;
    switch (category) {
      case 1:
        color = { color: '#aaaeb1', fillColor: '#aaaeb1' }
        break;
      case 2:
        color = { color: '#585C5F', fillColor: '#585C5F' }
        break;
      case 3:
        color = { color: '#433c7f', fillColor: '#433c7f' }
        break;
      case 4:
        color = { color: '#aab7c0', fillColor: '#aab7c0' }
        break;
      case 5:
        color = { color: '#1b1464', fillColor: '#1b1464' }
        break;
      case 6:
        color = { color: '#6d9ab7', fillColor: '#6d9ab7' }
        break;
      case 7:
        color = { color: '#3C5667', fillColor: '#3C5667' }
        break;
      case 8:
        color = { color: '#5591da', fillColor: '#5591da' }
        break;
      case 9:
        color = { color: '#302972', fillColor: '#302972' }
        break;
    }
    return color;
  }

  loadGeoJsonUrbanAreasCategory(feature, layer, that) {
    let state_style = {};
    if (!that.showLayerWms) {
      state_style = {
        "color": "#6C3721",
        "fillColor": "#e36930",
        "opacity": 0.25,
        "weight": 1
      };
    } else {
      state_style = {
        "color": '#000000',
        "opacity": 0.5,
        "fillOpacity": 0.1,
        "weight": 1
      };
    }

    that.nivelPolygons = "ZonaUrbanArea";
    that.select_urban_areas = feature;
    that.layer["select_urban_areas"] = layer;

    that.clearPolygons('select_urban_areas');
    that.clearPolygons('select_metropolitan');
    that.clearPolygons('select_municipality');
    that.clearPolygons('select_locality');
    that.clearPolygons('select_ageb');
    that.clearAllMarkers();
    that.resetbutton()

    const entidad_cvegeo = feature.properties.region_urbana_cve;
	//console.log(feature.properties)
	that.dataEntityName = "Región "+feature.properties.region_name_cve;

    that.polygonService.getOneUrbanAreasExposition(entidad_cvegeo).subscribe(datas => {
      that.polygonService.getOneUrbanAreas(entidad_cvegeo).subscribe(data => {
		  
		//console.log(data)  
        that.spinner.hide();

        that.updateInfra(data);
		that.updateCovid(data)
        that.updatePoblation(data);
        that.updateVunerability(data);
        that.updateProjection2020(data);
        that.updatePoverty(data);
        that.updateMortality(data);
        //that.showButton();

        that.showlegendInfo["projection2020"] = false;
        that.showlegendInfo["poverty"] = false;
        that.showlegendInfo["mortality"] = false;
        that.showlegendInfo["covid"] = false;
        that.showlegendInfo["mortalityLocation"] = false;
        that.showlegendInfo["generalData"] = false;

        let polygon_array = []
        silhueta_de_ciudades["features"].forEach(element => {
          if (element['properties']['region_urbana_cve'] == feature["properties"]["region_urbana_cve"]) {
            let newPolygon = {
              "type": "Feature",
              "properties": {
                "entidad_cvegeo": element['properties']['cve_sun'],
                "entidad_nombre": element['properties']['nom_ciudad'],
                "nom_reg": element['properties']['nom_reg'],
                "region_urbana_cve": element['properties']['region_urbana_cve']
              },
              "geometry": element.geometry
            }
            polygon_array.push(newPolygon);
          }
        });

        that.clearPolygons('select_state');
        that.clearPolygons('select_urban_areas');
        that.clearPolygons('select_metropolitan');
        that.clearAllMarkers();

        this.polygons["select_urban_areas"] = L.geoJSON(polygon_array, {
          style: state_style,
          onEachFeature: function (feature, layer) {
            layer.on('mouseover', (e) => {
              if (that.select_metropolitan == undefined || that.select_metropolitan.properties.entidad_cvegeo != feature.properties.entidad_cvegeo) {
                //if (!that.showLayerWms && !that.showLegendAreaExposition) {
                // if (!that.showLayerWms) {
                //   layer.setStyle({
                //     "color": "#6C3721",
                //     "fillColor": "#e36930",
                //     "opacity": 0.75,
                //     "weight": 2
                //   });
                // } else {
                //}
                
                layer.setStyle({
                  "weight": 2
                });
              }
              let state = feature.properties.entidad_nombre
              that.info.update_metropolitan(state);
            });

            layer.on('mouseout', (e) => {
              if (that.select_metropolitan == undefined || that.select_metropolitan.properties.entidad_cvegeo != feature.properties.entidad_cvegeo) {
                //if (!that.showLayerWms && !that.showLegendAreaExposition) {
                // if (!that.showLayerWms) {
                //   layer.setStyle({
                //     "color": "#6C3721",
                //     "fillColor": "#e36930",
                //     "opacity": 0.25,
                //     "weight": 1
                //   });
                // } else {
                // }
                    layer.setStyle({
                      "weight": 1
                    });
              }
              that.info.update_metropolitan();
            });

            layer.on('click', (e) => {
              if (that.select_metropolitan == undefined || that.select_metropolitan.properties.entidad_cvegeo != feature.properties.entidad_cvegeo) {
                that.select_locality = undefined;
                that.select_municipality = undefined;
                that.select_ageb = undefined;
                that.spinner.show();
                that.map.flyToBounds(layer.getBounds(), { paddingBottomRight: [0, 0] })
                that.map.once('moveend', function (e) {
                  layer.setStyle({
                    "weight": 6
                  });
                  that.loadGeoJsonMetropolitan(feature, layer, that)
                });
              }
            });
          },
        }).addTo(that.map);

        this.statusMapModeExposition = false;
        this.showLegendAreaExposition = false;
        if (this.zoneGeoJsonExposition != undefined) {
          this.map.removeLayer(this.zoneGeoJsonExposition);
          this.zoneGeoJsonExposition = undefined;
        }

        if (this.select_ws == undefined) {
          this.resetPolygonStatesExposition();
        }

        const controlMapButton = this.renderer.selectRootElement('.showMapModeExpositionModoRegion', true);
        this.renderer.setStyle(controlMapButton, 'background-color', '#6D9AB7');

        //that.polygonService.getOneUrbanAreasExposition(entidad_cvegeo).subscribe(data => {
        that.zoneExposition = []
        const municipalities = datas['municipalities'];
        archive_municipio['features'].forEach(element => {
          municipalities.forEach((indentify) => {
            if (element["properties"]['municipi_1'] && element["properties"]['municipio_'] == indentify['municipio_cvegeo'] && element.geometry != null) {
              let newPolygon = {
                "type": "Feature",
                "properties": {
                  "entidad_cvegeo": element["properties"]['entidad_cv'],
                  "municipio_cvegeo": element["properties"]['municipio_'],
                  "municipio_nombre": element["properties"]['municipi_1'],
                  "index_gen": parseFloat(parseFloat(indentify["index_gen"]).toFixed(2)),
                  "index_infr": parseFloat(parseFloat(indentify["index_infr"]).toFixed(2)),
                  "index_salu": parseFloat(parseFloat(indentify["index_salu"]).toFixed(2))
                },
                "geometry": element.geometry
              }
              that.zoneExposition.push(newPolygon);
            }
          });
        });

        that.zoneCovid = []
        const municipalitiesCovid = datas['municipalities_covid'];
        archive_municipio['features'].forEach(element => {
          municipalitiesCovid.forEach((indentify) => {
            if (element["properties"]['municipi_1'] && element["properties"]['municipio_'] == indentify['municipio_cvegeo'] && element.geometry != null) {
              let newPolygon = {
                "type": "Feature",
                "properties": {
                  "entidad_cvegeo": element["properties"]['entidad_cv'],
                  "municipio_cvegeo": element["properties"]['municipio_'],
                  "municipio_nombre": element["properties"]['municipi_1'],
                  "total": parseFloat(parseFloat(indentify["total"]).toFixed(2)),
                },
                "geometry": element.geometry
              }
              that.zoneCovid.push(newPolygon);
            }
          });
        });
        
        that.toggleMapModeExpositionModeRegion()
      });

    });
  };

  loadGeoJsonMetropolitan(feature, layer, that) {
    let municipality_style = {};
    if (that.cdmx_mode) {
      that.showLegendByMunicipalities = true;
      if (!that.showLayerWms && !that.showLegendAreaExposition) {
        municipality_style = {
          "color": '#2F855A',
          "opacity": 0.3,
          "weight": 1
        };
      } else {
        municipality_style = {
          "color": '#000000',
          "opacity": 0.5,
          "fillOpacity": 0.1,
          "weight": 1
        };
      }
    } else {
      if (!that.showLayerWms) {
        municipality_style = {
          "color": '#2F855A',
          "opacity": 0.3,
          "weight": 1
        };
      } else {
        municipality_style = {
          "color": '#000000',
          "opacity": 0.5,
          "fillOpacity": 0.1,
          "weight": 1
        };
      }
    }

    that.nivelPolygons = "Metropolitan";
    that.select_metropolitan = feature;
    if (that.layer['select_metropolitan'] != undefined) {
      that.layer["select_metropolitan"].setStyle({
        "weight": 1
      })
    }
    that.layer["select_metropolitan"] = layer;

    that.clearPolygons('select_municipality');
    that.clearPolygons('select_locality');
    that.clearPolygons('select_ageb');
    that.clearAllMarkers();
    that.resetbutton()

    const entidad_cvegeo = feature.properties.entidad_cvegeo;
    that.dataEntityName = "Zona "+feature.properties.entidad_nombre;
	//console.log(feature.properties)
    this.current_metropolitan_zone = feature.properties.entidad_nombre;

    let mode = that.cdmx_mode ? "cdmx" : "";
    that.polygonService.getMetropolitan(entidad_cvegeo, mode).subscribe(data => {

      //console.log(data)

      that.spinner.hide();
      //this.hospitalSedesa  = data['sedesa_hospitals']
      if (that.cdmx_mode) {
        that.hospitalSedesa = []
        that.hospitalSedesaActivo = []
        that.hospitalSedesaDesignado = []
        that.clearSedesa();
        that.disableInfoLayer(that.infoLayers[2]);
        that.infoLayers[2].display = false;
        let hospitals_array = []
        let hospitals_array_activos = []
        let hospitals_array_designados = []
        data['sedesa_hospitals'].forEach(sedesa => {
          let newHospital = {
            "type": "Feature",
            "properties": {
              name: {
                title: 'Nombre',
                value: sedesa['nombre_de_la_unidad']
              },
              institution: {
                title: 'Institución',
                value: sedesa['nombre_de_la_institucion']
              },
              address: {
                title: 'Dirección',
                value: sedesa['direccion']
              },
              tier: {
                title: 'Nivel de atención',
                value: sedesa['nivel_atencion']
              },
              beds_uci: {
                title: 'Camas UCI',
                value: sedesa['camas_uci']
              },
              beds: {
                title: 'Total de camas',
                value: sedesa['total_de_camas']
              },
              office: {
                title: 'Total de consultorios',
                value: sedesa['total_de_consultorios']
              },
              ventilator: {
                title: 'Total de ventiladores',
                value: sedesa['total_de_ventiladores']
              },
              carpas: {
                title: 'Carpas de triage',
                value: sedesa['total_carpas_triage_ss']
              },
              tipoSedesa: {
                title: 'Tipo de hospital en red SEDESA',
                value: sedesa['tipo_red_sedesa']
              },
              covid: {
                title: 'Hospital COVID',
                value: sedesa['covid_activo']
              },



              camas_de_recuperacion: {
                title: 'Camas de recuperación',
                value: sedesa['camas_de_recuperacion']
              },
              camas_censables_sedesa: {
                title: 'Camas censables SEDESA',
                value: sedesa['camas_censables_sedesa']
              },
              camas_no_censables_sedesa: {
                title: 'Camas no censables SEDESA',
                value: sedesa['camas_no_censables_sedesa']
              },
              camas_ti_adultos: {
                title: 'Camas ti adultos',
                value: sedesa['camas_ti_adultos']
              },
              camas_ti_pediatrica: {
                title: 'Camas ti pediátricas',
                value: sedesa['camas_ti_pediatrica']
              },
              camas_uci_neonatal: {
                title: 'Camas uci neonatal',
                value: sedesa['camas_uci_neonatal']
              },
              camas_uti: {
                title: 'Camas uti',
                value: sedesa['camas_uti']
              },

              neumologos: {
                title: 'Neumólogos',
                value: sedesa['neumologos']
              },
              internistas: {
                title: 'Internistas',
                value: sedesa['internistas']
              },
              anestesiologos: {
                title: 'Anestesiólogos',
                value: sedesa['anestesiologos']
              },
              nefrolos: {
                title: 'Nefrolos',
                value: sedesa['nefrolos']
              },
              tecnico_en_inaloterapia: {
                title: 'Técnicos en inaloterapia',
                value: sedesa['tecnico_en_inaloterapia']
              },
              medicos_generales: {
                title: 'Médicos generales',
                value: sedesa['medicos_generales']
              },
              personal_enfermeria: {
                title: 'Personal de enfermería',
                value: sedesa['personal_enfermeria']
              },

              especial: {
                title: 'Especialistas totales',
                value: sedesa['especialistas_totales']
              },
              resident: {
                title: 'Residentes totales',
                value: sedesa['residentes_totales']
              },
              "municipio_cvegeo": sedesa['municipio_cvegeo']
            },
            "geometry": {
              "type": "Point",
              "coordinates": [
                sedesa['longitud'],
                sedesa['latitud']
              ]
            },
          }
          hospitals_array.push(newHospital);
          //ahora sólo hay designado y otros. activos -> designados
          if (newHospital.properties.covid.value == 'Hospital SEDESA Designado COVID')
            hospitals_array_activos.push(newHospital);
          if (newHospital.properties.covid.value == 'Hospital Red SEDESA')
            hospitals_array_designados.push(newHospital);
        });
        that.hospitalSedesa = hospitals_array;
        that.hospitalSedesaActivo = hospitals_array_activos;
        that.hospitalSedesaDesignado = hospitals_array_designados;
        that.auxHospitalSedesa = hospitals_array;

        if (that.rendererTableSedesa) {
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next();
          });
        } else {
          that.dtTrigger.next();
          that.rendererTableSedesa = true
        }
      }

      const municipalities = data['municipalities_info'];

      if (that.cdmx_mode)
        that.updateInfraSedesa(data);

      that.updateCovid(data)
      that.updateInfra(data);
      that.updatePoblation(data);
      that.updateVunerability(data);
      that.updateProjection2020(data);
      that.updatePoverty(data);
      that.updateMortality(data);
      that.showButton();

      if (that.cdmx_mode) {
        that.aux_redSedesa = JSON.parse(JSON.stringify(that.redSedesa));
        that.aux_sedesaOtrasInstituciones = JSON.parse(JSON.stringify(that.sedesaOtrasInstituciones));
      }

      that.showlegendInfo["projection2020"] = false;
      that.showlegendInfo["poverty"] = false;
      that.showlegendInfo["mortality"] = false;
      that.showlegendInfo["covid"] = false;
      that.showlegendInfo["mortalityLocation"] = false;
      that.showlegendInfo["generalData"] = false;

      let covid_mun = data['casosCOVID_mun']

      let polygon_array = [];
      archive_municipio['features'].forEach(element => {
        municipalities.forEach((indentify) => {
          if (element["properties"]['municipi_1'] && element["properties"]['municipio_'] == indentify['municipio_cvegeo'] && element.geometry != null) {
            let newPolygon = {
              "type": "Feature",
              "properties": {
                "entidad_cvegeo": element["properties"]['entidad_cv'],
                "municipio_cvegeo": element["properties"]['municipio_'],
                "municipio_nombre": element["properties"]['municipi_1'],
                "num_casos_covid": covid_mun[element["properties"]['municipio_']]
              },
              "geometry": element.geometry
            }
            polygon_array.push(newPolygon);
          }
        });
      });

      that.clearPolygons('select_state');
      that.clearAllMarkers();

      that.polygons['select_state'] = L.geoJSON(polygon_array, {
        onEachFeature: function (feature, layer) {
          let colors = that.getColorByScaleMunicipalities(feature.properties.num_casos_covid);
          // if (!that.showLayerWms && !that.showLegendAreaExposition) {
          //   layer.setStyle({
          //     "color": colors.color,
          //     'fillColor': colors.fillColor,
          //     "opacity": 1,
          //     "fillOpacity": 0.9,
          //     "weight": 1
          //   });
          // } else {
          //   layer.setStyle({
          //     "color": '#000000',
          //     "opacity": 0.5,
          //     "fillOpacity": 0.1,
          //     "weight": 1
          //   });
          // }
          layer.setStyle({
            "color": '#000000',
            "opacity": 0.5,
            "fillOpacity": 0.1,
            "weight": 1
          });

          layer.on('mouseover', (e) => {
            if (that.cdmx_mode) {
              if (that.select_municipality == undefined || that.select_municipality.properties.municipio_cvegeo != feature.properties.municipio_cvegeo) {
                if (!that.showLayerWms && !that.showLegendAreaExposition) {
                  layer.setStyle({
                    "color": colors.color,
                    'fillColor': colors.fillColor,
                    "opacity": 1,
                    "fillOpacity": 0.9,
                    "weight": 2
                  });
                } else {
                  layer.setStyle({
                    "weight": 2
                  });
                }
              }
            }else{
              layer.setStyle({
                "weight": 2
              });
            }
            let municipality = feature.properties.municipio_nombre;
            let num_casos_covid = feature.properties.num_casos_covid;
            that.info.update_municipalities(municipality, num_casos_covid);
          });

          layer.on('mouseout', (e) => {
            if (that.cdmx_mode) {
              if (that.select_municipality == undefined || that.select_municipality.properties.municipio_cvegeo != feature.properties.municipio_cvegeo) {
                if (!that.showLayerWms && !that.showLegendAreaExposition) {
                  layer.setStyle({
                    "color": colors.color,
                    'fillColor': colors.fillColor,
                    "opacity": 1,
                    "fillOpacity": 0.9,
                    "weight": 1
                  });
                } else {
                  layer.setStyle({
                    "weight": 1
                  });
                }
              }
            } else {
              if (that.select_municipality == undefined || that.select_municipality.properties.municipio_cvegeo != feature.properties.municipio_cvegeo) {
                // if (!that.showLayerWms && !that.showLegendAreaExposition) {
                //   layer.setStyle({
                //     "color": colors.color,
                //     'fillColor': colors.fillColor,
                //     "opacity": 1,
                //     "fillOpacity": 0.9,
                //     "weight": 1
                //   });
                // } else {
                //   layer.setStyle({
                //     "weight": 1
                //   });
                // }
                layer.setStyle({
                  "weight": 1
                });
              }
            }

            let municipality = "";
            that.info.update_municipalities(municipality);
          });

          layer.on('click', (e) => {
            if (that.select_municipality == undefined || that.select_municipality.properties.municipio_cvegeo != feature.properties.municipio_cvegeo) {
              that.select_locality = undefined;
              that.select_ageb = undefined;
              that.spinner.show();
              that.map.flyToBounds(layer.getBounds(), { paddingBottomRight: [10, 10] })
              that.map.once('moveend', function (e) {
                layer.setStyle({
                  "weight": 6
                });
                that.loadGeoJsonMetropolisMunicipies(feature, layer, that)
              });
            }
          });
        }
      }).addTo(that.map);

      if (that.cdmx_mode == true) {
        that.polygonService.getStateExposition(entidad_cvegeo).subscribe(data => {
          that.zoneExposition = []
          const municipalities = data['municipalities'];
          archive_municipio['features'].forEach(element => {
            municipalities.forEach((indentify) => {
              if (element["properties"]['municipi_1'] && element["properties"]['municipio_'] == indentify['municipio_cvegeo'] && element.geometry != null) {
                let newPolygon = {
                  "type": "Feature",
                  "properties": {
                    "entidad_cvegeo": element["properties"]['entidad_cv'],
                    "municipio_cvegeo": element["properties"]['municipio_'],
                    "municipio_nombre": element["properties"]['municipi_1'],
                    "index_gen": parseFloat(parseFloat(indentify["index_gen"]).toFixed(2)),
                    "index_infr": parseFloat(parseFloat(indentify["index_infr"]).toFixed(2)),
                    "index_salu": parseFloat(parseFloat(indentify["index_salu"]).toFixed(2))
                  },
                  "geometry": element.geometry
                }
                that.zoneExposition.push(newPolygon);
              }
            });
          });

          that.toggleMapModeExposition();

        });
      }
    });
  }

  loadGeoJsonMetropolisMunicipies(feature, layer, that) {
    that.showLegendByMunicipalities = false;
    let locality_style = {};
    if (!that.showLayerWms) {
      locality_style = {
        "color": '#900dd6',
        "opacity": 0.3,
        "weight": 1
      };
    } else {
      locality_style = {
        "color": '#000000',
        "opacity": 0.5,
        "fillOpacity": 0.1,
        "weight": 1
      };
    }

    that.nivelPolygons = "ZonaMunicipio";
    that.select_municipality = feature;
    if (that.layer['select_municipality'] != undefined) {
      that.layer["select_municipality"].setStyle({
        "weight": 1
      })
    }
    that.layer["select_municipality"] = layer;

    that.clearPolygons('select_municipality')
    that.clearPolygons('select_locality')
    that.clearPolygons('select_ageb');
    that.clearAllMarkers();
    that.resetbutton()

    const municipio_cvegeo = feature.properties.municipio_cvegeo;
    const state = that.select_metropolitan.properties.entidad_nombre
    that.dataEntityName = feature.properties.municipio_nombre + ", " + state + ", " + "México";
    this.current_municipality = feature.properties.municipio_nombre;
    this.current_state = state;

    let mode = that.cdmx_mode ? "cdmx" : "";
    that.polygonService.getMunicipalities(municipio_cvegeo, mode).subscribe(data => {
      that.spinner.hide();

      //console.log(data)
      if (that.cdmx_mode) {
        that.clearSedesa()
        that.disableInfoLayer(that.infoLayers[2]);
        that.infoLayers[2].display = false;
        that.hospitalSedesa = []
        let labs_array = []
        let hospitals_array_activos = []
        let hospitals_array_designados = []

        this.auxHospitalSedesa.forEach(sedesa => {
          if (municipio_cvegeo == sedesa['properties']['municipio_cvegeo']) {
            let newHospital = {
              "type": "Feature",
              "properties": sedesa['properties'],
              "geometry": {
                "type": "Point",
                "coordinates": [
                  sedesa['geometry']['coordinates'][0],
                  sedesa['geometry']['coordinates'][1]
                ]
              },
            }

            labs_array.push(newHospital);
            if (newHospital.properties.covid.value == 'Hospital SEDESA Designado COVID')
              hospitals_array_activos.push(newHospital);
            if (newHospital.properties.covid.value == 'Hospital Red SEDESA')
              hospitals_array_designados.push(newHospital);
          }
        });
        that.hospitalSedesa = labs_array;
        that.hospitalSedesaActivo = hospitals_array_activos;
        that.hospitalSedesaDesignado = hospitals_array_designados;
      }

      if (that.cdmx_mode)
        that.updateInfraSedesa(data);

      that.updateCovid(data)
      that.updateInfra(data);
      that.updatePoblation(data);
      that.updateVunerability(data);
      that.updateProjection2020(data);
      that.updatePoverty(data);
      that.updateExposition(data);
      that.showButton();

      that.showlegendInfo["projection2020"] = false;
      that.showlegendInfo["poverty"] = false;
      that.showlegendInfo["covid"] = false;
      that.showlegendInfo["mortalityLocation"] = false;
      that.showlegendInfo["generalData"] = false;

      if (data['mortality_info']) {
        that.updateMortality(data);
        that.showlegendInfo["mortality"] = false;
      }

      let polygon_array = [];
      archive_loc_urb['features'].forEach(element => {
        if (element["properties"]['localida_1'] && element["properties"]['municipio_'] == municipio_cvegeo && element.geometry != null) {
          let newPolygon = {
            "type": "Feature",
            "properties": {
              "localidad_urbana_cvegeo": element["properties"]['localidad_'],
              "localidad_urbana_nombre": element["properties"]['localida_1']
            },
            "geometry": element.geometry
          }
          polygon_array.push(newPolygon);
        }
      });

      that.clearPolygons('select_municipality');
      that.clearAllMarkers();

      that.polygons['select_municipality'] = L.geoJSON(polygon_array, {
        style: locality_style,
        onEachFeature: function (feature, layer) {
          layer.on('mouseover', (e) => {
            if (that.select_locality == undefined || that.select_locality.properties.localidad_urbana_cvegeo != feature.properties.localidad_urbana_cvegeo) {
              if (!that.showLayerWms) {
                layer.setStyle({
                  "color": '#900dd6',
                  "opacity": 1,
                  "fillOpacity": 0.9,
                  "stroker": true,
                  "weight": 2
                });
              } else {
                layer.setStyle({
                  "weight": 2
                });
              }

            }
            let locality = feature.properties.localidad_urbana_nombre
            that.info.update_localities(locality);
          });

          layer.on('mouseout', (e) => {
            if (!that.showLayerWms) {
              layer.setStyle({
                "color": '#900dd6',
                "fillOpacity": 0.3,
                "opacity": 0.3,
                "weight": 1
              });
            } else {
              layer.setStyle({
                "weight": 1
              });
            }
            let locality = ""

            that.info.update_localities(locality);
          });

          layer.on('click', (e) => {
            if (that.select_locality == undefined || that.select_locality.properties.localidad_urbana_cvegeo != feature.properties.localidad_urbana_cvegeo) {
              that.select_ageb = undefined;
              that.spinner.show();
              that.map.flyToBounds(layer.getBounds(), { paddingBottomRight: [0, 0] })
              that.map.once('moveend', function (e) {
                that.loadGeoJsonMetropolisLocalities(feature, layer, that)
              });
            }
          });
        },
      }).addTo(that.map);
    });
  }

  loadGeoJsonMetropolisLocalities(feature, layer, that) {
    let locality_style = {};
    if (!that.showLayerWms) {
      locality_style = {
        "color": '#d60d53',
        "weight": 1,
        "opacity": 0.7,
      };
    } else {
      locality_style = {
        "color": '#000000',
        "opacity": 0.7,
        "fillOpacity": 0.1,
        "weight": 1
      };
    };

    that.nivelPolygons = "ZonaLocalidad";
    that.select_locality = feature;
    that.layer["select_locality"] = layer;

    that.clearPolygons('select_locality')
    that.clearPolygons('select_ageb');
    that.clearAllMarkers();
    that.resetbutton()

    const localidad_urbana_cvegeo = feature.properties.localidad_urbana_cvegeo;
    let state = that.select_metropolitan.properties.entidad_nombre;
    let municipality = that.select_municipality.properties.municipio_nombre;
    that.dataEntityName = feature.properties.localidad_urbana_nombre + ", " + municipality + ", " + state + ", " + "México";
    //this.current_metropolitan_zone = feature.properties.localidad_urbana_nombre;
    this.current_municipality = municipality;
    this.current_state = state;

    let mode = that.cdmx_mode ? "cdmx" : "";
    that.polygonService.getLocalities(localidad_urbana_cvegeo, mode).subscribe(data => {
      that.clearSedesa()
      that.disableInfoLayer(that.infoLayers[2]);
      that.spinner.hide();

      if (that.cdmx_mode)
        that.updateInfraSedesa(data);

      that.updatePoblation(data);
      that.updatePoverty(data);
      that.updateInfra(data);
      that.updateVunerability(data);
      that.showButton();
      //colorcar una bandera para este caso de projection 2020
      that.showlegendInfo["projection2020"] = true;
      that.showlegendInfo["poverty"] = true;
      that.showlegendInfo["covid"] = false;
      that.showlegendInfo["mortalityLocation"] = false;
      that.showlegendInfo["generalData"] = false;

      if (data['mortality_info']) {
        that.updateMortality(data);
        that.showlegendInfo["mortality"] = false;
      } else {
        const municipio_cvegeo = that.select_municipality.properties.municipio_cvegeo
        that.polygonService.getMunicipalities(municipio_cvegeo).subscribe(data => {
          if (data['mortality_info']) {
            that.updateMortality(data);
            that.showlegendInfo["mortality"] = true;
          }
        })
      }

      that.clearPolygons('select_ageb');
      that.clearAllMarkers();

      let polygon_array = [];
      data["agebs"].forEach(element => {
        let newPolygon = {
          "type": "Feature",
          "properties": {
            "ageb_urbana_cvegeo": element['ageb_urbana_cvegeo']
          },
          "geometry": JSON.parse(element.geojson)
        }
        polygon_array.push(newPolygon);
      });

      that.polygons['select_ageb'] = L.geoJSON(polygon_array, {
        style: locality_style,
        onEachFeature: function (feature, layer) {
          layer.on('mouseover', (e) => {
            if (that.select_ageb == undefined || that.select_ageb.properties.ageb_urbana_cvegeo != feature.properties.ageb_urbana_cvegeo) {
              if (!that.showLayerWms) {
                layer.setStyle({
                  "color": '#d60d53',
                  "opacity": 1,
                  "stroker": true,
                  "weight": 2
                });
              } else {
                layer.setStyle({
                  "weight": 2
                });
              }

              let ageb = feature.properties.ageb_urbana_cvegeo
              //that.info.update_ageb(ageb);
            }
          });

          layer.on('mouseout', (e) => {
            if (!that.showLayerWms) {
              layer.setStyle({
                "color": '#d60d53',
                "opacity": 0.7,
                "weight": 1
              });
            } else {
              layer.setStyle({
                "weight": 1
              });
            }

            //that.info.update_ageb();
          });

          layer.on('click', (e) => {
            if (that.select_ageb == undefined || that.select_ageb.properties.ageb_urbana_cvegeo != feature.properties.ageb_urbana_cvegeo) {
              //that.spinner.show()
              that.map.flyToBounds(layer.getBounds(), { paddingBottomRight: [10, 10] })
              that.map.once('moveend', function (e) {
                that.loadGeoJsonMetropolisAgeb(feature, layer, that)
              });
            }
          });
        },
      }).addTo(that.map);
    });
  }

  loadGeoJsonMetropolisAgeb(feature, layer, that) {
    let locality_style = {
      "color": '#900dd6',
      'stroke': true,
      "weight": 1
    };

    that.nivelPolygons = "ZonaAgeb";
    that.select_ageb = feature;
    that.layer["select_ageb"] = layer;

    that.clearAllMarkers();
    that.resetbutton()

    const ageb_urbana_cvegeo = feature.properties.ageb_urbana_cvegeo;
    const ageb = "ageb";
    const localidad = that.select_locality.properties.localidad_urbana_nombre;
    const state = that.select_metropolitan.properties.entidad_nombre;
    const municipality = that.select_municipality.properties.municipio_nombre;
    that.dataEntityName = ageb + ", " + localidad + ", " + municipality + ", " + state + ", " + "México";
    this.current_locality = localidad
    this.current_state = state
    this.current_municipality = municipality
    let mode = that.cdmx_mode ? "cdmx" : "";
    that.polygonService.getAgeb(ageb_urbana_cvegeo, mode).subscribe(data => {
      that.spinner.hide();
      that.updatePoblation(data);
      that.updateVunerability(data);
      that.updatePovertyAgeb(data);
      that.showlegendInfo["generalData"] = true;

      if (!that.showlegendInfo["mortality"]) {
        that.showlegendInfo["mortalityLocation"] = true;
      }
    });
  }

  loadGeoJsonCountry() {
    let that = this;
    let state_style = {
      "color": "#6C3721",
      "fillColor": "#e36930",
      "opacity": 0.25
    };

    this.polygonService.getCountryExposition().subscribe(datas => {
      this.polygonService.getCountry().subscribe(data => {
        this.initSearchMunicipality();
        this.spinner.hide();

        //console.log(data)

        this.updateCovid(data)
        this.countCovidbyState(data)
        this.updateExposition(data);
        this.updateInfra(data);
        this.updatePoblation(data);
        this.updateVunerability(data);
        this.updateMortality(data)
        this.updatePoverty(data);
        this.updateProjection2020(data);

        this.casosCovidNacional['casosCOVID'] = data['casosCOVID'];
        //console.log(this.casosCovidNacional['casosCOVID']['total'])
        this.covidTotal = this.casosCovidNacional['casosCOVID']['total'];

        this.showlegendInfo["mortality"] = false;
        this.showlegendInfo["projection2020"] = false;
        this.showlegendInfo["poverty"] = false;
        this.showlegendInfo["covid"] = false;
        this.showlegendInfo["mortalityLocation"] = false;
        this.showlegendInfo["generalData"] = false;

        this.aux_generalData = JSON.parse(JSON.stringify(this.generalData));
        this.aux_pobData = JSON.parse(JSON.stringify(this.pobData));
        this.aux_pobData2020 = JSON.parse(JSON.stringify(this.pobData2020));
        this.aux_vulData = JSON.parse(JSON.stringify(this.vulData));
        this.aux_povData = JSON.parse(JSON.stringify(this.povertyData));
        this.aux_mortalityData = JSON.parse(JSON.stringify(this.mortalityData));
        this.aux_expositionData = JSON.parse(JSON.stringify(this.expositionData));

        let polygon_array = []
        archive_entidades["features"].forEach(element => {
          let stateName = element['properties']['entidad_no'].toUpperCase();
          if (stateName === 'ESTADO DE MÉXICO') {
            stateName = 'MÉXICO';
          } else {
            if (stateName === 'QUERÉTARO') {
              stateName = 'QUERETARO';
            }
          }
          let covidData = that.covidCasesByState[stateName];
          let cases = 0;
          if (covidData !== undefined) {
            cases = covidData.total;
          }

          let newPolygon = {
            "type": "Feature",
            "properties": {
              "entidad_cvegeo": element['properties']['entidad_cv'],
              "entidad_nombre": element['properties']['entidad_no'],
              "covid": cases
            },
            "geometry": element.geometry
          }
          polygon_array.push(newPolygon);
        });

        this.polygons["select_country"] = L.geoJSON(polygon_array, {
          onEachFeature: function (feature, layer) {
            let colors = that.getColorByScale(feature.properties.covid);
            layer.setStyle({
              "color": colors.color,
              'fillColor': colors.fillColor,
              "opacity": 0.5,
              "fillOpacity": 0.7,
              "weight": 1
            });

            layer.on('mouseover', (e) => {
              if (that.select_state === undefined || that.select_state.properties.entidad_cvegeo != feature.properties.entidad_cvegeo) {
                if (!that.showLayerWms && !that.showLegendAreaExposition) {
                  layer.setStyle({
                    "color": '#6C3721',
                    'fillColor': colors.fillColor,
                    "opacity": 1,
                    "fillOpacity": 0.7,
                    "weight": 2
                  });
                  let state = feature.properties.entidad_nombre
                  that.info.update_states_covid(state, feature.properties.covid);
                } else {
                  layer.setStyle({
                    "weight": 2
                  });
                  let state = feature.properties.entidad_nombre
                  that.info.update_states(state);
                }

              }
            });

            layer.on('mouseout', (e) => {
              if (that.select_state === undefined || that.select_state.properties.entidad_cvegeo != feature.properties.entidad_cvegeo) {
                if (!that.showLayerWms && !that.showLegendAreaExposition) {
                  layer.setStyle({
                    "color": colors.color,
                    'fillColor': colors.fillColor,
                    "opacity": 0.5,
                    "fillOpacity": 0.7,
                    "weight": 1
                  });
                  that.info.update_states_covid();
                } else {
                  layer.setStyle({
                    "weight": 1
                  });
                  that.info.update_states_covid();
                }
              }
            });

            layer.on('click', (e) => {
              if (that.select_state === undefined || that.select_state.properties.entidad_cvegeo != feature.properties.entidad_cvegeo) {
                that.select_locality = undefined;
                that.select_municipality = undefined;
                that.select_ageb = undefined;
                that.spinner.show();
                let levelZoom = that.map.getBoundsZoom(layer.getBounds());
                if (levelZoom == 9) {
                  that.map.flyToBounds(layer.getBounds(), { paddingBottomRight: [0, 0], maxZoom: levelZoom - 1 })
                } else {
                  that.map.flyToBounds(layer.getBounds(), { paddingBottomRight: [0, 0], maxZoom: levelZoom })
                }
                that.map.once('moveend', function (e) {
                  layer.setStyle({
                    "weight": 6
                  });
                  //if(that.showLayerWms){ that.resetWms() }
                  that.loadGeoJsonStates(feature, layer, that)
                });
              }
            });
          },
        }).addTo(this.map);
        if (!this.showIntrojs) {
          this.showIntrojs = true;
          this.introJS.start();
        }

        this.statusMapModeExposition = false;
        this.showLegendAreaExposition = false;
        if (this.zoneGeoJsonExposition != undefined) {
          this.map.removeLayer(this.zoneGeoJsonExposition);
          this.zoneGeoJsonExposition = undefined;
        }
        if (this.select_ws == undefined) {
          this.resetPolygonStatesExposition();
        }

        const controlMapButton = this.renderer.selectRootElement('.showMapModeExpositionModoNormalCountry', true);
        //this.renderer.setStyle(controlMapButton, 'background-color', 'rgb(56, 178, 172, 0.7)');
        this.renderer.setStyle(controlMapButton, 'background-color', '#6D9AB7');
        document.getElementById("showMapCovidModoNormalCountry").classList.remove('active');
        document.getElementById("showMapExpositionModoNormalCountry").classList.remove('active');

        that.zoneExposition = []
        const municipalities = datas['municipalities'];
        archive_municipio['features'].forEach(element => {
          municipalities.forEach((indentify) => {
            if (element["properties"]['municipi_1'] && element["properties"]['municipio_'] == indentify['municipio_cvegeo'] && element.geometry != null) {
              let newPolygon = {
                "type": "Feature",
                "properties": {
                  "entidad_cvegeo": element["properties"]['entidad_cv'],
                  "municipio_cvegeo": element["properties"]['municipio_'],
                  "municipio_nombre": element["properties"]['municipi_1'],
                  "index_gen": parseFloat(parseFloat(indentify["index_gen"]).toFixed(2)),
                  "index_infr": parseFloat(parseFloat(indentify["index_infr"]).toFixed(2)),
                  "index_salu": parseFloat(parseFloat(indentify["index_salu"]).toFixed(2))
                },
                "geometry": element.geometry
              }
              that.zoneExposition.push(newPolygon);
            }
          });
        });
        that.toggleMapModeExpositionModeNormalCountry();
        that.showLegend = true;
      });
    });
  }



  getColorByScale(cases) {

    switch (true) {
      case (cases == 0):
        return { color: '#6C3721', fillColor: '#ffffff' };
        break;
      case (cases >= 1 && cases <= 2000):
        return { color: '#6C3721', fillColor: '#E7B1B1' };
        break;
      case (cases >= 2001 && cases <= 3000):
        return { color: '#6C3721', fillColor: '#D98282' };
        break;
      case (cases >= 3001 && cases <= 5000):
        return { color: '#6C3721', fillColor: '#D47373' };
        break;
      case (cases >= 5001 && cases <= 7000):
        return { color: '#6C3721', fillColor: '#CF6363' };
        break;
      case (cases >= 7001 && cases <= 10000):
        return { color: '#6C3721', fillColor: '#CA5353' };
        break;
      default:
        return { color: '#6C3721', fillColor: '#AC3535' };
        break;

    }

    /*     if (cases == 0) {
          return { color: '#6C3721', fillColor: '#ffffff' };
        } else {
          if (cases >= 1 && cases <= 1000) {
            return { color: '#6C3721', fillColor: '#DF9696' };
          } else {
            if (cases >= 1001 && cases <= 2000) {
              return { color: '#6C3721', fillColor: '#EEAAAA' };
            } else {
              if (cases >= 2001 && cases <= 3000) {
                return { color: '#6C3721', fillColor: '#D47373' };
              } else {
                if (cases >= 3001 && cases <= 10000) {
                  return { color: '#6C3721', fillColor: '#C54545' };
                } else {
                  if (cases >= 10000) {
                    return { color: '#6C3721', fillColor: '#B40404' };
                  }
                }
              }
            }
          }
        }	 */

  }


  getColorByScaleMunicipalities(cases) {
    switch (true) {

      case (cases == 0):
        return { color: '#6C3721', fillColor: '#ffffff' };
        break;
      case (cases >= 1 && cases <= 50):
        return { color: '#6C3721', fillColor: '#ffd7d7' };
        break;
      case (cases >= 51 && cases <= 2000):
        return { color: '#6C3721', fillColor: '#E7B1B1' };
        break;
      case (cases >= 2001 && cases <= 3000):
        return { color: '#6C3721', fillColor: '#D98282' };
        break;
      case (cases >= 3001 && cases <= 5000):
        return { color: '#6C3721', fillColor: '#D47373' };
        break;
      case (cases >= 5001 && cases <= 7000):
        return { color: '#6C3721', fillColor: '#CF6363' };
        break;
      case (cases >= 7001 && cases <= 10000):
        return { color: '#6C3721', fillColor: '#CA5353' };
        break;
      default:
        return { color: '#6C3721', fillColor: '#AC3535' };
        break;

    }
  }


  getColorByScaleMapExposition(cases) {
    if (cases < -2.15) {
      return "#662404";
    } else {
      if (-2.15 <= cases && cases < -1.04) {
        return "#662404";
      } else {
        if (-1.04 <= cases && cases < -0.79) {
          return "#cc4b07";
        } else {
          if (-0.79 <= cases && cases < -0.43) {
            return "#fb9929";
          } else {
            if (-0.43 <= cases && cases < -0.05) {
              return "#ffe28b";
            } else {
              if (-0.05 <= cases && cases <= 2.45) {
                return "#ffffe4";
              } else {
                if (2.45 <= cases) {
                  return "#ffffe4";
                }
              }
            }
          }
        }
      }
    }
  }

  loadGeoJsonStates(feature, layer, that) {
    this.showLegend = false;

    let municipality_style = {};
    if (!that.showLayerWms) {
      municipality_style = {
        "color": '#6C3721',
        "opacity": 1,
        "weight": 1
      };
    } else {
      municipality_style = {
        "color": '#000000',
        "opacity": 0.5,
        "fillOpacity": 0.1,
        "weight": 1
      };
    }

    //this.showLegendByMunicipalities = true;
    let nombre_estado = feature.properties.entidad_nombre.toUpperCase()

    /*     if (nombre_estado === 'ESTADO DE MÉXICO')  //excepción para el estado de México, que la info sólo aparece como "México"
          nombre_estado = 'MÉXICO'
        if (nombre_estado === 'QUERÉTARO')  //excepción para el estado de México, que la info sólo aparece como "México"
          nombre_estado = 'QUERETARO'
    
        //this.loadInfoCOVIDEstado(feature.properties.entidad_nombre.toUpperCase())
        if (this.COVID_casos_por_estado[nombre_estado] != null) {
          this.loadInfoCOVID(nombre_estado, this.COVID_casos_por_estado[nombre_estado])
        }
        else {
          this.loadInfoCOVID(nombre_estado, [])
        } */

    that.estadoCOVID = feature.properties.entidad_nombre
    that.nivelPolygons = "Estado";
    that.select_state = feature;

    if (that.layer['select_state'] != undefined) {
      that.layer["select_state"].setStyle({
        "weight": 1
      })
    }

    that.layer["select_state"] = layer;

    that.clearPolygons('select_state');
    that.clearPolygons('select_municipality');
    that.clearPolygons('select_locality');
    that.clearPolygons('select_ageb');
    that.clearAllMarkers();
    that.resetbutton()

    const entidad_cvegeo = feature.properties.entidad_cvegeo;
    that.dataEntityName = feature.properties.entidad_nombre + ", " + "México";
    this.current_state = feature.properties.entidad_nombre

    that.polygonService.getStatesExpositionModoNormal(entidad_cvegeo).subscribe(datas => {
      that.polygonService.getStates(entidad_cvegeo).subscribe(data => {
        that.spinner.hide();

        //console.log(data)

        that.updateCovid(data)
        that.updateInfra(data);
        that.updatePoblation(data);
        that.updateVunerability(data);
        that.updateVulnerabilityState(data);
        that.updateProjection2020(data);
        that.updatePoverty(data);
        that.updateMortality(data);
        that.showButton();

        that.showlegendInfo["projection2020"] = false;
        that.showlegendInfo["poverty"] = false;
        that.showlegendInfo["mortality"] = false;
        that.showlegendInfo["covid"] = true;
        that.showlegendInfo["mortalityLocation"] = false;
        that.showlegendInfo["generalData"] = false;

        let covid_mun = data['casosCOVID_mun']
        let polygon_array = [];
        archive_municipio['features'].forEach(element => {
          if (element["properties"]['municipi_1'] && element["properties"]['entidad_cv'] == entidad_cvegeo && element.geometry != null) {
            let newPolygon = {
              "type": "Feature",
              "properties": {
                "entidad_cvegeo": element["properties"]['entidad_cv'],
                "municipio_cvegeo": element["properties"]['municipio_'],
                "municipio_nombre": element["properties"]['municipi_1'],
                "num_casos_covid": covid_mun[element["properties"]['municipio_']]
              },
              "geometry": element.geometry
            }
            polygon_array.push(newPolygon);
          }
        });


        that.clearPolygons('select_state');
        that.clearAllMarkers();

        that.polygons['select_state'] = L.geoJSON(polygon_array, {
          onEachFeature: function (feature, layer) {
            // let colorMapExposition = that.getColorByScaleMapExposition(feature.properties.index_gen);
            // layer.setStyle({
            //   "color": "#000000",
            //   "fillColor": colorMapExposition,
            //   "opacity": 0.5,
            //   "fillOpacity": 0.7,
            //   "weight": 1
            // });
            let colors = that.getColorByScaleMunicipalities(feature.properties.num_casos_covid);
            if (!that.showLayerWms && !that.showLegendAreaExposition) {
              layer.setStyle({
                "color": colors.color,
                'fillColor': colors.fillColor,
                "opacity": 1,
                "fillOpacity": 0.9,
                "weight": 1
              });
            } else {
              layer.setStyle({
                "color": '#000000',
                "opacity": 0.5,
                "fillOpacity": 0.01,
                "weight": 1
              });
            }

            layer.on('mouseover', (e) => {
              if (that.select_municipality === undefined || that.select_municipality.properties.municipio_cvegeo != feature.properties.municipio_cvegeo) {
                if (!that.showLayerWms && !that.showLegendAreaExposition) {
                  layer.setStyle({
                    "color": colors.color,
                    'fillColor': colors.fillColor,
                    "opacity": 1,
                    "fillOpacity": 0.9,
                    "weight": 2
                  });
                  // layer.setStyle({
                  //   "color": "#000000",
                  //   "fillColor": colorMapExposition,
                  //   "opacity": 0.5,
                  //   "fillOpacity": 0.7,
                  //   "weight": 2
                  // });
                  let municipality = feature.properties.municipio_nombre;
                  let num_casos_covid = feature.properties.num_casos_covid;
                  that.info.update_municipalities_covid(municipality, num_casos_covid);
                } else {
                  layer.setStyle({
                    "weight": 2
                  });
                  let municipality = feature.properties.municipio_nombre;
                  that.info.update_municipalities(municipality);
                }
              } else {
                if (!that.showLayerWms && !that.showLegendAreaExposition) {
                  let municipality = feature.properties.municipio_nombre;
                  let num_casos_covid = feature.properties.num_casos_covid;
                  that.info.update_municipalities_covid(municipality, num_casos_covid);
                } else {
                  let municipality = feature.properties.municipio_nombre;
                  that.info.update_municipalities(municipality);
                }
              }
            });

            layer.on('mouseout', (e) => {
              if (that.select_municipality === undefined || that.select_municipality.properties.municipio_cvegeo != feature.properties.municipio_cvegeo) {
                if (!that.showLayerWms && !that.showLegendAreaExposition) {
                  layer.setStyle({
                    "color": colors.color,
                    'fillColor': colors.fillColor,
                    "opacity": 1,
                    "fillOpacity": 0.9,
                    "weight": 1
                  });
                  // layer.setStyle({
                  //   "color": "#000000",
                  //   "fillColor": colorMapExposition,
                  //   "opacity": 0.5,
                  //   "fillOpacity": 0.7,
                  //   "weight": 1
                  // });
                  that.info.update_municipalities_covid();
                } else {
                  layer.setStyle({
                    "weight": 1
                  });
                  that.info.update_municipalities();
                }
              } else {
                if (!that.showLayerWms && !that.showLegendAreaExposition) {
                  that.info.update_municipalities_covid();
                } else {
                  that.info.update_municipalities();
                }
              }
            });

            layer.on('click', (e) => {
              if (that.select_municipality == undefined || that.select_municipality.properties.municipio_cvegeo != feature.properties.municipio_cvegeo) {
                that.select_locality = undefined;
                that.select_ageb = undefined;
                that.spinner.show();
                that.map.flyToBounds(layer.getBounds(), { paddingBottomRight: [10, 10] })
                that.map.once('moveend', function (e) {
                  layer.setStyle({
                    "weight": 6
                  });
                  that.loadGeoJsonMunicipies(feature, layer, that)
                });
              }
            });
          },
        }).addTo(that.map);

        //   this.statusMapModeExposition = false;
        //   this.showLegendAreaExposition = false;
        //   if (this.zoneGeoJsonExposition != undefined) {
        //     this.map.removeLayer(this.zoneGeoJsonExposition);
        //     this.zoneGeoJsonExposition = undefined;
        //   }
        //   if (this.select_ws == undefined) {
        //     this.resetPolygonStatesExposition();
        //   }

        //   const controlMapButton = this.renderer.selectRootElement('.showMapModeExpositionModoNormal', true);
        //   this.renderer.setStyle(controlMapButton, 'background-color', '#6D9AB7');

        //   that.zoneExposition = []
        //   const municipalities = datas['municipalities'];
        //   archive_municipio['features'].forEach(element => {
        //     municipalities.forEach((indentify) => {
        //       if (element["properties"]['municipi_1'] && element["properties"]['municipio_'] == indentify['municipio_cvegeo'] && element.geometry != null) {
        //         let newPolygon = {
        //           "type": "Feature",
        //           "properties": {
        //             "entidad_cvegeo": element["properties"]['entidad_cv'],
        //             "municipio_cvegeo": element["properties"]['municipio_'],
        //             "municipio_nombre": element["properties"]['municipi_1'],
        //             "index_gen": parseFloat(parseFloat(indentify["index_gen"]).toFixed(2)),
        //             "index_infr": parseFloat(parseFloat(indentify["index_infr"]).toFixed(2)),
        //             "index_salu": parseFloat(parseFloat(indentify["index_salu"]).toFixed(2))
        //           },
        //           "geometry": element.geometry
        //         }
        //         that.zoneExposition.push(newPolygon);
        //       }
        //     });
        //   });
        //   that.toggleMapModeExpositionModeNormal()
        that.showLegendByMunicipalities = true;
      });
    });
  }

  loadGeoJsonMunicipies(feature, layer, that) {
    that.showLegendByMunicipalities = false
    let locality_style = {};
    if (!that.showLayerWms) {
      locality_style = {
        "color": '#900dd6',
        "opacity": 0.3,
        "weight": 1
      };
    } else {
      locality_style = {
        "color": '#000000',
        "opacity": 0.5,
        "fillOpacity": 0.1,
        "weight": 1
      };
    }

    that.nivelPolygons = "Municipio";
    that.select_municipality = feature;
    if (that.layer['select_municipality'] != undefined) {
      that.layer["select_municipality"].setStyle({
        "weight": 1
      })
    }
    that.layer["select_municipality"] = layer;

    that.clearPolygons('select_municipality')
    that.clearPolygons('select_locality')
    that.clearPolygons('select_ageb');
    that.clearAllMarkers();
    that.resetbutton()

    const municipio_cvegeo = feature.properties.municipio_cvegeo;
    const state = that.select_state.properties.entidad_nombre
    that.dataEntityName = feature.properties.municipio_nombre + ", " + state + ", " + "México";
    this.current_municipality = feature.properties.municipio_nombre;
    this.current_state = state;

    that.polygonService.getMunicipalities(municipio_cvegeo).subscribe(data => {
      that.spinner.hide();

      that.updateCovid(data)
      that.updateInfra(data);
      that.updatePoblation(data);
      that.updateVunerability(data);
      that.updateProjection2020(data);
      that.updatePoverty(data);
      that.updateExposition(data);
      that.showButton();

      that.showlegendInfo["projection2020"] = false;
      that.showlegendInfo["poverty"] = false;
      that.showlegendInfo["covid"] = true;
      that.showlegendInfo["mortalityLocation"] = false;
      that.showlegendInfo["generalData"] = false;

      if (data['mortality_info']) {
        that.updateMortality(data);
        that.showlegendInfo["mortality"] = false;
      }

      let polygon_array = [];
      archive_loc_urb['features'].forEach(element => {
        if (element["properties"]['localida_1'] && element["properties"]['municipio_'] == municipio_cvegeo && element.geometry != null) {
          let newPolygon = {
            "type": "Feature",
            "properties": {
              "localidad_urbana_cvegeo": element["properties"]['localidad_'],
              "localidad_urbana_nombre": element["properties"]['localida_1']
            },
            "geometry": element.geometry
          }
          polygon_array.push(newPolygon);
        }
      });

      that.clearPolygons('select_municipality');
      that.clearAllMarkers();

      that.polygons['select_municipality'] = L.geoJSON(polygon_array, {
        style: locality_style,
        onEachFeature: function (feature, layer) {
          layer.on('mouseover', (e) => {
            if (that.select_locality == undefined || that.select_locality.properties.localidad_urbana_cvegeo != feature.properties.localidad_urbana_cvegeo) {
              if (!that.showLayerWms) {
                layer.setStyle({
                  "color": '#900dd6',
                  "opacity": 1,
                  "stroker": true,
                  "weight": 2
                });
              } else {
                layer.setStyle({
                  "weight": 2
                });
              }
            }
            let locality = feature.properties.localidad_urbana_nombre;
            that.info.update_localities(locality);
          });

          layer.on('mouseout', (e) => {
            if (!that.showLayerWms) {
              layer.setStyle({
                "color": '#900dd6',
                "opacity": 0.3,
                "weight": 1
              });
            } else {
              layer.setStyle({
                "weight": 1
              });
            }
            let locality = "";
            that.info.update_localities(locality);
          });

          layer.on('click', (e) => {
            if (that.select_locality == undefined || that.select_locality.properties.localidad_urbana_cvegeo != feature.properties.localidad_urbana_cvegeo) {
              that.select_ageb = undefined;
              that.spinner.show()
              that.map.flyToBounds(layer.getBounds(), { paddingBottomRight: [0, 0] })
              that.map.once('moveend', function (e) {
                //if(that.showLayerWms){ that.resetWms() }
                that.loadGeoJsonLocalities(feature, layer, that)
              });
            }
          });
        },
      }).addTo(that.map);
    });
  }

  loadGeoJsonLocalities(feature, layer, that) {
    let locality_style = {};
    if (!that.showLayerWms) {
      locality_style = {
        "color": '#a7d60d',
        "opacity": 0.7,
        "fillOpacity": 0.1,
        "stroker": true,
        "weight": 1
      };
    } else {
      locality_style = {
        "color": '#000000',
        "opacity": 0.7,
        "weight": 1
      };
    }

    that.nivelPolygons = "Localidad";
    that.select_locality = feature;
    that.layer["select_locality"] = layer;

    that.clearPolygons('select_locality')
    that.clearPolygons('select_ageb');
    that.clearAllMarkers();
    that.resetbutton()

    const localidad_urbana_cvegeo = feature.properties.localidad_urbana_cvegeo;
    let state = that.select_state.properties.entidad_nombre;
    let municipality = that.select_municipality.properties.municipio_nombre;
    that.dataEntityName = feature.properties.localidad_urbana_nombre + ", " + municipality + ", " + state + ", " + "México";
    this.current_locality = feature.properties.localidad_urbana_nombre
    this.current_municipality = municipality
    this.current_state = state

    that.polygonService.getLocalities(localidad_urbana_cvegeo).subscribe(data => {
      that.spinner.hide();

      that.updatePoblation(data);
      that.updatePoverty(data);
      that.updateInfra(data);
      that.updateVunerability(data);
      that.showButton();
      //colorcar una bandera para este caso de projection 2020
      that.showlegendInfo["projection2020"] = true;
      that.showlegendInfo["poverty"] = true;
      that.showlegendInfo["mortalityLocation"] = false;
      that.showlegendInfo["generalData"] = false;

      if (data['mortality_info']) {
        that.updateMortality(data);
        that.showlegendInfo["mortality"] = false;
      } else {
        const municipio_cvegeo = that.select_municipality.properties.municipio_cvegeo
        that.polygonService.getMunicipalities(municipio_cvegeo).subscribe(data => {
          if (data['mortality_info']) {
            that.updateMortality(data);
            that.showlegendInfo["mortality"] = true;
          }
        })
      }

      that.clearPolygons('select_ageb');
      that.clearAllMarkers();

      let polygon_array = [];
      data["agebs"].forEach(element => {
        let newPolygon = {
          "type": "Feature",
          "properties": {
            "ageb_urbana_cvegeo": element['ageb_urbana_cvegeo']
          },
          "geometry": JSON.parse(element.geojson)
        }
        polygon_array.push(newPolygon);
      });

      that.polygons['select_ageb'] = L.geoJSON(polygon_array, {
        style: locality_style,
        onEachFeature: function (feature, layer) {
          layer.on('mouseover', (e) => {
            if (that.select_ageb == undefined || that.select_ageb.properties.ageb_urbana_cvegeo != feature.properties.ageb_urbana_cvegeo) {
              if (!that.showLayerWms) {
                layer.setStyle({
                  "color": '#a7d60d',
                  "opacity": 1,
                  "fillOpacity": 0.5,
                  "stroker": true,
                  "weight": 2
                });
              } else {
                layer.setStyle({
                  "weight": 2
                });
              }
              let ageb = feature.properties.ageb_urbana_cvegeo
              //that.info.update_ageb(ageb);
            }
          });

          layer.on('mouseout', (e) => {
            if (!that.showLayerWms) {
              layer.setStyle({
                "color": '#a7d60d',
                "opacity": 0.7,
                "fillOpacity": 0.1,
                "stroker": true,
                "weight": 1
              });
            } else {
              layer.setStyle({
                "weight": 1
              });
            }
            //that.info.update_ageb();
          });

          layer.on('click', (e) => {
            if (that.select_ageb == undefined || that.select_ageb.properties.ageb_urbana_cvegeo != feature.properties.ageb_urbana_cvegeo) {
              //that.spinner.show()
              that.map.flyToBounds(layer.getBounds(), { paddingBottomRight: [10, 10] })
              that.map.once('moveend', function (e) {
                that.loadGeoJsonAgeb(feature, layer, that)
              });
            }
          });
        }
      }).addTo(that.map);
    });
  }

  loadGeoJsonAgeb(feature, layer, that) {
    let locality_style = {
      "color": '#900dd6',
      "stroke": true,
      "opacity": 0.3,
      "weight": 1
    };

    that.nivelPolygons = "Ageb";
    that.select_ageb = feature;
    that.layer["select_ageb"] = layer;

    that.clearAllMarkers();
    that.resetbutton()

    const ageb_urbana_cvegeo = feature.properties.ageb_urbana_cvegeo;
    const ageb = "ageb";
    const localidad = that.select_locality.properties.localidad_urbana_nombre;
    const state = that.select_state.properties.entidad_nombre;
    const municipality = that.select_municipality.properties.municipio_nombre;
    //that.dataEntityName = ageb + ", " + localidad + ", " + municipality + ", " + state + ", " + "México";
    this.current_state = state;
    this.current_municipality = municipality;
    this.current_locality = localidad;

    that.polygonService.getAgeb(ageb_urbana_cvegeo).subscribe(data => {
      that.spinner.hide();
      that.updatePoblation(data);
      that.updateVunerability(data);
      that.updatePovertyAgeb(data);
      that.showlegendInfo["generalData"] = true;
      if (!that.showlegendInfo["mortality"]) {
        that.showlegendInfo["mortalityLocation"] = true;
      }
    });
  }

  updateMortality(data) {
    const mortality = data['mortality_info'];

    let grado_cancer: any          //para evitar el error al asignar cadena a número
    let grado_cardiacas: any
    let grado_diabetes: any
    let grado_pulmonares: any

    /* 	if(mortality.grado_cancer == 0 || isNaN(mortality.grado_cancer))
        grado_cancer = "No hay datos"
      else */

    if (mortality == undefined) {
      grado_cancer = "No hay datos";
      grado_cardiacas = "No hay datos";
      grado_diabetes = "No hay datos";
      grado_pulmonares = "No hay datos";
    }
    else {
      grado_cancer = mortality.grado_cancer;
      grado_cardiacas = mortality.grado_cardiacas;
      grado_diabetes = mortality.grado_diabetes;
      grado_pulmonares = mortality.grado_pulmonares
    }

    this.mortalityData.gradoCancer.total = grado_cancer;
    this.mortalityData.gradoCardiacas.total = grado_cardiacas;
    this.mortalityData.gradoDiabetes.total = grado_diabetes;
    this.mortalityData.gradoPulmonares.total = grado_pulmonares;

    if (mortality != undefined)
      this.mortalityRateChartData = [
        {
          "name": "Cancer",
          "value": mortality.tasa_cancer,
          "color": "#0f1dd9"
        }, {
          "name": "Cardiaca",
          "value": mortality.tasa_cardiacas,
          "color": "#d90f0f"
        }, {
          "name": "Diabetes",
          "value": mortality.tasa_diabetes,
          "color": "#0fd3d9"
        }, {
          "name": "Pulmonar",
          "value": mortality.tasa_pulmonares,
          "color": "#088a22"
        }
      ];
    this.initChartMortality()
  }

  updatePovertyAgeb(data) {
    const poverty = data['poverty_range'];
    if (data['poverty_range']) {
      const povRange: any = poverty.pov_range;
      const message: any = "No hay datos"

      if (povRange.includes("[") || povRange.includes("(")) {
        let range = povRange;
        let rangeValues = range.split(',');
        const min = rangeValues[0].slice(1).trim();
        const max = rangeValues[1].slice(0, -1).trim();

        this.vulDataAgeb.povRange.total = 0;
        this.vulDataAgeb.povRange.min = min;
        this.vulDataAgeb.povRange.max = max;
      } else {
        this.vulDataAgeb.povRange.total = message;
      }
    } else {
      const message: any = "No hay datos";
      this.vulDataAgeb.povRange.total = message;
    }
  }


  updateExposition(data) {

    //  console.log("updateExposition")
    const expositionData = data['covid_exposure'];

    let exposicion: any
    let exposicion_salud: any
    let exposicion_infra: any

    if (expositionData != undefined) {
      exposicion = parseFloat(expositionData[0].index_gen).toFixed(4);
      exposicion_salud = parseFloat(expositionData[0].index_salu).toFixed(4);
      exposicion_infra = parseFloat(expositionData[0].index_infr).toFixed(4);

      this.expositionData.exposicion.total = exposicion;
      this.expositionData.exposicion.label = this.getLabelForExposition(exposicion);

      this.expositionData.exposicionSalud.total = exposicion_salud;
      this.expositionData.exposicionSalud.label = this.getLabelForExposition(exposicion_salud);

      this.expositionData.exposicionInfra.total = exposicion_infra;
      this.expositionData.exposicionInfra.label = this.getLabelForExposition(exposicion_infra);
    } else {
      const message: any = "No hay datos";
      this.expositionData.exposicion.total = message;
      this.expositionData.exposicion.label = message;
      this.expositionData.exposicionSalud.total = message;
      this.expositionData.exposicionSalud.label = message;
      this.expositionData.exposicionInfra.total = message;
      this.expositionData.exposicionInfra.label = message;
    }
  }

  getLabelForExposition(exposition) {
    if (exposition >= -2.15 && exposition < -1.04) {
      return 'Muy alto';
    } else {
      if (exposition >= -1.04 && exposition < -0.79) {
        return 'Alto';
      } else {
        if (exposition >= -0.79 && exposition < -0.43) {
          return 'Medio';
        } else {
          if (exposition >= -0.43 && exposition < -0.05) {
            return 'Bajo';
          } else {
            if (exposition >= -0.05 && exposition <= 2.45) {
              return 'Muy bajo';
            }
          }
        }
      }
    }
  }

  updatePoverty(data) {

    if (this.nivelPolygons == 'Localidad' || this.nivelPolygons == 'ZonaLocalidad') {
      //if(this.nivelPolygons == 'Localidad' || this.nivelPolygons == 'ZonaLocalidad' || this.nivelPolygons == 'ZonaAgeb' || this.nivelPolygons == 'Ageb')
      if (this.povertyChart != undefined) {
        this.povertyChart.children.values[0].text = "% de pobreza (municipio)";
      }

      return
    }

    const poverty = data['poverty_info'];

    let pobreza: any;
    let pobrezaExtrema: any;
    let pobrezaSalud: any;
    let pobrezaServicio: any;
    let pobrezaAlimentos: any;

    //validación para pobreza
    if (poverty.pobreza == 0 || isNaN(poverty.pobreza)) {
      pobreza = "No hay datos"
      this.povertyData.pobreza.total = pobreza;
    }
    else {
      pobreza = poverty.pobreza * 100;
      this.povertyData.pobreza.total = parseFloat(pobreza.toFixed(2));
    }

    //validación para pobreza extrema
    if (poverty.pob_ext == 0 || isNaN(poverty.pob_ext)) {
      pobrezaExtrema = "No hay datos"
      this.povertyData.pobrezaExtrema.total = pobrezaExtrema;
    }
    else {
      pobrezaExtrema = poverty.pob_ext * 100;
      this.povertyData.pobrezaExtrema.total = parseFloat(pobrezaExtrema.toFixed(2));
    }

    //validación para pobreza/carencia en salud
    if (poverty.pob_salud == 0 || isNaN(poverty.pob_salud)) {
      pobrezaSalud = "No hay datos"
      this.povertyData.pobrezaSalud.total = pobrezaSalud;
    }
    else {
      pobrezaSalud = poverty.pob_salud * 100;
      this.povertyData.pobrezaSalud.total = parseFloat(pobrezaSalud.toFixed(2));
    }

    //validación para pobreza servicios
    if (poverty.pob_servic == 0 || isNaN(poverty.pob_servic)) {
      pobrezaServicio = "No hay datos"
      this.povertyData.pobrezaServicio.total = pobrezaServicio;
    }
    else {
      pobrezaServicio = poverty.pob_servic * 100;
      this.povertyData.pobrezaServicio.total = parseFloat(pobrezaServicio.toFixed(2));
    }

    //validación para pobreza alimentos
    if (poverty.pob_alimen == 0 || isNaN(poverty.pob_alimen)) {
      pobrezaAlimentos = "No hay datos"
      this.povertyData.pobrezaAlimentos.total = pobrezaServicio;
    }
    else {
      pobrezaAlimentos = poverty.pob_alimen * 100;
      this.povertyData.pobrezaAlimentos.total = parseFloat(pobrezaAlimentos.toFixed(2));
    }

    this.povertyChartData = [
      {
        title: "Pobreza",
        count: this.povertyData.pobreza.total
      },
      {
        title: "Pobreza extrema",
        count: this.povertyData.pobrezaExtrema.total
      },
      {
        title: "Carencia en salud",
        count: this.povertyData.pobrezaSalud.total
      },
      {
        title: "Carencia en servicios",
        count: this.povertyData.pobrezaServicio.total
      },
      {
        title: "Carencia en alimentos",
        count: this.povertyData.pobrezaAlimentos.total
      }
    ];
    this.initChartPoverty();

    //pobreza = poverty.pobreza * 100;
    //pobrezaExtrema = poverty.pob_ext * 100;
    //pobrezaSalud = poverty.pob_salud * 100;
    //pobrezaServicio = poverty.pob_servic * 100;
    //pobrezaAlimentos = poverty.pob_alimen * 100;


    //this.vulData.pobreza.total = pobreza.toFixed(2);
    //this.vulData.pobrezaExtrema.total = pobrezaExtrema.toFixed(2);
    //this.vulData.pobrezaSalud.total = pobrezaSalud.toFixed(2);
    //this.vulData.pobrezaServicio.total = pobrezaServicio.toFixed(2);
    //this.vulData.pobrezaAlimentos.total = pobrezaAlimentos.toFixed(2);

    /*     this.vulData.pobreza.total = parseFloat(parseFloat(parseFloat(poverty.pobreza)*100).toFixed(2));
        this.vulData.pobrezaExtrema.total = parseFloat(parseFloat(parseFloat(poverty.pob_ext)*100).toFixed(2));
        this.vulData.pobrezaSalud.total = parseFloat(parseFloat(parseFloat(poverty.pob_salud)*100).toFixed(2));
        this.vulData.pobrezaServicio.total = parseFloat(parseFloat(parseFloat(poverty.pob_servic)*100).toFixed(2));
        this.vulData.pobrezaAlimentos.total = parseFloat(parseFloat(parseFloat(poverty.pob_alimen)*100).toFixed(2)); */
  }

  updateProjection2020(data) {
    const projection2020 = data['projection_2020_info'];

    this.pobData2020.projection2020.total = parseInt(projection2020.pob2020);
    this.pobData2020.projection2020under4.total = parseInt(projection2020.pob_0a4);
    this.pobData2020.projection2020over60.total = parseInt(projection2020.pob60ym);

    this.projectionChartData = [
      {
        title: "Mayores de 60 años",
        count: parseInt(projection2020.pob60ym)
      },
      {
        title: "Menores de 4 años",
        count: parseInt(projection2020.pob_0a4)
      },
      {
        title: "Resto de la población",
        count: parseInt(projection2020.pob2020) - parseInt(projection2020.pob_0a4) - parseInt(projection2020.pob60ym)
      }
    ];
    this.initChartProjection();
  }

  updatePoblation(data) {
    const populationState = data['poblation_info'];
    const pob_total = parseInt(populationState.pob_total)
    const mayores_65 = parseInt(populationState.mayores_65)
    const pob_menores_5 = parseInt(populationState.pob_menores_5)
    const message: any = "No hay datos"

    if (pob_total >= 0) {
      this.pobData.pobTotal.total = pob_total;
    } else {
      this.pobData.pobTotal.total = message
    }

    if (mayores_65 >= 0) {
      this.pobData.over65.total = mayores_65;
    } else {
      this.pobData.over65.total = message
    }

    if (pob_menores_5 >= 0) {
      this.pobData.under5.total = pob_menores_5;
    } else {
      this.pobData.under5.total = message
    }

    if (pob_total >= 0 && mayores_65 >= 0 && pob_menores_5 >= 0) {
      const restPobl = pob_total - mayores_65 - pob_menores_5;
      this.poblChart.data = [
        ['Mayores de 65 años', mayores_65],
        ['Menores de 5 años', pob_menores_5],
        ['Resto de la población', restPobl]
      ];

      this.populationChartData = [
        {
          title: "Mayores de 65 años",
          count: parseInt(populationState.mayores_65)
        },
        {
          title: "Menores de 5 años",
          count: parseInt(populationState.pob_menores_5)
        },
        {
          title: "Resto de la población",
          count: restPobl
        }
      ];
      this.initChartPopulation();
    }
  }


  updateCovid(data) {
    const COVID_casos = data['casosCOVID'];
    this.covidData = {}
    let arrayAge = [];

    this.covidData['totalCases'] = {
      title: 'Casos confirmados',
      total: parseInt(COVID_casos.total),
      logo: 'icon-corona'
    }

    this.covidData['totalGender'] = {
      title: 'Confirmados por sexo',
      totalMen: parseInt(COVID_casos.cont_hombres),
      totalWomen: parseInt(COVID_casos.cont_mujeres),
      menPct: parseInt(COVID_casos.cont_hombres) * 100 / parseInt(COVID_casos.total),
      womenPct: parseInt(COVID_casos.cont_mujeres) * 100 / parseInt(COVID_casos.total),
      logoMen: 'icon-male',
      logoWomen: 'icon-female',
      logo: 'fas fa-venus-mars'
    };

    this.covidData['minmaxAges'] = {
      title: 'Edades mínima y máxima',
      edadMinima: parseInt(COVID_casos.edad_minima),
      edadMaxima: parseInt(COVID_casos.edad_maxima),
      logoEdadMinima: 'icon-baby',
      logoEdadMaxima: 'icon-old',
      logo: 'fas fa-users'
    };

    arrayAge.push(
      {
        category: "0 a 10",
        value1: parseInt(COVID_casos.h_10),
        value2: parseInt(COVID_casos.m_10),
        total: parseInt(COVID_casos.edad_0_10)
      },
      {
        category: "11 a 20",
        value1: parseInt(COVID_casos.h_20),
        value2: parseInt(COVID_casos.m_20),
        total: parseInt(COVID_casos.edad_11_20)
      },
      {
        category: "21 a 30",
        value1: parseInt(COVID_casos.h_30),
        value2: parseInt(COVID_casos.m_30),
        total: parseInt(COVID_casos.edad_21_30)
      },
      {
        category: "31 a 40",
        value1: parseInt(COVID_casos.h_40),
        value2: parseInt(COVID_casos.m_40),
        total: parseInt(COVID_casos.edad_31_40)
      },
      {
        category: "41 a 50",
        value1: parseInt(COVID_casos.h_50),
        value2: parseInt(COVID_casos.m_50),
        total: parseInt(COVID_casos.edad_41_50)
      },
      {
        category: "51 a 60",
        value1: parseInt(COVID_casos.h_60),
        value2: parseInt(COVID_casos.m_60),
        total: parseInt(COVID_casos.edad_51_60)
      },
      {
        category: "61 a 70",
        value1: parseInt(COVID_casos.h_70),
        value2: parseInt(COVID_casos.m_70),
        total: parseInt(COVID_casos.edad_61_70)
      },
      {
        category: "71 a 80",
        value1: parseInt(COVID_casos.h_80),
        value2: parseInt(COVID_casos.m_80),
        total: parseInt(COVID_casos.edad_71_80)
      },
      {
        category: "81 a 90",
        value1: parseInt(COVID_casos.h_90),
        value2: parseInt(COVID_casos.m_90),
        total: parseInt(COVID_casos.edad_81_90)
      },
      {
        category: "91 o más",
        value1: parseInt(COVID_casos.h_91),
        value2: parseInt(COVID_casos.m_91),
        total: parseInt(COVID_casos.edad_91_mas)
      }
    )

    this.initCovidAgesChart(arrayAge, parseInt(COVID_casos.total))

  }


  countCovidbyState(data) {
    const COVID_casos_estado = data['casosEstado'];

    COVID_casos_estado.forEach(state => {
      //console.log(state['entidad_name'])
      //console.log(state['total'])
      this.covidCasesByState[state['entidad_name']] = {
        title: state['entidad_name'],
        total: state['total']
      }
    });
  }


  updateInfraSedesa(data) {

    //actualiza tarjeta de laboratorios
    //console.log("updateInfraSedesa")
    const labs = data['labs'];
    this.redSedesa.labs.total = labs.total;

    //actualiza tarjeta de hospitales red sedesa
    const redSedesa = data['sedesa_hospitals']
    if (redSedesa != undefined) {
      //console.log(redSedesa.length)
      this.redSedesa.sedesa.total = redSedesa.length
    }

    //actualiza tarjeta de carpas y ventiladores
    const covid_ventilators = data['covid_ventilators'];
    if (covid_ventilators != undefined) {
      if (covid_ventilators.ventiladores_ss != null)
        this.redSedesa.ventilators.total = parseInt(covid_ventilators.ventiladores_ss);
      else
        this.redSedesa.ventilators.total = 0;

      if (covid_ventilators.ventiladores_clues != null)
        this.sedesaOtrasInstituciones.ventilatorsClues.total = parseInt(covid_ventilators.ventiladores_clues);
      else
        this.sedesaOtrasInstituciones.ventilatorsClues.total = 0;


      if (covid_ventilators.carpas != null)
        this.redSedesa.carpas.total = parseInt(covid_ventilators.carpas);
      else
        this.redSedesa.carpas.total = 0;
    }

    //actualiza tarjeta de camas
    const camasSedesa = data['beds_count_sedesa']
    let total_camas_de_recuperacion = 0;
    let total_camas_de_camas_censables_sedesa = 0;
    let total_camas_no_censables_sedesa = 0;
    let total_camas_ti_adultos = 0;
    let total_camas_ti_pediatrica = 0;
    let total_camas_uci_neonatal = 0;
    let total_camas_uti = 0;
    let childrenCamas = [];

    if (camasSedesa.total_camas_de_recuperacion != null)
      total_camas_de_recuperacion = parseInt(camasSedesa.total_camas_de_recuperacion)
    if (camasSedesa.total_camas_de_camas_censables_sedesa != null)
      total_camas_de_camas_censables_sedesa = parseInt(camasSedesa.total_camas_de_camas_censables_sedesa)
    if (camasSedesa.total_camas_no_censables_sedesa != null)
      total_camas_no_censables_sedesa = parseInt(camasSedesa.total_camas_no_censables_sedesa)
    if (camasSedesa.total_camas_ti_adultos != null)
      total_camas_ti_adultos = parseInt(camasSedesa.total_camas_ti_adultos)
    if (camasSedesa.total_camas_ti_pediatrica != null)
      total_camas_ti_pediatrica = parseInt(camasSedesa.total_camas_ti_pediatrica)
    if (camasSedesa.total_camas_uci_neonatal != null)
      total_camas_uci_neonatal = parseInt(camasSedesa.total_camas_uci_neonatal)
    if (camasSedesa.total_camas_uti != null)
      total_camas_uti = parseInt(camasSedesa.total_camas_uti)

    childrenCamas.push({
      name: 'Camas de recuperación',
      value: total_camas_de_recuperacion
    })
    childrenCamas.push({
      name: 'Camas Censables',
      value: total_camas_de_camas_censables_sedesa
    })
    childrenCamas.push({
      name: 'Camas no censables',
      value: total_camas_no_censables_sedesa
    })
    childrenCamas.push({
      name: 'Camas adultos',
      value: total_camas_ti_adultos
    })
    childrenCamas.push({
      name: 'Camas pediatricas',
      value: total_camas_ti_pediatrica
    })
    childrenCamas.push({
      name: 'Unidad de Cuidados Intensivos Neonatal',
      value: total_camas_uci_neonatal
    })
    childrenCamas.push({
      name: 'Camas Unidad de Terapia Intermedia',
      value: total_camas_uti
    })

    this.redSedesa.camas.total = total_camas_de_recuperacion + total_camas_de_camas_censables_sedesa + total_camas_no_censables_sedesa + total_camas_ti_adultos + total_camas_ti_pediatrica + total_camas_uci_neonatal + total_camas_uti
    this.redSedesa.camas.children = childrenCamas;

    //actualiza tarjeta de recursos humanos
    const hrSedesa = data['human_resources_count_sedesa']
    let total_neumologos = 0;
    let total_internistas = 0;
    let total_anestesiologos = 0;
    let total_nefrolos = 0;
    let total_tecnico_en_inaloterapia = 0;
    let total_medicos_generales = 0;
    let total_personal_enfermeria = 0;
    let total_residentes = 0;
    let total_especialistas = 0;
    let childrenHR = [];

    if (hrSedesa.total_neumologos != null)
      total_neumologos = parseInt(hrSedesa.total_neumologos)
    if (hrSedesa.total_internistas != null)
      total_internistas = parseInt(hrSedesa.total_internistas)
    if (hrSedesa.total_anestesiologos != null)
      total_anestesiologos = parseInt(hrSedesa.total_anestesiologos)
    if (hrSedesa.total_nefrolos != null)
      total_nefrolos = parseInt(hrSedesa.total_nefrolos)
    if (hrSedesa.total_tecnico_en_inaloterapia != null)
      total_tecnico_en_inaloterapia = parseInt(hrSedesa.total_tecnico_en_inaloterapia)
    if (hrSedesa.total_medicos_generales != null)
      total_medicos_generales = parseInt(hrSedesa.total_medicos_generales)
    if (hrSedesa.total_personal_enfermeria != null)
      total_personal_enfermeria = parseInt(hrSedesa.total_personal_enfermeria)
    if (hrSedesa.total_residentes != null)
      total_residentes = parseInt(hrSedesa.total_residentes)
    if (hrSedesa.total_especialistas != null)
      total_especialistas = parseInt(hrSedesa.total_especialistas)

    childrenHR.push({
      name: 'Neumólogos',
      value: total_neumologos
    })
    childrenHR.push({
      name: 'Internistas',
      value: total_internistas
    })
    childrenHR.push({
      name: 'Anestesiólogos',
      value: total_anestesiologos
    })
    childrenHR.push({
      name: 'Nefrólogos',
      value: total_nefrolos
    })
    childrenHR.push({
      name: 'Técnicos en inhaloterapia',
      value: total_tecnico_en_inaloterapia
    })
    childrenHR.push({
      name: 'Médicos generales',
      value: total_medicos_generales
    })
    childrenHR.push({
      name: 'Residentes totales',
      value: total_residentes
    })
    childrenHR.push({
      name: 'Personal de enfermería',
      value: total_personal_enfermeria
    })

    this.redSedesa.recursosHum.total = total_neumologos + total_internistas + total_anestesiologos + total_nefrolos + total_tecnico_en_inaloterapia + total_medicos_generales + total_residentes + total_personal_enfermeria
    this.redSedesa.recursosHum.children = childrenHR;


    //actualiza tarjeta de consultorios
    const consultoriosSedesa = data['consultorios_count_sedesa']
    let total_de_consultorios = 0;
    let total_consultorios_de_med_gral = 0;
    let total_consultorios_en_otras_areas = 0;
    let childrenConsultorios = [];

    if (consultoriosSedesa.total_de_consultorios != null)
      total_de_consultorios = parseInt(consultoriosSedesa.total_de_consultorios)
    if (consultoriosSedesa.total_consultorios_de_med_gral != null)
      total_consultorios_de_med_gral = parseInt(consultoriosSedesa.total_consultorios_de_med_gral)
    if (consultoriosSedesa.total_consultorios_en_otras_areas != null)
      total_consultorios_en_otras_areas = parseInt(consultoriosSedesa.total_consultorios_en_otras_areas)

    childrenConsultorios.push({
      name: 'Consultorios totales',
      value: total_de_consultorios
    })
    childrenConsultorios.push({
      name: 'Consultorios medicina general',
      value: total_consultorios_de_med_gral
    })
    childrenConsultorios.push({
      name: 'Consultorios especialidades',
      value: total_consultorios_en_otras_areas
    })

    this.redSedesa.consultorios.total = total_de_consultorios;
    this.redSedesa.consultorios.children = childrenConsultorios;

  }


  updateInfra(data) {
    const labs = data['labs'];
    this.generalData.labs.total = labs.total;

    const officesState = data['drugs_offices_info'];
    /* this.generalData.publicDoctors.total = officesState.consultorios_publicos;
    this.generalData.privateDoctors.total = officesState.consultorios_privados;
    this.generalData.pharmacies.total = officesState.farmacias; */

    // const hospitals = data['hospitals_info'];
    // this.generalData.publicHospitals.total = hospitals.total_hospitales_publicos;
    // this.generalData.privateHospitals.total = hospitals.hospitales_privados;
    //this.generalData.ventilators.total = hospitals.total_de_ventiladores_ssa;

    //console.log(data)

    if (this.cdmx_mode) {
      const medicos = data['doctors_count']
      let childrenMedicos = [];
      if (medicos.total_medicos != null)
        this.generalData.medicos.total = parseInt(medicos.total_medicos);
      else
        this.generalData.medicos.total = 0;


      if (medicos.total_especialistas != null) {
        let especial = {
          name: 'Especialistas',
          realValue: parseInt(medicos.total_especialistas)
        };

        childrenMedicos.push(especial);
      }

      if (medicos.total_residentes != null) {
        let resident = {
          name: 'Residentes',
          realValue: parseInt(medicos.total_residentes)
        };

        childrenMedicos.push(resident);
      }
      this.generalData.medicos.children = childrenMedicos;

      const redSedesa = data['sedesa_hospitals']
      if (redSedesa != undefined) {
        //console.log(redSedesa.length)
        this.generalData.sedesa.total = redSedesa.length
      }

    }

    const covid_ventilators = data['covid_ventilators'];
    if (covid_ventilators != undefined) {
      if (covid_ventilators.ventiladores_ss != null)
        this.generalData.ventilators.total = parseInt(covid_ventilators.ventiladores_ss);
      else
        this.generalData.ventilators.total = 0;


      if (covid_ventilators.ventiladores_clues != null)
        this.generalData.ventilatorsClues.total = parseInt(covid_ventilators.ventiladores_clues);
      else
        this.generalData.ventilators.total = 0;


      if (covid_ventilators.carpas != null)
        this.generalData.carpas.total = parseInt(covid_ventilators.carpas);
      else
        this.generalData.carpas.total = 0;

      if (covid_ventilators.total_camas != null)
        this.generalData.camas.total = parseInt(covid_ventilators.total_camas);
      else
        this.generalData.camas.total = 0;

      if (covid_ventilators.camas_uci != null)
        this.generalData.camasUci.total = parseInt(covid_ventilators.camas_uci);
      else
        this.generalData.camasUci.total = 0;

    }

    let covid_hospitals_imss = 0;
    let covid_hospitals_issste = 0;
    let covid_hospitals_ss = 0;
    let covid_hospitals_sedena = 0;
    let covid_hospitals_semar = 0;
    let covid_hospitals_total = 0;
    let covidHospitalsChildren = [];

    let colors_intitution = {
      SEDENA: '#96bcb4',
      SEMAR: '#bbdcd3',
      SEDESA: '#b2ced6',
      SSA: '#b2ced6',
      IMSS: '#9dbbc9',
      ISSTE: '#91accb',
      ISSSTE: '#91accb'
    };

    const covid_hospitals = data['covid_hospitals'];
    if (covid_hospitals != undefined) {
      //console.log('covid_hospitals')
      //console.log(covid_hospitals)


      this.generalData.covidHospitals.total = covid_hospitals.total;
      covid_hospitals_imss = parseInt(covid_hospitals.imss);
      covid_hospitals_issste = parseInt(covid_hospitals.issste);
      covid_hospitals_ss = parseInt(covid_hospitals.ss);
      covid_hospitals_sedena = parseInt(covid_hospitals.sedena);
      covid_hospitals_semar = parseInt(covid_hospitals.semar);
      covid_hospitals_total = this.generalData.covidHospitals.total


      const escalaHijos = scaleSqrt() //escala para evitar que los muy pequeños no se vean en la gráfica
        .domain([0, covid_hospitals_total])
        //.domain([0, ])
        .range([0, 100]);



      for (const key in covid_hospitals) {
        if (key !== 'total') {
          if (covid_hospitals[key] !== '0') {
            let child = {
              name: key.toUpperCase(),
              value: escalaHijos(parseInt(covid_hospitals[key])),
              realValue: parseInt(covid_hospitals[key]),
              color: colors_intitution[key.toUpperCase()],
            };

            covidHospitalsChildren.push(child);
          }
        }
      }

      /*
            const escalaHijos = scaleSqrt() //escala para evitar que los muy pequeños no se vean en la gráfica
              //.domain([0, Math.max(parseInt(hospitals.hospitales_privados),parseInt(hospitals.total_hospitales_publicos),covid_hospitals_total)])
              .domain([0, parseInt(hospitals.hospitales_privados) + parseInt(hospitals.total_hospitales_publicos), covid_hospitals_total])
              //.domain([0, ])
              .range([0, 100]);
      
             this.hospitalsChartData = [
              {
                name: 'Hospitales COVID',
                realValue: covid_hospitals_total,
                color: '#799f2b',
                children: []
              }
            ];
      
            for (const key in covid_hospitals) {
              if (key !== 'total') {
                if (covid_hospitals[key] !== '0') {
                  let child = {
                    name: key.toUpperCase(),
                    value: escalaHijos(parseInt(covid_hospitals[key])),
                    realValue: parseInt(covid_hospitals[key])
                  };
      
                  this.hospitalsChartData[0].children.push(child);
                }
              }
            }
      
            let hospitalPublicChartData = {
              name: 'Hospitales públicos',
              realValue: parseInt(hospitals.total_hospitales_publicos),
              color: '#3832FF',
              children: []
            };
      
            this.hospitalsChartData.push(hospitalPublicChartData);
      
            //console.log("public hospitals")
            //console.log(hospitals)
      
            if (hospitals.hospitales_imss !== '0') {
              let child = {
                name: 'IMSS',
                value: escalaHijos(parseInt(hospitals.hospitales_imss)),
                realValue: parseInt(hospitals.hospitales_imss)
              };
      
              this.hospitalsChartData[1].children.push(child);
            }
      
            if (hospitals.hospitales_issste !== '0') {
              let child = {
                name: 'ISSSTE',
                value: escalaHijos(parseInt(hospitals.hospitales_issste)),
                realValue: parseInt(hospitals.hospitales_issste)
              };
      
              this.hospitalsChartData[1].children.push(child);
            }
      
            if (hospitals.hospitales_ssa !== '0') {
              let child = {
                name: 'SSA',
                value: escalaHijos(parseInt(hospitals.hospitales_ssa)),
                realValue: parseInt(hospitals.hospitales_ssa)
              };
      
              this.hospitalsChartData[1].children.push(child);
            }
      
            if (hospitals.hospitales_sme !== '0') {
              let child = {
                name: 'SME',
                value: escalaHijos(parseInt(hospitals.hospitales_sme)),
                realValue: parseInt(hospitals.hospitales_sme)
              };
      
              this.hospitalsChartData[1].children.push(child);
            }
      
            if (hospitals.hospitales_semar !== '0') {
              let child = {
                name: 'SEMAR',
                value: escalaHijos(parseInt(hospitals.hospitales_semar)),
                realValue: parseInt(hospitals.hospitales_semar)
              };
      
              this.hospitalsChartData[1].children.push(child);
            }
      
            if (hospitals.hospitales_sedena !== '0') {
              let child = {
                name: 'SEDENA',
                value: escalaHijos(parseInt(hospitals.hospitales_sedena)),
                realValue: parseInt(hospitals.hospitales_sedena)
              };
      
              this.hospitalsChartData[1].children.push(child);
            }
      
            if (hospitals.hospitales_pemex !== '0') {
              let child = {
                name: 'PEMEX',
                value: escalaHijos(parseInt(hospitals.hospitales_pemex)),
                realValue: parseInt(hospitals.hospitales_pemex)
              };
      
              this.hospitalsChartData[1].children.push(child);
            }
      
      
            //como no tiene hijos su valor se convierte en la suma de las escalas de sus siete 'hijos virtuales'
            let virtualChildren = parseInt(hospitals.hospitales_privados) / this.hospitalsChartData[1].children.length // el mismo número de hijos que tanga hospitales públicos
            let hospitalPrivateChartData = {
              name: 'Hospitales privados',
              //value: escalaHijos(parseInt(hospitals.hospitales_privados)),
              //value: escalaHijos(parseInt(hospitals.hospitales_privados)/2)+escalaHijos(parseInt(hospitals.hospitales_privados)/2),
              value: escalaHijos(virtualChildren) * this.hospitalsChartData[1].children.length,
              realValue: parseInt(hospitals.hospitales_privados),
              color: '#169743'
            };
      
            this.hospitalsChartData.push(hospitalPrivateChartData);
      
            this.hospitalsChartData = this.deleteEmptyHospitals(this.hospitalsChartData); */
    }

    const covVentInst = data['covid_ventilators_institutions'];

    let bedsForInst = [];
    let ventForInst = [];

    let camas_sedesa = 0;
    let ventiladores_sedesa = 0;

    if (covVentInst != undefined) {
      this.ventilatorsChartData = [];

      //console.log(covVentInst)
      let max_camas = 0;
      for (let i = 0; i < covVentInst.length; i++) {
        if (parseInt(covVentInst[i].total_de_camas) > max_camas)
          max_camas = parseInt(covVentInst[i].total_de_camas)
      }

      const escalaHijosVent = scaleSqrt() //escala para evitar que los muy pequeños no se vean en la gráfica
        .domain([0, max_camas])
        //.domain([0, ])
        .range([0, 10]);

      covVentInst.forEach(institution => {
        // console.log(institution)

        if (institution.siglas_institucion !== 'RED SEDESA') {

          /* 		  if(institution.siglas_institucion == 'SEDESA' && this.cdmx_mode == false){
                camas_sedesa = parseInt(institution.total_de_camas)
                ventiladores_sedesa = parseInt(institution.total_de_ventiladores)
                
                }
                  
                else{  */

          if (institution.total_de_camas !== '0') {
            let bedsInst = {
              name: institution.siglas_institucion,
              realValue: parseInt(institution.total_de_camas)
            };

            bedsForInst.push(bedsInst);
          }

          if (institution.total_de_ventiladores !== '0') {
            let ventInst = {
              name: institution.siglas_institucion,
              realValue: parseInt(institution.total_de_ventiladores)
            };

            ventForInst.push(ventInst);
          }

          let instData = {
            name: institution.siglas_institucion,
            color: colors_intitution[institution.siglas_institucion],
            realValue: parseInt(institution.total_de_camas) + parseInt(institution.total_de_ventiladores),
            children: []
            /*          children: [
                 {
                   name: 'Camas',
                   value: parseInt(institution.total_de_camas),
                   realValue: parseInt(institution.total_de_camas)
                 },
                 {
                   name: 'Ventiladores',
                   value: parseInt(institution.total_de_ventiladores),
                   realValue: parseInt(institution.total_de_ventiladores)
                 }
                 ] */
          };

          if (parseInt(institution.total_de_camas) > 0) {
            let children_camas =
            {
              name: 'Camas',
              value: escalaHijosVent(parseInt(institution.total_de_camas)),
              realValue: parseInt(institution.total_de_camas)
            }
            instData.children.push(children_camas);
          }

          if (parseInt(institution.total_de_ventiladores) > 0) {
            let children_ventiladores =
            {
              name: 'Ventiladores',
              value: escalaHijosVent(parseInt(institution.total_de_ventiladores)),
              realValue: parseInt(institution.total_de_ventiladores)
            }
            instData.children.push(children_ventiladores);
          }

          this.ventilatorsChartData.push(instData);
          //}

        }
      });

      if (this.ventilatorsChartData.length === 0) {
        this.emptyInfrastructure = true;
      } else {
        this.emptyInfrastructure = false;
      }
    }

    /*
        const infraestructureData = [officesState.farmacias, officesState.consultorios_publicos, officesState.consultorios_privados, hospitals.total_hospitales_publicos, hospitals.hospitales_privados, hospitals.total_de_ventiladores_ssa];
        if (this.nivelPolygons == "Country") {
          this.infraInfoCountry = infraestructureData;
        }
    
        if (this.nivelPolygons == 'Country' || this.nivelPolygons == 'UrbanAreas') {
          this.hospitalsChartData_aux = this.hospitalsChartData;
          this.ventilatorsChartData_aux = this.ventilatorsChartData;
        }
    
         this.infraestructureChartData = [
          {
            "name": "Farmacias",
            "value": officesState.farmacias,
            "color": "#ce574f"
          },
          {
            "name": "Consultorios públicos",
            "value": officesState.consultorios_publicos,
            "color": "#89d3c8"
          },
          {
            "name": "Consultorios privados",
            "value": officesState.consultorios_privados,
            "color": "#b933d5"
          },
          {
            "name": "Hospitales COVID",
            "value": this.generalData.covidHospitals.total,
            "color": "#799f2b"
          },
          {
            "name": "Hospitales públicos",
            "value": hospitals.total_hospitales_publicos,
            "color": "#3832FF"
          },
          {
            "name": "Hospitales privados",
            "value": hospitals.hospitales_privados,
            "color": "#169743"
          },
          {
            "name": "Laboratorios",
            "value": labs.total,
            "color": "#bfb441"
          }] */

    //this.initChartInfra(infraestructureData)

    // this.initChartHospitals()
    if (this.cdmx_mode)
      this.initChartVentilators();

    //this.generalData.covidHospitals.children = this.hospitalsChartData[0].children;
    this.generalData.covidHospitals.children = covidHospitalsChildren;
    if (this.generalData.covidHospitals.children.length === 0) {
      this.generalData.covidHospitals.showChildren = false;
    }
    this.generalData.camas.children = bedsForInst;
    // this.generalData.ventilators.children = ventForInst;
    // this.generalData.camas.children = bedsForInst;	
    this.infraestructureChartData = this.generalData.covidHospitals.children;
    this.initChartInfraestructure();

    if (this.cdmx_mode) {
      this.generalData.ventilators.children = ventForInst;
      //this.generalData.camas.children = bedsForInst;
    }
    else {
      /* 		console.log(ventForInst)
          for(let i=0;i<ventForInst.length;i++){
          	
            if(ventForInst[i].name == 'SSA'){
              console.log("SSA")
              ventForInst[i].realValue += ventiladores_sedesa;
              break;
            }
          }
        	
          for(let i=0;i<bedsForInst.length;i++){
          	
            if(bedsForInst[i].name == 'SSA'){
              console.log("SSA")
              bedsForInst[i].realValue += camas_sedesa;
              break;
            }
          }		
        	
          console.log(ventForInst); */
      this.generalData.ventilatorsClues.children = ventForInst;
      //this.generalData.camas.children = bedsForInst;
    }

  }

  deleteEmptyHospitals(hospitals) {
    let i = 0;
    while (i < hospitals.length) {
      if (hospitals[i].realValue === 0) {
        hospitals.splice(i, 1);
      } else {
        ++i;
      }
    }
    return hospitals;
  }

  updateVunerability(data) {

    // console.log(data)
    const populationState = data['poblation_info'];
    const message: any = "No hay datos"
    const sinDerechoHabiencia = parseInt(populationState.sin_derechohabiencia);
    const sinDerechoHabienciaPop = parseInt(populationState.sin_derechohabiencia_seg_pop);
    const derechoHabienciaIMSS = parseInt(populationState.derechohabientes_imss);
    const derechoHabienciaISSSTE = parseInt(populationState.derechohabientes_issste);


    const pob_total = parseInt(populationState.pob_total);

    if (sinDerechoHabienciaPop >= 0) {
      this.vulData.insabi.total = sinDerechoHabienciaPop;
    } else {
      this.vulData.insabi.total = message
    }

    if (derechoHabienciaIMSS >= 0) {
      this.vulData.imss.total = derechoHabienciaIMSS;
    } else {
      this.vulData.imss.total = message
    }

    if (derechoHabienciaISSSTE >= 0) {
      this.vulData.issste.total = derechoHabienciaISSSTE;
    } else {
      this.vulData.issste.total = message
    }

    // this.vulData.insabi.total = sinDerechoHabienciaPop;
    // this.vulData.imss.total = derechoHabienciaIMSS;
    // this.vulData.issste.total = derechoHabienciaISSSTE;
    /* if (sinDerechoHabiencia >= 0) {
      this.vulData.sinDerechoHabiencia.total = sinDerechoHabiencia;
    } else {
      this.vulData.sinDerechoHabiencia.total = message
    }
 
    if (sinDerechoHabienciaPop >= 0) {
      this.vulData.sinDerechoHabienciaPop.total = sinDerechoHabienciaPop - sinDerechoHabiencia;
    } else {
      this.vulData.sinDerechoHabienciaPop.total = message
    }
 
    if (sinDerechoHabiencia >= 0 && pob_total >= 0 && pob_total >= 0) {
      const restPoblNoRight = pob_total - sinDerechoHabienciaPop;
      this.sinDerechoHabienteChart.data = [
        ['No derechohabientes', this.vulData.sinDerechoHabiencia.total],
        ['INSABI', this.vulData.sinDerechoHabienciaPop.total],
        ['Resto de la población', restPoblNoRight]
      ];
 
      this.vulnerabilityChartData = [
        {
          title: "No derechohabientes",
          count: this.vulData.sinDerechoHabiencia.total
        },
        {
          title: "Población INSABI",
          count: this.vulData.sinDerechoHabienciaPop.total
        },
        {
          title: "Resto de la población",
          count: restPoblNoRight
        }
      ];
 
 
      this.initChartVulnerability();
    } */
  }


  updateVulnerabilityState(data) {
    const vulnerabilityState = data['vulnerability_state'];
    //console.log(vulnerabilityState)

    this.vulnerabilityStateData.muyalto.total = parseFloat(vulnerabilityState.muy_alto_porc)
    this.vulnerabilityStateData.alto.total = parseFloat(vulnerabilityState.alto_porc)
    this.vulnerabilityStateData.medio.total = parseFloat(vulnerabilityState.medio_porc)
    this.vulnerabilityStateData.bajo.total = parseFloat(vulnerabilityState.bajo_porc)
    this.vulnerabilityStateData.muybajo.total = parseFloat(vulnerabilityState.muy_bajo_porc)


    this.vulnerabilityStateChartData = [
      {
        title: "Muy alta",
        count: this.vulnerabilityStateData.muyalto.total
      },
      {
        title: "Alta",
        count: this.vulnerabilityStateData.alto.total
      },
      {
        title: "Media",
        count: this.vulnerabilityStateData.medio.total
      },
      {
        title: "Baja",
        count: this.vulnerabilityStateData.bajo.total
      },
      {
        title: "Muy baja",
        count: this.vulnerabilityStateData.muybajo.total
      }
    ];

    //this.initChartVulnerabilityState()
  }


  initControlMap(map: L.map) {
    setTimeout(() => {
      const streets = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}.png',
        {
          attribution: '&copy; <a href="https://carto.com/">Carto</a> ' +
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        });
      const noon = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}.png',
        {
          attribution: '&copy; <a href="https://carto.com/">Carto</a> ' +
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        });
      const night = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/dark_all/{z}/{x}/{y}.png',
        {
          attribution: '&copy; <a href="https://carto.com/">Carto</a> ' +
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        });

      const eco = L.tileLayer('https://cartocdn_{s}.global.ssl.fastly.net/base-eco/{z}/{x}/{y}.png',
        {
          attribution: '&copy; <a href="https://carto.com/">Carto</a> ' +
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        });

      const blue = L.tileLayer('https://cartocdn_{s}.global.ssl.fastly.net/base-flatblue/{z}/{x}/{y}.png',
        {
          attribution: '&copy; <a href="https://carto.com/">Carto</a> ' +
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        });

      const midnight = L.tileLayer('https://cartocdn_{s}.global.ssl.fastly.net/base-midnight/{z}/{x}/{y}.png',
        {
          attribution: '&copy; <a href="https://carto.com/">Carto</a> ' +
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        });

      const baseMaps = {
        noon: {
          id: 'noon',
          layer: noon,
          name: 'Claro',
          imgURL: './assets/traffic.png',
          active: true
        },
        night: {
          id: 'night',
          layer: night,
          name: 'Oscuro',
          imgURL: './assets/night.png',
          active: false
        },
        streets: {
          id: 'streets',
          layer: streets,
          name: 'Calles',
          imgURL: './assets/Streets.png',
          active: false
        },
        eco: {
          id: 'eco',
          layer: eco,
          name: 'Áreas verdes',
          imgURL: './assets/eco.PNG',
          active: false
        },
        blue: {
          id: 'blue',
          layer: blue,
          name: 'Azul',
          imgURL: './assets/blue.PNG',
          active: false
        },
        midnight: {
          id: 'midnight',
          layer: midnight,
          name: 'Medianoche',
          imgURL: './assets/midnight.PNG',
          active: false
        }
      };

      let currentMap = baseMaps.noon;

      const controlMap = this.renderer.selectRootElement('#controlMap', true);
      for (const mapName of Object.keys(baseMaps)) {
        const newMapBase = this.renderer.createElement('div');
        let htmlString = '';
        htmlString = '<div id=\'' + mapName + '\' class="baseMap ' + (mapName === 'noon' ? 'active' : '') + '" (click)="changeMap(\'' + mapName + '\')">';
        htmlString += '<div class="baseContainer">';
        htmlString += '<img class="baseImg" src="' + baseMaps[mapName].imgURL + '"/>';
        htmlString += '</div>';
        htmlString += '<span class="baseName">' + baseMaps[mapName].name + '</span>';
        htmlString += '</div>';
        newMapBase.innerHTML = htmlString;
        this.renderer.appendChild(controlMap, newMapBase);
        this.renderer.listen(newMapBase, 'click', (event) => {
          this.controlMouseDown = true;
          const selectedMap = newMapBase.firstChild.id;

          const currentDiv = document.getElementById(currentMap.id);
          currentDiv.classList.remove('active');

          const selectedDiv = document.getElementById(selectedMap);
          selectedDiv.classList.add('active');
          switch (selectedMap) {
            case 'noon':
              this.map.removeLayer(currentMap.layer);
              this.map.addLayer(baseMaps.noon.layer);
              currentMap = baseMaps.noon;
              break;
            case 'streets':
              this.map.removeLayer(currentMap.layer);
              this.map.addLayer(baseMaps.streets.layer);
              currentMap = baseMaps.streets;
              break;
            case 'night':
              this.map.removeLayer(currentMap.layer);
              this.map.addLayer(baseMaps.night.layer);
              currentMap = baseMaps.night;
              break;
            case 'eco':
              this.map.removeLayer(currentMap.layer);
              this.map.addLayer(baseMaps.eco.layer);
              currentMap = baseMaps.eco;
              break;
            case 'blue':
              this.map.removeLayer(currentMap.layer);
              this.map.addLayer(baseMaps.blue.layer);
              currentMap = baseMaps.blue;
              break;
            case 'midnight':
              this.map.removeLayer(currentMap.layer);
              this.map.addLayer(baseMaps.midnight.layer);
              currentMap = baseMaps.midnight;
              break;
          }
          this.toggleMapControl();
          if (this.select_ws != undefined) {
            this.resetTitleMapWms(this.select_ws.baseMap, this.select_ws.selectedMap);
          };
        });

      }
      controlMap.addEventListener("mouseleave", (evt) => {
        if (!this.controlMouseDown) {
          this.toggleMapControl();
        }
      });
    });
  }
  //Ciudades
  initControlMapWms(map: L.map) {
    setTimeout(() => {
      var wmsURL = 'http://idegeo.centrogeo.org.mx/geoserver/wms';

      const pobTotal = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:poblacion_ciudades',
        styles: 'poblacion_ciudades',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });

      const over65 = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:poblacion_ciudades',
        styles: 'Población de 60 y más años',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });
      const under5 = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:poblacion_ciudades',
        styles: 'Población de 0 a 4 años',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });

      const statesPoverty = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:ciudades_pobreza',
        styles: 'ciudades_pobreza',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });

      const povertyExtrem = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:ciudades_pobreza',
        styles: 'Proporción de personas en pobreza extrema',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });

      const foodPoverty = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:ciudades_pobreza',
        styles: 'Pobreza Alimentaria',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });

      const povertyServices = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:ciudades_pobreza',
        styles: 'Pobreza en Servicios',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });

      const povertyHealth = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:ciudades_pobreza',
        styles: 'Pobreza en Salud',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });

      const rasterAccessibility = this.accesibility_layer;

      this.status_wms["urbanAreas"] = {
        pobTotal: {
          id: 'pobTotal',
          layer: pobTotal,
          name: 'Población áreas urbanas',
          imgURL: './assets/wms/city/pobTotal.PNG',
          type: "Poblacion",
          active: false
        },
        over65: {
          id: 'over65',
          layer: over65,
          name: 'Población 60 y mas años',
          imgURL: './assets/wms/city/over65.PNG',
          type: "Poblacion",
          active: false
        },
        under5: {
          id: 'under5',
          layer: under5,
          name: 'Población 0 a 4 años',
          imgURL: './assets/wms/city/under5.PNG',
          type: "Poblacion",
          active: false
        },
        // statesPoverty: {
        //   id: 'statesPoverty',
        //   layer: statesPoverty,
        //   name: 'Pobreza en ciudades',
        //   imgURL: './assets/Streets.png',
        //   type: "Pobreza",
        //   active: false
        // },
        povertyExtrem: {
          id: 'povertyExtrem',
          layer: povertyExtrem,
          name: 'Pobreza extrema',
          imgURL: './assets/wms/city/povExt.PNG',
          type: "Pobreza",
          active: false
        },
        // foodPoverty: {
        //   id: 'foodPoverty',
        //   layer: foodPoverty,
        //   name: 'Pobreza Alimentaria',
        //   imgURL: './assets/Streets.png',
        //   type: "Pobreza",
        //   active: false
        // },
        povertyServices: {
          id: 'povertyServices',
          layer: povertyServices,
          name: 'Carencia en servicios',
          imgURL: './assets/wms/city/povServ.PNG',
          type: "Pobreza",
          active: false
        },
        povertyHealth: {
          id: 'povertyHealth',
          layer: povertyHealth,
          name: 'Carencia en salud',
          imgURL: './assets/wms/city/povHealth.PNG',
          type: "Pobreza",
          active: false
        }
      };

      if (this.cdmx_mode) {
        this.status_wms["urbanAreas"]["raster"] = {
          id: 'raster',
          layer: rasterAccessibility,
          name: 'Accesibilidad a servicios de salud',
          imgURL: './assets/access.png',
          type: "raster",
          category: "factoresdeRiesgo",
          active: false
        }
      }

      const baseMaps = this.status_wms["urbanAreas"];
      const controlMap = this.renderer.selectRootElement('#controlMapWms', true);
      let index = 0;
      for (const mapName of Object.keys(baseMaps)) {
        const newTitle = this.renderer.createElement('div');
        let htmlTitle = ""
        if (index == 0) {
          htmlTitle = '<div class="subHeader">'
          htmlTitle += '<span class="dataSubHeader">Factores sociodemográficos</span>'
          htmlTitle += '</div>'
        }
        if (index == 3) {
          htmlTitle = '<div class="subHeader">'
          htmlTitle += '<span class="dataSubHeader">Factores de riesgo</span>'
          htmlTitle += '</div>'
        }

        index++;
        newTitle.innerHTML = htmlTitle;
        this.renderer.appendChild(controlMap, newTitle);

        const newMapBase = this.renderer.createElement('div');
        let htmlString = '';
        htmlString += '<div id=\'' + mapName + '\' class="baseMap ' + '" (click)="changeMap(\'' + mapName + '\')">';
        htmlString += '<div class="baseContainer">';
        htmlString += '<img class="baseImg" src="' + baseMaps[mapName].imgURL + '"/>';
        htmlString += '</div>';
        htmlString += '<span class="baseName">' + baseMaps[mapName].name + '</span>';
        htmlString += '</div>';
        newMapBase.innerHTML = htmlString;
        this.renderer.appendChild(controlMap, newMapBase);
        this.renderer.listen(newMapBase, 'click', (event) => {
          this.controlMouseDown = true;
          const selectedMap = newMapBase.firstChild.id;

          baseMaps[selectedMap].active = !baseMaps[selectedMap].active;
          if (baseMaps[selectedMap].active) {
            this.select_ws = {
              baseMap: baseMaps,
              selectedMap: selectedMap
            };
            const selectedDiv = document.getElementById(selectedMap);
            selectedDiv.classList.add('active');
          } else {
            const currentDiv = document.getElementById(selectedMap);
            currentDiv.classList.remove('active');
          }
          this.toggleTitleMap(baseMaps, selectedMap)
          //this.toggleMapWms();
        });
      }
      // controlMap.addEventListener("mouseleave", (evt) => {
      //   if (!this.controlMouseDown) {
      //     this.toggleMapWms();
      //   }
      // });
    });
  }

  initControlMapWmsMunicipality(map: L.map) {
    setTimeout(() => {
      var wmsURL = 'http://idegeo.centrogeo.org.mx/geoserver/wms';

      const pobTotal = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:poblacion_municipio',
        styles: ' poblacion_municipio',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });

      const under5 = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:poblacion_municipio',
        styles: 'Población de 0 a 4 años por municipio',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });
      const under10 = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:poblacion_municipio',
        styles: 'Población de 0 a 9 años por municipio',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });

      const over65 = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:poblacion_municipio',
        styles: 'Población de 60 y más por municipio',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });

      const povertyExtrem = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:municipio_pobreza',
        styles: 'Población en pobreza extrema por municipio',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });

      const foodPoverty = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:municipio_pobreza',
        styles: 'Población con carencias en alimentación por municipio',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });

      const povertyServices = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:municipio_pobreza',
        styles: 'Población con carencias en servicios por municipio',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });

      const povertyHealth = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:municipio_pobreza',
        styles: 'Población con carencias en servicios de salud por municipio',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });

      this.status_wms["states"] = {
        pobTotalMunicipality: {
          id: 'pobTotalMunicipality',
          layer: pobTotal,
          name: 'Población municipios',
          imgURL: './assets/wms/mun/pobTotal.PNG',
          type: "Poblacion",
          active: false
        },
        over65Municipality: {
          id: 'over65Municipality',
          layer: over65,
          name: 'Población 60 y mas años',
          imgURL: './assets/wms/mun/over65.PNG',
          type: "Poblacion",
          active: false
        },
        under5Municipality: {
          id: 'under5Municipality',
          layer: under5,
          name: 'Población 0 a 4 años',
          imgURL: './assets/wms/mun/under5.PNG',
          type: "Poblacion",
          active: false
        },
        // under10Municipality: {
        //   id: 'under5Municipality',
        //   layer: under10,
        //   name: 'Población 0 a 9 años',
        //   imgURL: './assets/Streets.png',
        //   type: "Poblacion",
        //   active: false
        // },
        povertyExtremMunicipality: {
          id: 'povertyExtremMunicipality',
          layer: povertyExtrem,
          name: 'Pobreza extrema',
          imgURL: './assets/wms/mun/povExt.PNG',
          type: "Pobreza",
          active: false
        },
        // foodPovertyMunicipality: {
        //   id: 'foodPovertyMunicipality',
        //   layer: foodPoverty,
        //   name: 'Pobreza Alimentaria',
        //   imgURL: './assets/Streets.png',
        //   type: "Pobreza",
        //   active: false
        // },
        povertyServicesMunicipality: {
          id: 'povertyServicesMunicipality',
          layer: povertyServices,
          name: 'Carencia en servicios',
          imgURL: './assets/wms/mun/povServ.PNG',
          type: "Pobreza",
          active: false
        },
        povertyHealthMunicipality: {
          id: 'povertyHealthMunicipality',
          layer: povertyHealth,
          name: 'Carencia en salud',
          imgURL: './assets/wms/mun/povHealth.PNG',
          type: "Pobreza",
          active: false
        }
      };
      const baseMaps = this.status_wms["states"];

      const controlMap = this.renderer.selectRootElement('#controlMapWmsMunicipality', true);
      let index = 0;
      for (const mapName of Object.keys(baseMaps)) {
        const newTitle = this.renderer.createElement('div');
        let htmlTitle = ""
        if (index == 0) {
          htmlTitle = '<div class="subHeader">'
          htmlTitle += '<span class="dataSubHeader">Factores sociodemográficos</span>'
          htmlTitle += '</div>'
        }
        if (index == 4) {
          htmlTitle = '<div class="subHeader">'
          htmlTitle += '<span class="dataSubHeader">Factores de riesgo</span>'
          htmlTitle += '</div>'
        }

        index++;
        newTitle.innerHTML = htmlTitle;
        this.renderer.appendChild(controlMap, newTitle);

        const newMapBase = this.renderer.createElement('div');
        let htmlString = '';
        htmlString = '<div id=\'' + mapName + '\' class="baseMap ' + '" (click)="changeMap(\'' + mapName + '\')">';
        htmlString += '<div class="baseContainer">';
        htmlString += '<img class="baseImg" src="' + baseMaps[mapName].imgURL + '"/>';
        htmlString += '</div>';
        htmlString += '<span class="baseName">' + baseMaps[mapName].name + '</span>';
        htmlString += '</div>';
        newMapBase.innerHTML = htmlString;
        this.renderer.appendChild(controlMap, newMapBase);
        this.renderer.listen(newMapBase, 'click', (event) => {
          this.controlMouseDown = true;
          const selectedMap = newMapBase.firstChild.id;

          baseMaps[selectedMap].active = !baseMaps[selectedMap].active;
          if (baseMaps[selectedMap].active) {
            this.select_ws = {
              baseMap: baseMaps,
              selectedMap: selectedMap
            };
            const selectedDiv = document.getElementById(selectedMap);
            selectedDiv.classList.add('active');
          } else {
            const currentDiv = document.getElementById(selectedMap);
            currentDiv.classList.remove('active');
          }
          this.toggleTitleMap(baseMaps, selectedMap)
          //this.toggleMapWmsMunicipality();
        });
      }
      // controlMap.addEventListener("mouseleave", (evt) => {
      //   if (!this.controlMouseDown) {
      //     this.toggleMapWmsMunicipality();
      //   }
      // });
    });
  }

  initControlMapWmsStates(map: L.map) {
    setTimeout(() => {
      var wmsURL = 'http://idegeo.centrogeo.org.mx/geoserver/wms';

      const pobTotal = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:poblacion',
        styles: 'poblacion',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });

      const over65 = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:poblacion',
        styles: 'Oblación de 60 años y más por estado',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });
      const under5 = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:poblacion',
        styles: 'Población de 0 a 4 años por estado',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });
      const under10 = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:poblacion',
        styles: 'Población de 0 a 9 años por estado',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });

      const povertyExtrem = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:entidad_pobreza',
        styles: 'Población en pobreza extrema por estado',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });

      const foodPoverty = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:entidad_pobreza',
        styles: 'Población con carencias en la alimentación',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });

      const povertyServices = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:entidad_pobreza',
        styles: 'Población con carencias en los servicios de salud',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });

      const povertyHealth = L.tileLayer.wms(wmsURL, {
        layers: 'geonode:entidad__pobreza',
        styles: 'Población con carencias en los servicios de salud',
        format: 'image/png',
        transparent: true,
        attribution: 'IDEGEO | Datos preliminares sujetos a revisión'
      });

      this.status_wms["country"] = {
        pobTotalState: {
          id: 'pobTotalState',
          layer: pobTotal,
          name: 'Población estados',
          imgURL: './assets/wms/state/pobTotal.PNG',
          type: "Poblacion",
          active: false
        },
        over65State: {
          id: 'over65State',
          layer: over65,
          name: 'Población 60 y mas años',
          imgURL: './assets/wms/state/over65.PNG',
          type: "Poblacion",
          active: false
        },
        under5State: {
          id: 'under5State',
          layer: under5,
          name: 'Población 0 a 4 años',
          imgURL: './assets/wms/state/under5.PNG',
          type: "Poblacion",
          active: false
        },
        // under10State: {
        //   id: 'under10State',
        //   layer: under10,
        //   name: 'Población 0 a 9 años',
        //   imgURL: './assets/Streets.png',
        //   type: "Poblacion",
        //   active: false
        // }
        povertyExtremState: {
          id: 'povertyExtremState',
          layer: povertyExtrem,
          name: 'Pobreza extrema',
          imgURL: './assets/wms/state/povExt.PNG',
          type: "Pobreza",
          active: false
        },
        povertyServicesState: {
          id: 'povertyServicesState',
          layer: povertyServices,
          name: 'Carencia en servicios',
          imgURL: './assets/wms/state/povServ.PNG',
          type: "Pobreza",
          active: false
        },
        // povertyHealthState: {
        //   id: 'povertyHealthState',
        //   layer: povertyHealth,
        //   name: 'Pobreza en salud',
        //   imgURL: './assets/wms/state/povHealth.PNG',
        //   type: "Pobreza",
        //   active: false
        // }
      };

      const baseMaps = this.status_wms["country"];

      const controlMap = this.renderer.selectRootElement('#controlMapWmsState', true);
      let index = 0;
      for (const mapName of Object.keys(baseMaps)) {
        const newTitle = this.renderer.createElement('div');
        let htmlTitle = ""
        if (index == 0) {
          htmlTitle = '<div class="subHeader">'
          htmlTitle += '<span class="dataSubHeader">Factores sociodemográficos</span>'
          htmlTitle += '</div>'
        }
        if (index == 3) {
          htmlTitle = '<div class="subHeader">'
          htmlTitle += '<span class="dataSubHeader">Factores de riesgo</span>'
          htmlTitle += '</div>'
        }

        index++;
        newTitle.innerHTML = htmlTitle;
        this.renderer.appendChild(controlMap, newTitle);

        const newMapBase = this.renderer.createElement('div');
        let htmlString = '';
        htmlString = '<div id=\'' + mapName + '\' class="baseMap ' + '" (click)="changeMap(\'' + mapName + '\')">';
        htmlString += '<div class="baseContainer">';
        htmlString += '<img class="baseImg" src="' + baseMaps[mapName].imgURL + '"/>';
        htmlString += '</div>';
        htmlString += '<span class="baseName">' + baseMaps[mapName].name + '</span>';
        htmlString += '</div>';
        newMapBase.innerHTML = htmlString;
        this.renderer.appendChild(controlMap, newMapBase);
        this.renderer.listen(newMapBase, 'click', (event) => {
          this.controlMouseDown = true;
          const selectedMap = newMapBase.firstChild.id;

          baseMaps[selectedMap].active = !baseMaps[selectedMap].active;
          if (baseMaps[selectedMap].active) {
            this.select_ws = {
              baseMap: baseMaps,
              selectedMap: selectedMap
            };
            const selectedDiv = document.getElementById(selectedMap);
            selectedDiv.classList.add('active');
          } else {
            const currentDiv = document.getElementById(selectedMap);
            currentDiv.classList.remove('active');
          }
          this.toggleTitleMap(baseMaps, selectedMap)
          //this.toggleMapWmsStates();
        });
      }
      // controlMap.addEventListener("mouseleave", (evt) => {
      //   if (!this.controlMouseDown) {
      //     this.toggleMapWmsStates();
      //   }
      // });
    });
  }

  toggleMapControl() {
    this.statusControlMap = !this.statusControlMap;
    if (this.statusControlMap) {
      const controlMap = this.renderer.selectRootElement('.mapControl', true);
      this.renderer.removeStyle(controlMap, 'display');

      const controlMapButton = this.renderer.selectRootElement('.showControlMap', true);
      this.renderer.setStyle(controlMapButton, 'background-color', 'rgb(178, 56, 62, 1)');
    } else {
      const controlMap = this.renderer.selectRootElement('.mapControl', true);
      this.renderer.setStyle(controlMap, 'display', 'none');

      const controlMapButton = this.renderer.selectRootElement('.showControlMap', true);
      this.renderer.setStyle(controlMapButton, 'background-color', '#6D9AB7');
    }
    setTimeout(() => {
      this.controlMouseDown = false;
    }, 300);
  }

  // toggleMapWms() {
  //   this.statusControlMapWms = !this.statusControlMapWms;
  // if (this.statusControlMapWms) {
  //   const controlMap = this.renderer.selectRootElement('.mapControlWms', true);
  //   this.renderer.removeStyle(controlMap, 'display');

  //   const controlMapButton = this.renderer.selectRootElement('.showControlMapWms', true);
  //   this.renderer.setStyle(controlMapButton, 'background-color', 'rgb(178, 56, 62, 1)');
  // } else {
  //   const controlMap = this.renderer.selectRootElement('.mapControlWms', true);
  //   this.renderer.setStyle(controlMap, 'display', 'none');

  //   const controlMapButton = this.renderer.selectRootElement('.showControlMapWms', true);
  //   this.renderer.setStyle(controlMapButton, 'background-color', '#6D9AB7');
  // }
  //   setTimeout(() => {
  //     this.controlMouseDown = false;
  //   }, 300);
  // }

  // toggleMapWmsStates() {
  //   this.statusControlMapWmsState = !this.statusControlMapWmsState;
  // if (this.statusControlMapWmsState) {
  //   const controlMap = this.renderer.selectRootElement('.mapControlWmsState', true);
  //   this.renderer.removeStyle(controlMap, 'display');

  //   const controlMapButton = this.renderer.selectRootElement('.showControlMapWmsState', true);
  //   this.renderer.setStyle(controlMapButton, 'background-color', 'rgb(178, 56, 62, 1)');
  // } else {
  //   const controlMap = this.renderer.selectRootElement('.mapControlWmsState', true);
  //   this.renderer.setStyle(controlMap, 'display', 'none');

  //   const controlMapButton = this.renderer.selectRootElement('.showControlMapWmsState', true);
  //   this.renderer.setStyle(controlMapButton, 'background-color', '#6D9AB7');
  // }
  //   setTimeout(() => {
  //     this.controlMouseDown = false;
  //   }, 300);
  // }

  // toggleMapWmsMunicipality() {
  //   this.statusControlMapWmsMunicipality = !this.statusControlMapWmsMunicipality;
  // if (this.statusControlMapWmsMunicipality) {
  //   const controlMap = this.renderer.selectRootElement('.mapControlWmsMunicipality', true);
  //   this.renderer.removeStyle(controlMap, 'display');

  //   const controlMapButton = this.renderer.selectRootElement('.showControlMapWmsMunicipality', true);
  //   this.renderer.setStyle(controlMapButton, 'background-color', 'rgb(178, 56, 62, 1)');
  // } else {
  //   const controlMap = this.renderer.selectRootElement('.mapControlWmsMunicipality', true);
  //   this.renderer.setStyle(controlMap, 'display', 'none');

  //   const controlMapButton = this.renderer.selectRootElement('.showControlMapWmsMunicipality', true);
  //   this.renderer.setStyle(controlMapButton, 'background-color', '#6D9AB7');
  // }
  //   setTimeout(() => {
  //     this.controlMouseDown = false;
  //   }, 300);
  // }


  toggleMapMode() {
    this.statusMapMode = !this.statusMapMode;
    this.showRegionLegend = !this.showRegionLegend;
    if (this.statusMapMode) {
      this.resetMapMode()
      if (this.cdmx_mode == true || this.yuc_mode == true) {
        this.loadGeoJsonUrbanAreas()
      } else {
        this.loadGeoJsonCategory()
      }
      const controlMapButton = this.renderer.selectRootElement('.showMapMode', true);
      this.renderer.setStyle(controlMapButton, 'background-color', 'rgb(178, 56, 62, 1)');
    } else {
      this.resetMap()
      this.loadGeoJsonCountry()
      const controlMapButton = this.renderer.selectRootElement('.showMapMode', true);
      this.renderer.setStyle(controlMapButton, 'background-color', '#6D9AB7');
    }
  }

  toggleMapModeExposition() {
    this.statusMapModeExposition = !this.statusMapModeExposition;
    if (this.statusMapModeExposition) {
      this.showAreaExposition();
      this.showLegendAreaExposition = true;
      const controlMapButton = this.renderer.selectRootElement('.showMapModeExposition', true);
      this.renderer.setStyle(controlMapButton, 'background-color', 'rgb(178, 56, 62, 1)');
    } else {
      this.showLegendAreaExposition = false;
      if (this.zoneGeoJsonExposition != undefined) {
        this.map.removeLayer(this.zoneGeoJsonExposition);
        this.zoneGeoJsonExposition = undefined;
      }
      if (this.polygons["select_urban_areas"] != undefined) {
        this.polygons["select_urban_areas"].eachLayer(function (layer) {
          layer.setStyle({
            "color": '#6C3721',
            "opacity": 0.3,
            "weight": 1
          })
        });
      };

      let that = this;
      if (this.polygons["select_state"] != undefined) {
        this.polygons["select_state"].eachLayer(function (layer) {
          const colorMunicipio = that.getColorByScaleMunicipalities(layer.feature.properties.num_casos_covid);
          if (that.select_municipality == undefined || that.select_municipality.properties.municipio_cvegeo != layer.feature.properties.municipio_cvegeo) {
            layer.setStyle({
              "color": colorMunicipio.color,
              "fillColor": colorMunicipio.fillColor,
              "opacity": 1,
              "fillOpacity": 0.9,
              "weight": 1
            })
          } else {
            layer.setStyle({
              "color": colorMunicipio.color,
              "fillColor": colorMunicipio.fillColor,
              "opacity": 1,
              "fillOpacity": 0.9,
              "weight": 6
            })
          }
        });
      };
      const controlMapButton = this.renderer.selectRootElement('.showMapModeExposition', true);
      this.renderer.setStyle(controlMapButton, 'background-color', '#6D9AB7');
    }
  }

  toggleMapModeExpositionModeNormal() {
    let that = this;
    this.statusMapModeExposition = !this.statusMapModeExposition;
    if (this.statusMapModeExposition) {
      this.showAreaExpositionModeNormal();
      this.showLegendAreaExposition = true;
      const controlMapButton = this.renderer.selectRootElement('.showMapModeExpositionModoNormal', true);
      this.renderer.setStyle(controlMapButton, 'background-color', '#6D9AB7');
    } else {
      this.showLegendAreaExposition = false;
      if (this.zoneGeoJsonExposition != undefined) {
        this.map.removeLayer(this.zoneGeoJsonExposition);
        this.zoneGeoJsonExposition = undefined;
      }
      this.resetPolygonStatesExposition();
      const controlMapButton = this.renderer.selectRootElement('.showMapModeExpositionModoNormal', true);
      this.renderer.setStyle(controlMapButton, 'background-color', 'rgb(178, 56, 62, 1)');
      ;
    }
  }

  toggleMapModeExpositionModeNormalCountry() {
    let that = this;
    if (this.select_ws != undefined) {
      this.resetWms();
      this.statusMapModeExposition = true;
      this.showLegend = true;
    }

    this.statusMapModeExposition = !this.statusMapModeExposition;
    document.getElementById("showMapExpositionModoNormalCountry").classList.remove('active');
    document.getElementById("showMapExpositionModoNormalMunicipality").classList.remove('active');

    document.getElementById("showMapCovidModoNormalCountry").classList.remove('active');
    document.getElementById("showMapCovidModoNormalMunicipality").classList.remove('active');

    if (this.statusMapModeExposition) {
      this.showAreaExpositionModeNormalCountry();
      this.showLegendAreaExposition = true;
      const controlMapButton = this.renderer.selectRootElement('.showMapModeExpositionModoNormalCountry', true);
      this.renderer.setStyle(controlMapButton, 'background-color', '#6D9AB7');
      document.getElementById("showMapExpositionModoNormalCountry").classList.add('active');
      document.getElementById("showMapExpositionModoNormalMunicipality").classList.add('active');
    } else {
      this.showLegendAreaExposition = false;
      if (this.zoneGeoJsonExposition != undefined) {
        this.map.removeLayer(this.zoneGeoJsonExposition);
        this.zoneGeoJsonExposition = undefined;
      }
      this.resetPolygonStatesExposition();
      document.getElementById("showMapCovidModoNormalCountry").classList.add('active');
      document.getElementById("showMapCovidModoNormalMunicipality").classList.add('active');
      const controlMapButton = this.renderer.selectRootElement('.showMapModeExpositionModoNormalCountry', true);
      this.renderer.setStyle(controlMapButton, 'background-color', 'rgb(178, 56, 62, 1)');  
    }
  }

  toggleMapModeExpositionModeNormalEnableCountry() {
    let that = this;
    if (this.select_ws != undefined) {
      this.resetWms();
      this.statusMapModeExposition = true;
      this.showLegend = true;
    }

    this.statusMapModeExposition = true;
    this.showLegendAreaExposition = false;
    if (this.zoneGeoJsonExposition != undefined) {
      this.map.removeLayer(this.zoneGeoJsonExposition);
      this.zoneGeoJsonExposition = undefined;
    }
    this.resetPolygonStatesExposition();
    document.getElementById("showMapExpositionModoNormalCountry").classList.remove('active');
    document.getElementById("showMapExpositionModoNormalMunicipality").classList.remove('active');

    document.getElementById("showMapCovidModoNormalCountry").classList.remove('active');
    document.getElementById("showMapCovidModoNormalMunicipality").classList.remove('active');

    this.showAreaExpositionModeNormalCountry();
    this.showLegendAreaExposition = true;
    const controlMapButton = this.renderer.selectRootElement('.showMapModeExpositionModoNormalCountry', true);
    this.renderer.setStyle(controlMapButton, 'background-color', '#6D9AB7');
    document.getElementById("showMapExpositionModoNormalCountry").classList.add('active');
    document.getElementById("showMapExpositionModoNormalMunicipality").classList.add('active');
  }

  toggleMapModeExpositionModeNormalDisabledCountry() {
    let that = this;
    if (this.select_ws != undefined) {
      this.resetWms();
      this.statusMapModeExposition = true;
      this.showLegend = true;
    }

    this.statusMapModeExposition = false
    this.showLegendAreaExposition = false;
    if (this.zoneGeoJsonExposition != undefined) {
      this.map.removeLayer(this.zoneGeoJsonExposition);
      this.zoneGeoJsonExposition = undefined;
    }
    this.resetPolygonStatesExposition();
    const controlMapButton = this.renderer.selectRootElement('.showMapModeExpositionModoNormalCountry', true);
    this.renderer.setStyle(controlMapButton, 'background-color', 'rgb(178, 56, 62, 1)');      
    document.getElementById("showMapExpositionModoNormalCountry").classList.remove('active');
    document.getElementById("showMapExpositionModoNormalMunicipality").classList.remove('active');
    document.getElementById("showMapCovidModoNormalCountry").classList.add('active');
    document.getElementById("showMapCovidModoNormalMunicipality").classList.add('active');
  }

  toggleMapModeExpositionModeRegion() {
    let that = this;
    if (this.select_ws != undefined) {
      this.resetWms();
      this.statusMapModeExposition = true;
    }

    document.getElementById("showMapCovidModoRegionCountry").classList.remove('active');
    document.getElementById("showMapExpositionModoRegionCountry").classList.remove('active');
    document.getElementById("showMapCovidModoRegionMunicipality").classList.remove('active');
    document.getElementById("showMapExpositionModoRegionMunicipality").classList.remove('active');

    this.statusMapModeExposition = !this.statusMapModeExposition;
    if (this.statusMapModeExposition) {
      if (this.zoneGeoJsonExposition != undefined) {
        this.map.removeLayer(this.zoneGeoJsonExposition);
        this.zoneGeoJsonExposition = undefined;
      }
      this.showAreaExpositionModeRegion();
      this.showLegendAreaExposition = true;
      const controlMapButton = this.renderer.selectRootElement('.showMapModeExpositionModoRegion', true);
      this.renderer.setStyle(controlMapButton, 'background-color', '#6D9AB7');
      document.getElementById("showMapExpositionModoRegionCountry").classList.add('active');
      document.getElementById("showMapExpositionModoRegionMunicipality").classList.add('active');
    } else {
      this.showLegendAreaExposition = false;
      if (this.zoneGeoJsonExposition != undefined) {
        this.map.removeLayer(this.zoneGeoJsonExposition);
        this.zoneGeoJsonExposition = undefined;
      }
      this.showCovidModeRegion();
      //this.resetPolygonStatesExposition();
      const controlMapButton = this.renderer.selectRootElement('.showMapModeExpositionModoRegion', true);
      this.renderer.setStyle(controlMapButton, 'background-color', 'rgb(178, 56, 62, 1)');
      document.getElementById("showMapCovidModoRegionCountry").classList.add('active');
      document.getElementById("showMapCovidModoRegionMunicipality").classList.add('active');
    }
  }

  toggleMapModeExpositionModeRegionEnableCountry() {
    let that = this;
    if (this.select_ws != undefined) {
      this.resetWms();
      this.statusMapModeExposition = true;
    }

    this.statusMapModeExposition = true;

    if (this.zoneGeoJsonExposition != undefined) {
      this.map.removeLayer(this.zoneGeoJsonExposition);
      this.zoneGeoJsonExposition = undefined;
    }
    this.showAreaExpositionModeRegion();
    document.getElementById("showMapCovidModoRegionCountry").classList.remove('active');
    document.getElementById("showMapExpositionModoRegionCountry").classList.remove('active');
    document.getElementById("showMapCovidModoRegionMunicipality").classList.remove('active');
    document.getElementById("showMapExpositionModoRegionMunicipality").classList.remove('active');
    this.showLegendAreaExposition = true;
    
    const controlMapButton = this.renderer.selectRootElement('.showMapModeExpositionModoRegion', true);
    this.renderer.setStyle(controlMapButton, 'background-color', '#6D9AB7');
    document.getElementById("showMapExpositionModoRegionCountry").classList.add('active');
    document.getElementById("showMapExpositionModoRegionMunicipality").classList.add('active');
  }

  toggleMapModeExpositionModeRegionDisabledCountry() {
    let that = this;
    if (this.select_ws != undefined) {
      this.resetWms();
      this.statusMapModeExposition = true;
    }

    this.statusMapModeExposition = false;
    
    this.showLegendAreaExposition = false;
    if (this.zoneGeoJsonExposition != undefined) {
      this.map.removeLayer(this.zoneGeoJsonExposition);
      this.zoneGeoJsonExposition = undefined;
    }
    this.showCovidModeRegion();

    const controlMapButton = this.renderer.selectRootElement('.showMapModeExpositionModoRegion', true);
    this.renderer.setStyle(controlMapButton, 'background-color', 'rgb(178, 56, 62, 1)');

    document.getElementById("showMapCovidModoRegionCountry").classList.remove('active');
    document.getElementById("showMapExpositionModoRegionCountry").classList.remove('active');
    document.getElementById("showMapCovidModoRegionMunicipality").classList.remove('active');
    document.getElementById("showMapExpositionModoRegionMunicipality").classList.remove('active');

    document.getElementById("showMapCovidModoRegionCountry").classList.add('active');  
    document.getElementById("showMapCovidModoRegionMunicipality").classList.add('active');  
  }

  centerMap() {
    const centerMapButton = this.renderer.selectRootElement('.centerMap', true);
    this.renderer.setStyle(centerMapButton, 'background-color', 'rgb(178, 56, 62, 1)');

    if (this.cdmx_mode === true) {
      this.map.flyToBounds(this.cdmx_mode_bounds, { paddingBottomRight: [0, 0], zoom: 10 })
    }
    else if (this.yuc_mode === true) {
      this.map.flyToBounds(this.yuc_mode_bounds, { paddingBottomRight: [0, 0] })
    }
    else {
      this.map.flyTo(L.latLng(21.95774, -101.62595), 5);
    }



    let that = this;
    this.map.once('moveend', function (e) {
      that.renderer.setStyle(centerMapButton, 'background-color', '#6D9AB7');
    });
  }

  dragMoved(event, element, type) {
    let point_pixels = [event.pointerPosition.x, event.pointerPosition.y]
    let point_latlon = this.map.containerPointToLatLng(point_pixels)
    let polygon;

    switch (this.nivelPolygons) {
      case "Estado":
        let select_state = this.select_state;
        if (select_state.geometry.type == "Polygon") {
          polygon = turf.polygon(select_state.geometry.coordinates);
        } else {
          polygon = turf.multiPolygon(select_state.geometry.coordinates);
        }
        break;
      case "Metropolitan":
        let select_metropolitan = this.select_metropolitan;
        if (select_metropolitan.geometry.type == "Polygon") {
          polygon = turf.polygon(select_metropolitan.geometry.coordinates);
        } else {
          polygon = turf.multiPolygon(select_metropolitan.geometry.coordinates);
        }
        break;
      case "Municipio":
      case "ZonaMunicipio":
        let select_municipality = this.select_municipality;
        if (select_municipality.geometry.type == "Polygon") {
          polygon = turf.polygon(select_municipality.geometry.coordinates);
        } else {
          polygon = turf.multiPolygon(select_municipality.geometry.coordinates);
        }
        break;
      case "Localidad":
      case "ZonaLocalidad":
        let select_locality = this.select_locality;
        if (select_locality.geometry.type == "Polygon") {
          polygon = turf.polygon(select_locality.geometry.coordinates);
        } else {
          polygon = turf.multiPolygon(select_locality.geometry.coordinates);
        }
        break;
      default:
        polygon = turf.multiPolygon(this.select_state.geometry.coordinates);
        break;
    }

    let point = turf.point([point_latlon.lng, point_latlon.lat]);
    let intersection = turf.booleanPointInPolygon(point, polygon);

    if (intersection) {
      this.drag_inside_polygon = true;
      document.getElementById(element).className = 'drag-button-inside-circle';
    } else {
      this.drag_inside_polygon = false;
      document.getElementById(element).className = 'drag-button';
    }
  }

  dragEnded(event, element, type) {
    if (this.drag_inside_polygon) {
      this.showLayer(type);
    }
    event['source']._dragRef.reset();
  }

  showLayer(layerType: string) {
    (document.getElementById(layerType) as HTMLButtonElement).disabled = true;
    //console.log(document.getElementById("label_"+layerType))
    //document.getElementById("label_"+layerType).innerHTML = " Cargando... "	

    //console.log(layerType)
    switch (layerType) {
      /* case 'Farmacias':
        document.getElementById("label_" + layerType).innerHTML = document.getElementById("label_" + layerType).innerHTML.replace("Farmacias", "Cargando...");
        this.clearLayer('pharmacies');
        this.getFarmaciasCovidService();
        this.enableInfoLayer(this.infoLayers[0]);
        break;
      case 'DoctoresPublicos':
        document.getElementById("label_" + layerType).innerHTML = document.getElementById("label_" + layerType).innerHTML.replace("Consultorios públicos", "Cargando...");
        this.clearLayer('publicDoctors');
        this.getDoctorPublicCovidService();
        this.enableInfoLayer(this.infoLayers[1]);
        break;
      case 'DoctoresPrivados':
        document.getElementById("label_" + layerType).innerHTML = document.getElementById("label_" + layerType).innerHTML.replace("Consultorios privados", "Cargando...");
        this.clearLayer('privateDoctors');
        this.getDoctorPrivateCovidService();
        this.enableInfoLayer(this.infoLayers[2]);
        break; */
      case 'labs':
        document.getElementById("label_" + layerType).innerHTML = document.getElementById("label_" + layerType).innerHTML.replace("Laboratorios", "Cargando...");
        this.clearLayer('labs');
        this.getLabsCovidService();
        this.enableInfoLayer(this.infoLayers[0]);
        break;
      case 'HospitalesCovid':
        document.getElementById("label_" + layerType).innerHTML = document.getElementById("label_" + layerType).innerHTML.replace("Hospitales COVID", "Cargando...");
        this.clearLayer('covidHospitals');
        this.getHospitalesCovidService();
        this.resetLegedHospitalCovid();
        this.enableInfoLayer(this.infoLayers[1]);
        break;
      case 'sedesa':
        this.clearSedesa('sedesa')
        this.getSedesaCovidService('sedesa')
        this.resetLegedHospitalCovidSedesa();
        this.enableInfoLayer(this.infoLayers[2]);
        this.enableInfoLayer(this.infoLayerSedesa[0]);
        break;
      case 'sedesaTemp':
        this.clearSedesa('sedesaTemp')
        this.getSedesaCovidService('sedesaTemp')
        //this.resetLegedHospitalCovidSedesa();
        // this.enableInfoLayer(this.infoLayers[2]);
        this.enableInfoLayer(this.infoLayerSedesa[1]);
        break;

      default:
        break;
    }
  }

  hideLayer(layerType: string) {
    switch (layerType) {
      /* case 'Farmacias':
        this.clearLayer('pharmacies');
        this.disableInfoLayer(this.infoLayers[0]);
        break;
      case 'DoctoresPublicos':
        this.clearLayer('publicDoctors');
        this.disableInfoLayer(this.infoLayers[1]);
        break;
      case 'DoctoresPrivados':
        this.clearLayer('privateDoctors');
        this.disableInfoLayer(this.infoLayers[2]);
        break; */
      case 'labs':
        this.clearLayer('labs');
        this.disableInfoLayer(this.infoLayers[0]);
        break;
      case 'HospitalesCovid':
        this.clearLayer('covidHospitals');
        this.disableInfoLayer(this.infoLayers[1]);
        this.showLegendHospitalsCovid = false;
        break;
      case 'sedesa':
        this.clearSedesa('sedesa');
        this.disableInfoLayer(this.infoLayers[2]);
        this.disableInfoLayer(this.infoLayerSedesa[0]);
        this.showLegendHospitalsSedesa = false;
        break;
      case 'sedesaTemp':
        this.clearSedesa('sedesaTemp');
        //this.disableInfoLayer(this.infoLayers[2]);
        this.disableInfoLayer(this.infoLayerSedesa[1]);
        //this.showLegendHospitalsSedesa = false;
        break;
      default:
        break;
    }
  }

  clearLayer(name) {
    if (name != "publicHospitals" && name != "privateHospitals" && name != "ventilators" && name != "ventilatorsClues" && name != "carpas" && name != "camas" && name != "camasUci" && name != "medicos") {
      if (this.covidGeoJson[name] != undefined) {
        this.map.removeLayer(this.covidGeoJson[name]);
        this.covidGeoJson[name] = undefined;
      }

      if (this.map.hasLayer(this.markerClusters[name])) {
        this.map.removeLayer(this.markerClusters[name])
        this.markerClusters[name].clearLayers();
      }
      this.markerClusters[name].enableClustering();
      this.generalData[name].clusterized = true;
    }

  }

  clearPolygons(name) {
    if (this.polygons[name] != undefined) {
      this.map.removeLayer(this.polygons[name]);
      this.polygons[name] = undefined;
    }
  }

  toggleClusters(clusterized, type) {
    if (clusterized) {
      this.markerClusters[type].disableClustering();
      this.generalData[type].clusterized = false;
      if (this.cdmx_mode)
        this.redSedesa[type].clusterized = false;
    }
    else {
      this.markerClusters[type].enableClustering();
      this.generalData[type].clusterized = true;
      if (this.cdmx_mode)
        this.redSedesa[type].clusterized = true;
    }
  }

  getLabsCovidService() {
    let levelPolygons = this.nivelPolygons
    let entidad_cvegeo;
    let wkt;

    switch (levelPolygons) {
      case "Estado":
        entidad_cvegeo = this.select_state.properties.entidad_cvegeo;
        break;
      case "Municipio":
      case "ZonaMunicipio":
        entidad_cvegeo = this.select_municipality.properties.municipio_cvegeo;
        break;
      case "Localidad":
      case "ZonaLocalidad":
        entidad_cvegeo = this.select_locality.properties.localidad_urbana_cvegeo;
        break;
      case "Metropolitan":
        entidad_cvegeo = this.select_metropolitan.properties.entidad_cvegeo;
        if (this.select_metropolitan.geometry.type == "Polygon") {
          wkt = stringify(this.select_metropolitan);
        } else {
          wkt = stringify(this.select_metropolitan);
        }
        break;
      default:
        entidad_cvegeo = this.select_state.properties.entidad_cvegeo;
        break;
    }

    this.covidLabsService.getLabs(entidad_cvegeo, levelPolygons, wkt)
      .subscribe(data => {
        let labs_array = []
        data['labs'].forEach(lab => {

          let newLab = {
            "type": "Feature",
            "properties": {
              "nombre": lab['nombre']
            },
            "geometry": {
              "type": "Point",
              "coordinates": [
                lab['longitud'],
                lab['latitud']
              ]
            },
          }
          labs_array.push(newLab);
        });

        this.clearLayer('labs');
        this.covidGeoJson['labs'] = L.geoJSON(labs_array, {
          pointToLayer: function (feature, latlng) {
            var iconoLaboratorio = new L.Icon({
              iconUrl: backend_url + '/covid_pins/pin_laboratorio_400.png',
              iconSize: [41, 41],
              //iconAnchor: [41, 41],
              popupAnchor: [0, -20],
              //shadowSize: [41, 41],
              prefix: 'icon',
            });

            let popupContent = '<div class="popup-wrapper">';
            popupContent += '<div class="popup-content">';
            popupContent += '<div class="popup-title">';
            popupContent += 'Nombre:&nbsp;';
            popupContent += '</div>';
            popupContent += '<div class="popup-value">';
            popupContent += feature.properties.nombre;
            popupContent += '</div>';
            popupContent += '</div>';
            popupContent += '</div>';

            return L.marker(latlng, {
              icon: iconoLaboratorio
            }).bindPopup(popupContent, { className: 'lab-popup' });
          }
        }).addTo(this.markerClusters['labs']);
        this.map.addLayer(this.markerClusters['labs'])
        document.getElementById("label_labs").innerHTML = document.getElementById("label_labs").innerHTML.replace("Cargando...", "Laboratorios");
        (document.getElementById("labs") as HTMLButtonElement).disabled = false;

      }, (error) => {
        console.error("laboratorios ERROR", error);
      });
  }

  getSedesaCovidService(type) {
    let pinHospital = '';
    let tipo_sedesa = ''
    //console.log(type)

    if (type === 'sedesa')
      tipo_sedesa = 'Hospitales Red Sedesa'
    if (type === 'sedesaTemp')
      tipo_sedesa = 'Unidad Médica Temporal'

    this.cdmxModeSedesa = L.geoJSON(this.hospitalSedesa, {

      pointToLayer: function (feature, latlng) {
        if (feature.properties.tipoSedesa.value == tipo_sedesa) {
          for (let val in feature.properties.institution.value) {
            var inst = feature.properties.institution.value
            if (feature.properties.covid.value == 'Hospital SEDESA Designado COVID')
              pinHospital = backend_url + '/covid_pins/pin_hospital_sedesa_covid_activo.png'
            else if (feature.properties.covid.value == 'Hospital Red SEDESA')
              pinHospital = backend_url + '/covid_pins/pin_hospital_sedesa_covid_designado.png'
            else
              pinHospital = backend_url + '/covid_pins/pin_hospital_covid_ss.png'
            break;
          }

          var iconoHospitalSedesa = new L.Icon({
            iconUrl: pinHospital,
            //iconUrl: backend_url + '/covid_pins/pin_hospital_covid_400.png',
            iconSize: [41, 60],
            //iconAnchor: [41, 41],
            popupAnchor: [0, -20],
            //shadowSize: [41, 41],
            //prefix: 'icon',
          });

          let popupContent = '<div class="popup-wrapper">';

          for (let propertie in feature.properties) {
            if (feature.properties[propertie].value !== null && feature.properties[propertie].value !== undefined && propertie != "address") {
              popupContent += '<div class="popup-content">';
              popupContent += '<div class="popup-title">';
              popupContent += feature.properties[propertie].title + ':&nbsp;';
              popupContent += '</div>';
              popupContent += '<div class="popup-value">';
              popupContent += feature.properties[propertie].value;
              popupContent += '</div>';
              popupContent += '</div>';
            }
          }

          popupContent += '</div>';

          return L.marker(latlng, {
            icon: iconoHospitalSedesa
          }).bindPopup(popupContent, { className: 'covid-popup' });
        }
      }
    }).addTo(this.markerClusters[type]);
    this.map.addLayer(this.markerClusters[type]);
    //document.getElementById("label_sedesa").innerHTML = document.getElementById("label_sedesa").innerHTML.replace("Cargando...", "Sedesa");
    (document.getElementById(type) as HTMLButtonElement).disabled = false;
    if (type === 'sedesa')
      this.showLegendHospitalsSedesa = true;
  }

  getDoctorPrivateCovidService() {
    let levelPolygons = this.nivelPolygons
    let entidad_cvegeo;
    let wkt;

    switch (levelPolygons) {
      case "Estado":
        entidad_cvegeo = this.select_state.properties.entidad_cvegeo;
        break;
      case "Municipio":
      case "ZonaMunicipio":
        entidad_cvegeo = this.select_municipality.properties.municipio_cvegeo;
        break;
      case "Localidad":
      case "ZonaLocalidad":
        entidad_cvegeo = this.select_locality.properties.localidad_urbana_cvegeo;
        break;
      case "Metropolitan":
        entidad_cvegeo = this.select_metropolitan.properties.entidad_cvegeo;
        if (this.select_metropolitan.geometry.type == "Polygon") {
          wkt = stringify(this.select_metropolitan);
        } else {
          wkt = stringify(this.select_metropolitan);
        }
        break;
      default:
        entidad_cvegeo = this.select_state.properties.entidad_cvegeo;
        break;
    }

    this.covidDoctor.getPrivate(entidad_cvegeo, levelPolygons, wkt)
      .subscribe(data => {
        let consultoriosPrivados_array = []
        data['privateDoctors'].forEach(consultorioPrivado => {

          let newConsulorioPrivado = {
            "type": "Feature",
            "properties": {
              "censo": consultorioPrivado['censo'],
              "nombre": consultorioPrivado['nombre'],
              "denue_ocupacion": consultorioPrivado["denue_ocupacion"]
            },
            "geometry": {
              "type": "Point",
              "coordinates": [
                consultorioPrivado['longitud'],
                consultorioPrivado['latitud']
              ]
            },
          }
          consultoriosPrivados_array.push(newConsulorioPrivado);
        });

        this.clearLayer('privateDoctors');
        this.covidGeoJson['privateDoctors'] = L.geoJSON(consultoriosPrivados_array, {
          pointToLayer: function (feature, latlng) {
            var iconoCPrivado = new L.Icon({
              iconUrl: backend_url + '/covid_pins/pin_cprivado_400.png',
              iconSize: [41, 41],
              iconAnchor: [41, 41],
              popupAnchor: [-20, -45],
              shadowSize: [41, 41],
              prefix: 'icon',
              //glyph: 'cprivado'
            });

            let popupContent = '<div class="popup-wrapper">';
            popupContent += '<div class="popup-content">';
            popupContent += '<div class="popup-title">';
            popupContent += 'Nombre:&nbsp;';
            popupContent += '</div>';
            popupContent += '<div class="popup-value">';
            popupContent += feature.properties.nombre;
            popupContent += '</div>';
            popupContent += '</div>';
            popupContent += '</div>';

            return L.marker(latlng, {
              icon: iconoCPrivado
            }).bindPopup(popupContent, { className: 'private-popup' });
          }
        }).addTo(this.markerClusters['privateDoctors']);
        this.map.addLayer(this.markerClusters['privateDoctors'])
        document.getElementById("label_DoctoresPrivados").innerHTML = document.getElementById("label_DoctoresPrivados").innerHTML.replace("Cargando...", "Consultorios privados");
        (document.getElementById("DoctoresPrivados") as HTMLButtonElement).disabled = false;

      }, (error) => {
        console.error("privateDoctors ERROR", error);
      });
  }

  getDoctorPublicCovidService() {
    let entidad_cvegeo;
    let levelPolygons = this.nivelPolygons
    let wkt;
    switch (levelPolygons) {
      case "Estado":
        entidad_cvegeo = this.select_state.properties.entidad_cvegeo;
        break;
      case "Municipio":
      case "ZonaMunicipio":
        entidad_cvegeo = this.select_municipality.properties.municipio_cvegeo;
        break;
      case "Localidad":
      case "ZonaLocalidad":
        entidad_cvegeo = this.select_locality.properties.localidad_urbana_cvegeo;
        break;
      case "Metropolitan":
        entidad_cvegeo = this.select_metropolitan.properties.entidad_cvegeo;
        if (this.select_metropolitan.geometry.type == "Polygon") {
          wkt = stringify(this.select_metropolitan);
        } else {
          wkt = stringify(this.select_metropolitan);
        }
        break;
      default:
        entidad_cvegeo = this.select_state.properties.entidad_cvegeo;
        break;
    }

    this.covidDoctor.getPublic(entidad_cvegeo, levelPolygons, wkt)
      .subscribe(data => {
        let consultoriosPublicos_array = []
        data['publicDoctors'].forEach(consultorioPublico => {
          let newConsultorioPublico = {
            "type": "Feature",
            "properties": {
              "censo": consultorioPublico['censo'],
              "nombre": consultorioPublico['nombre'],
              "denue_ocupacion": consultorioPublico["denue_ocupacion"]
            },
            "geometry": {
              "type": "Point",
              "coordinates": [
                consultorioPublico['longitud'],
                consultorioPublico['latitud']
              ]
            },
          }
          consultoriosPublicos_array.push(newConsultorioPublico);
        });

        this.clearLayer('publicDoctors');
        this.covidGeoJson['publicDoctors'] = L.geoJSON(consultoriosPublicos_array, {
          pointToLayer: function (feature, latlng) {
            var iconoCPublico = new L.Icon({
              iconUrl: backend_url + '/covid_pins/pin_cpublico_400.png',
              iconSize: [41, 41],
              iconAnchor: [41, 41],
              popupAnchor: [-20, -45],
              shadowSize: [41, 41],
              prefix: 'icon',
            });

            let popupContent = '<div class="popup-wrapper">';
            popupContent += '<div class="popup-content">';
            popupContent += '<div class="popup-title">';
            popupContent += 'Nombre:&nbsp;';
            popupContent += '</div>';
            popupContent += '<div class="popup-value">';
            popupContent += feature.properties.nombre;
            popupContent += '</div>';
            popupContent += '</div>';
            popupContent += '</div>';

            return L.marker(latlng, {
              icon: iconoCPublico
            }).bindPopup(popupContent, { className: 'public-popup' });
          }
        }).addTo(this.markerClusters['publicDoctors']);
        this.map.addLayer(this.markerClusters['publicDoctors'])
        document.getElementById("label_DoctoresPublicos").innerHTML = document.getElementById("label_DoctoresPublicos").innerHTML.replace("Cargando...", "Consultorios públicos");
        (document.getElementById("DoctoresPublicos") as HTMLButtonElement).disabled = false;

      }, (error) => {
        console.error("publicDoctors", error);
      });
  }

  getFarmaciasCovidService() {
    let entidad_cvegeo;
    let levelPolygons = this.nivelPolygons;
    let wkt;
    switch (levelPolygons) {
      case "Estado":
        entidad_cvegeo = this.select_state.properties.entidad_cvegeo;
        break;
      case "Municipio":
      case "ZonaMunicipio":
        entidad_cvegeo = this.select_municipality.properties.municipio_cvegeo;
        break;
      case "Localidad":
      case "ZonaLocalidad":
        entidad_cvegeo = this.select_locality.properties.localidad_urbana_cvegeo;
        break;
      case "Metropolitan":
        entidad_cvegeo = this.select_metropolitan.properties.entidad_cvegeo;
        if (this.select_metropolitan.geometry.type == "Polygon") {
          wkt = stringify(this.select_metropolitan);
        } else {
          wkt = stringify(this.select_metropolitan);
        }
        break;
      default:
        entidad_cvegeo = this.select_state.properties.entidad_cvegeo;
        break;
    }

    this.covidPharmacyService.getPhamarcy(entidad_cvegeo, levelPolygons, wkt)
      .subscribe(data => {

        //console.log(data)
        let farmacias_array = []

        data['pharmacies'].forEach(pharmacy => {
          let newPharmacies = {
            "type": "Feature",
            "properties": {
              "censo": pharmacy['censo'],
              "nombre": pharmacy['nombre'],
              "denue_ocupacion": pharmacy["denue_ocupacion"]
            },
            "geometry": {
              "type": "Point",
              "coordinates": [
                pharmacy['longitud'],
                pharmacy['latitud']
              ]
            },
          }
          farmacias_array.push(newPharmacies);
        });

        this.clearLayer('pharmacies');
        this.covidGeoJson['pharmacies'] = L.geoJSON(farmacias_array, {
          pointToLayer: function (feature, latlng) {
            var iconoFarmacias = new L.Icon({
              iconUrl: backend_url + '/covid_pins/pin_farmacia_400.png',
              iconSize: [41, 41],
              iconAnchor: [41, 41],
              popupAnchor: [-20, -45],
              shadowSize: [41, 41],
              prefix: 'icon',
              //glyph: 'farmacia'
            });

            let popupContent = '<div class="popup-wrapper">';
            popupContent += '<div class="popup-content">';
            popupContent += '<div class="popup-title">';
            popupContent += 'Nombre:&nbsp;';
            popupContent += '</div>';
            popupContent += '<div class="popup-value">';
            popupContent += feature.properties.nombre;
            popupContent += '</div>';
            popupContent += '</div>';
            popupContent += '</div>';

            return L.marker(latlng, {
              icon: iconoFarmacias
            }).bindPopup(popupContent, { className: 'pharma-popup' });
          }
        }).addTo(this.markerClusters['pharmacies']);
        this.map.addLayer(this.markerClusters['pharmacies'])
        document.getElementById("label_Farmacias").innerHTML = document.getElementById("label_Farmacias").innerHTML.replace("Cargando...", "Farmacias");
        (document.getElementById("Farmacias") as HTMLButtonElement).disabled = false;

      }, (error) => {
        console.error("farmacias ERROR", error);
      });
  }



  getHospitalesCovidService() {
    let entidad_cvegeo;
    let levelPolygons = this.nivelPolygons;
    let wkt;
    let mode = this.cdmx_mode ? "cdmx" : "";
    switch (levelPolygons) {
      case "Estado":
        entidad_cvegeo = this.select_state.properties.entidad_cvegeo;
        break;
      case "Municipio":
      case "ZonaMunicipio":
        entidad_cvegeo = this.select_municipality.properties.municipio_cvegeo;
        break;
      case "Localidad":
      case "ZonaLocalidad":
        entidad_cvegeo = this.select_locality.properties.localidad_urbana_cvegeo;
        break;
      /*       case "ZonaUrbanArea":
              entidad_cvegeo = this.select_urban_areas.properties.region_urbana_cve;
              break;	 */
      case "Metropolitan":
        entidad_cvegeo = this.select_metropolitan.properties.entidad_cvegeo;
        if (this.select_metropolitan.geometry.type == "Polygon") {
          wkt = stringify(this.select_metropolitan);
        } else {
          wkt = stringify(this.select_metropolitan);
        }
        break;
      default:
        entidad_cvegeo = this.select_state.properties.entidad_cvegeo;
        break;
    }


    this.covidHospitalsService.getHospitals(entidad_cvegeo, levelPolygons, wkt, mode)
      .subscribe(data => {

        // console.log(data)

        let covid_hospitals_array = [];
        let pinHospital = '';

        data['covidHospitals'].forEach(covidHospital => {
          let newHospital_ss = {
            "type": "Feature",
            "properties": {
              name: {
                title: 'Nombre',
                value: covidHospital['nombre_de_la_unidad']
              },
              institution: {
                title: 'Institución',
                value: covidHospital['nombre_de_la_institucion']
              },
              address: {
                title: 'Dirección',
                value: covidHospital['direccion']
              },
              tier: {
                title: 'Nivel de atención',
                value: covidHospital['nivel_atencion']
              },
              beds_uci: {
                title: 'Camas UCI',
                value: covidHospital['camas_uci']
              },
              beds: {
                title: 'Total de camas',
                value: covidHospital['total_de_camas']
              },
              office: {
                title: 'Total de consultorios',
                value: covidHospital['total_de_consultorios']
              },
              ventilator: {
                title: 'Total de ventiladores',
                value: covidHospital['total_de_ventiladores']
              },
              covid: {
                title: 'Hospital COVID',
                value: covidHospital['covid']
              },
              especial: {
                title: 'Médicos especialistas',
                value: covidHospital['total_especialistas']
              },
              resident: {
                title: 'Médicos residentes',
                value: covidHospital['total_residentes']
              }
            },
            "geometry": {
              "type": "Point",
              "coordinates": [
                covidHospital['longitud'],
                covidHospital['latitud']
              ]
            },
          }
          covid_hospitals_array.push(newHospital_ss);
        });

        this.clearLayer('covidHospitals');
        this.covidGeoJson['covidHospitals'] = L.geoJSON(covid_hospitals_array, {
          pointToLayer: function (feature, latlng) {

            for (let val in feature.properties.institution.value) {
              var inst = feature.properties.institution.value
              //console.log(inst);
              //console.log("\n");
              switch (inst) {
                case "INSTITUTO MEXICANO DEL SEGURO SOCIAL":
                case "INSTITUTO MEXICANO DEL SEGURO SOCIAL REGIMEN BIENESTAR":
                  if (feature.properties.covid.value == 'Hospital SEDESA Designado COVID')
                    pinHospital = backend_url + '/covid_pins/pin_hospital_covid_imss_activo.png'
                  else if (feature.properties.covid.value == 'Hospital Red SEDESA')
                    pinHospital = backend_url + '/covid_pins/pin_hospital_covid_imss_designado.png'
                  else
                    pinHospital = backend_url + '/covid_pins/pin_hospital_covid_imss.png'
                  break;

                case "SECRETARIA DE SALUD":
                  if (feature.properties.covid.value == 'Hospital SEDESA Designado COVID')
                    pinHospital = backend_url + '/covid_pins/pin_hospital_sedesa_covid_activo.png'
                  else if (feature.properties.covid.value == 'Hospital Red SEDESA')
                    pinHospital = backend_url + '/covid_pins/pin_hospital_sedesa_covid_designado.png'
                  else
                    pinHospital = backend_url + '/covid_pins/pin_hospital_covid_ss.png'
                  break;

                case "SECRETARIA DE MARINA":
                  if (feature.properties.covid.value == 'Hospital SEDESA Designado COVID')
                    pinHospital = backend_url + '/covid_pins/pin_hospital_covid_semar_activo.png'
                  else if (feature.properties.covid.value == 'Hospital Red SEDESA')
                    pinHospital = backend_url + '/covid_pins/pin_hospital_covid_semar_designado.png'
                  else
                    pinHospital = backend_url + '/covid_pins/pin_hospital_covid_semar.png'
                  break;

                case "SECRETARIA DE LA DEFENSA NACIONAL":
                  if (feature.properties.covid.value == 'Hospital SEDESA Designado COVID')
                    pinHospital = backend_url + '/covid_pins/pin_hospital_covid_sedena_activo.png'
                  else if (feature.properties.covid.value == 'Hospital Red SEDESA')
                    pinHospital = backend_url + '/covid_pins/pin_hospital_covid_sedena_designado.png'
                  else
                    pinHospital = backend_url + '/covid_pins/pin_hospital_covid_sedena.png'
                  break;

                case "INSTITUTO DE SEGURIDAD Y SERVICIOS SOCIALES PARA LOS TRABAJADORES DEL ESTADO":
                  if (feature.properties.covid.value == 'Hospital SEDESA Designado COVID')
                    pinHospital = backend_url + '/covid_pins/pin_hospital_covid_issste_activo.png'
                  else if (feature.properties.covid.value == 'Hospital Red SEDESA')
                    pinHospital = backend_url + '/covid_pins/pin_hospital_covid_issste_designado.png'
                  else
                    pinHospital = backend_url + '/covid_pins/pin_hospital_covid_issste.png'
                  break;

                default:
                  pinHospital = backend_url + '/covid_pins/pin_hospital_covid_400.png'
                  break;
              }
            }


            var iconoHospitalCOVID = new L.Icon({
              iconUrl: pinHospital,
              //iconUrl: backend_url + '/covid_pins/pin_hospital_covid_400.png',
              iconSize: [29, 41],
              //iconAnchor: [41, 41],
              popupAnchor: [0, -20],
              //shadowSize: [41, 41],
              //prefix: 'icon',
            });


            let popupContent = '<div class="popup-wrapper">';

            for (let propertie in feature.properties) {
              if (feature.properties[propertie].value !== null && feature.properties[propertie].value !== undefined && propertie != "address") {
                popupContent += '<div class="popup-content">';
                popupContent += '<div class="popup-title">';
                popupContent += feature.properties[propertie].title + ':&nbsp;';
                popupContent += '</div>';
                popupContent += '<div class="popup-value">';
                popupContent += feature.properties[propertie].value;
                popupContent += '</div>';
                popupContent += '</div>';
              }
            }

            popupContent += '</div>';

            return L.marker(latlng, {
              icon: iconoHospitalCOVID
            }).bindPopup(popupContent, { className: 'covid-popup' });
          }

        }).addTo(this.markerClusters['covidHospitals']);
        this.map.addLayer(this.markerClusters['covidHospitals'])
        document.getElementById("label_HospitalesCovid").innerHTML = document.getElementById("label_HospitalesCovid").innerHTML.replace("Cargando...", "Hospitales COVID");
        (document.getElementById("HospitalesCovid") as HTMLButtonElement).disabled = false;
        this.showLegendHospitalsCovid = true;


      }, (error) => {
        console.error("HospitalesCovid ERROR", error);
      });
  }

  enableInfoLayer(infoLayer) {
    infoLayer.active = true;
    infoLayer.disabled = false;
  }

  disableInfoLayer(infoLayer) {
    infoLayer.active = false;
    infoLayer.disabled = true;
    infoLayer.opacity = false;
  }

  showButton() {
    /* this.infoLayers[0].display = this.generalData.pharmacies.total > 0 ? true : false;
    this.infoLayers[1].display = this.generalData.publicDoctors.total > 0 ? true : false;
    this.infoLayers[2].display = this.generalData.privateDoctors.total > 0 ? true : false; */
    this.infoLayers[0].display = this.generalData.labs.total > 0 ? true : false;
    this.infoLayers[1].display = this.generalData.covidHospitals.total > 0 ? true : false;
    if (this.cdmx_mode) {
      //this.infoLayers[2].display = this.generalData.sedesa.total > 0 ? true : false;
      this.showRedSedesaButton = this.generalData.sedesa.total > 0 ? true : false;
    }
  }

  resetbutton() {
    this.infoLayers.forEach(layer => {
      layer.display = false;
      layer.active = false;
      layer.opacity = false;
      layer.disabled = true;
      this.clearLayer(layer.id);
    });
    this.showLegendHospitalsCovid = false;
    this.showLegendHospitalsSedesa = false;
    this.resetLegedHospitalCovid();
    this.resetLegedHospitalCovidSedesa();
    this.disableInfoLayer(this.infoLayerSedesa[0]);
    this.disableInfoLayer(this.infoLayerSedesa[1]);
  }

  backPolygon(nivel) {
    let that = this;
    switch (nivel) {
      case 'País':
        this.resetMap();
        break;
      case 'Estado':
        this.select_locality = undefined;
        this.select_municipality = undefined;
        this.select_ageb = undefined;
        this.spinner.show();
        this.map.flyToBounds(this.layer["select_state"], { paddingBottomRight: [20, 20] })
        this.map.once('moveend', function (e) {
          //if(that.showLayerWms){ that.resetWms() }
          that.loadGeoJsonStates(that.select_state, that.layer["select_state"], that)
        });
        break;
      case 'Municipio':
        this.select_locality = undefined;
        this.select_ageb = undefined;
        this.spinner.show();
        this.map.flyToBounds(this.layer["select_municipality"], { paddingBottomRight: [20, 20] })
        this.map.once('moveend', function (e) {
          //if(that.showLayerWms){ that.resetWms() }
          that.loadGeoJsonMunicipies(that.select_municipality, that.layer["select_municipality"], that)
        });
        break;
      case 'Localidad':
        this.select_ageb = undefined;
        this.spinner.show();
        this.map.flyToBounds(this.layer["select_locality"], { paddingBottomRight: [20, 20] })
        this.map.once('moveend', function (e) {
          that.loadGeoJsonLocalities(that.select_locality, that.layer["select_locality"], that)
        });
        break;
      default:
        this.resetMap();
        break;
    }
  }

  backPolygonUrbanAreas(nivel) {
    let that = this;
    switch (nivel) {
      case 'UrbanAreas':
        this.resetMapMode();
        if (this.cdmx_mode == true || this.yuc_mode == true) {
          this.loadGeoJsonUrbanAreas()
        } else {
          this.loadGeoJsonCategory();
        }
        break;
      case 'ZonaUrbanArea':
        this.select_metropolitan = undefined;
        this.select_locality = undefined;
        this.select_municipality = undefined;
        this.select_ageb = undefined;
        this.spinner.show();
        this.map.flyToBounds(this.layer["select_urban_areas"], { paddingBottomRight: [20, 20] })
        this.map.once('moveend', function (e) {
          that.loadGeoJsonUrbanAreasCategory(that.select_urban_areas, that.layer["select_urban_areas"], that)
        });
        break;
      case 'Metropolitan':
        this.select_locality = undefined;
        this.select_municipality = undefined;
        this.select_ageb = undefined;
        this.spinner.show();
        this.map.flyToBounds(this.layer["select_metropolitan"], { paddingBottomRight: [20, 20] })
        this.map.once('moveend', function (e) {
          that.loadGeoJsonMetropolitan(that.select_metropolitan, that.layer["select_metropolitan"], that)
        });
        break;
      case 'ZonaMunicipio':
        this.select_locality = undefined;
        this.select_ageb = undefined;
        this.spinner.show();
        this.map.flyToBounds(this.layer["select_municipality"], { paddingBottomRight: [20, 20] })
        this.map.once('moveend', function (e) {
          that.loadGeoJsonMetropolisMunicipies(that.select_municipality, that.layer["select_municipality"], that)
        });
        break;
      case 'ZonaLocalidad':
        this.select_ageb = undefined;
        this.spinner.show();
        this.map.flyToBounds(this.layer["select_locality"], { paddingBottomRight: [20, 20] })
        this.map.once('moveend', function (e) {
          that.loadGeoJsonMetropolisLocalities(that.select_locality, that.layer["select_locality"], that)
        });
        break;
      default:
        this.resetMap();
        break;
    }
  }

  clearAllMarkers() {
    /* this.clearLayer('pharmacies');
    this.clearLayer('publicDoctors');
    this.clearLayer('privateDoctors'); */
    this.clearLayer('labs');
  }

  resetMapModeZone() {
    this.resetMapMode()
    this.loadGeoJsonCategory()
  }

  resetMapModeRegion() {
    this.resetMapMode();
    if (this.cdmx_mode || this.yuc_mode) {
      this.loadGeoJsonUrbanAreas();
    }
  }

  resetMapMode() {
    this.infoLayers.forEach(layer => {
      layer.display = false;
      layer.active = false;
      layer.opacity = false;
      layer.disabled = true;
      this.clearLayer(layer.id);
    });

    this.resetWms();
    this.clearPolygons('select_metropolitan');
    this.clearPolygons('select_categories');
    this.clearPolygons('select_urban_areas');
    this.clearPolygons('select_state');
    this.clearPolygons('select_municipality');
    this.clearPolygons('select_locality');
    this.clearPolygons('select_country');
    this.clearPolygons('select_ageb');

    this.clearAllMarkers();

    this.select_locality = undefined;
    this.select_municipality = undefined;
    this.select_urban_areas = undefined;

    this.dataEntityName = "México";

    if (this.mortalityChart != undefined) {
      this.mortalityChart.destroy();
      this.mortalityChart = undefined
    }

    if (this.mortalityRateChart != undefined) {
      //this.mortalityRateChart.destroy();
      this.mortalityRateChart = undefined
    }

    //    this.loadInfoCOVID('NACIONAL', COVID_casos_positivos);
    this.updateCovid(this.casosCovidNacional);
    //this.initChartInfra(this.infraInfoCountry)
    this.showlegendInfo["mortality"] = false;
    this.showlegendInfo["projection2020"] = false;
    this.showlegendInfo["poverty"] = false;
    this.showlegendInfo["covid"] = false;
    this.showlegendInfo["mortalityLocation"] = false;
    this.showlegendInfo["generalData"] = false;

    this.map.flyTo(L.latLng(21.95774, -101.62595), 5);
    this.nivelPolygons = 'UrbanAreas';
    this.showLegend = false;
    this.showLegendByMunicipalities = false;
    this.showLegendHospitalsCovid = false;
    this.showLegendHospitalsSedesa = false;
    this.showLegendAreaExposition = false;
    this.statusMapModeExposition = false;

    if (this.zoneGeoJsonExposition != undefined) {
      this.map.removeLayer(this.zoneGeoJsonExposition);
      this.zoneGeoJsonExposition = undefined;
    }

    this.resetLegedHospitalCovid();
    this.resetLegedHospitalCovidSedesa();

    const controlMapButton = this.renderer.selectRootElement('.showMapModeExposition', true);
    this.renderer.setStyle(controlMapButton, 'background-color', '#6D9AB7');
    // const controlMapButtonNormal = this.renderer.selectRootElement('.showMapModeExpositionModoNormal', true);
    // this.renderer.setStyle(controlMapButtonNormal, 'background-color', 'rgb(56, 178, 172, 0.7)');
    const controlMapButtonNormalCountry = this.renderer.selectRootElement('.showMapModeExpositionModoNormalCountry', true);
    this.renderer.setStyle(controlMapButtonNormalCountry, 'background-color', '#6D9AB7');
    //this.renderer.setStyle(controlMapButtonNormalCountry, 'background-color', 'rgb(56, 178, 172, 0.7)');
    document.getElementById("showMapCovidModoNormalCountry").classList.remove('active');
    document.getElementById("showMapExpositionModoNormalCountry").classList.add('active');
    const controlMapButtonRegion = this.renderer.selectRootElement('.showMapModeExpositionModoRegion', true);
    this.renderer.setStyle(controlMapButtonRegion, 'background-color', '#6D9AB7');

    // if (this.cdmx_mode || this.yuc_mode) {
    //   this.loadGeoJsonUrbanAreas();
    // }

    if (this.cdmx_mode) {
      this.resetHospitalsCDMX();
      this.redSedesa = JSON.parse(JSON.stringify(this.aux_redSedesa));
      this.sedesaOtrasInstituciones = JSON.parse(JSON.stringify(this.aux_sedesaOtrasInstituciones));
    }

  }

  resetMap() {
    const resetMapButton = this.renderer.selectRootElement('.resetMap', true);
    this.renderer.setStyle(resetMapButton, 'background-color', 'rgb(178, 56, 62, 1)');

    this.infoLayers.forEach(layer => {
      layer.display = false;
      layer.active = false;
      layer.opacity = false;
      layer.disabled = true;
      this.clearLayer(layer.id);
    });
    this.showLegendHospitalsCovid = false;
    this.showLegendHospitalsSedesa = false;




    this.resetWms();
    this.clearPolygons('select_state');
    this.clearPolygons('select_municipality');
    this.clearPolygons('select_locality');
    this.clearPolygons("select_urban_areas");
    this.clearPolygons('select_categories');
    this.clearPolygons('select_metropolitan');
    this.clearPolygons('select_ageb');


    this.clearAllMarkers();
    this.select_locality = undefined;
    this.select_municipality = undefined;
    this.select_state = undefined;

    this.dataEntityName = "México";
    this.estadoCOVID = "México";
    this.current_state = '';
    this.current_municipality = '';
    this.current_locality = '';
    this.current_urban_region = '';
    this.current_metropolitan_zone = '';
    this.showlegendInfo["mortality"] = false;
    this.showlegendInfo["projection2020"] = false;
    this.showlegendInfo["poverty"] = false;
    this.showlegendInfo["covid"] = false;
    this.showlegendInfo["mortalityLocation"] = false;
    this.showlegendInfo["generalData"] = false;
    this.showLegendAreaExposition = false;

    //    this.loadInfoCOVID('NACIONAL', COVID_casos_positivos);
    this.updateCovid(this.casosCovidNacional);


    this.showProjectionChart = false;
    this.populationChart.titles.values[0].text = "Censo 2010"

    if (this.statusMapMode) {
      this.statusMapMode = !this.statusMapMode;
      this.loadGeoJsonCountry();
      const mapModeButton = this.renderer.selectRootElement('.showMapMode', true);
      this.renderer.setStyle(mapModeButton, 'background-color', '#6D9AB7');
    }

    this.statusMapModeExposition = false;
    this.showLegendAreaExposition = false;
    if (this.zoneGeoJsonExposition != undefined) {
      this.map.removeLayer(this.zoneGeoJsonExposition);
      this.zoneGeoJsonExposition = undefined;
    }
    this.resetPolygonStatesExposition();
    // const controlMapButtonNormal = this.renderer.selectRootElement('.showMapModeExpositionModoNormal', true);
    // this.renderer.setStyle(controlMapButtonNormal, 'background-color', 'rgb(56, 178, 172, 0.7)');
    const controlMapButtonNormalCountry = this.renderer.selectRootElement('.showMapModeExpositionModoNormalCountry', true);
    this.renderer.setStyle(controlMapButtonNormalCountry, 'background-color', '#6D9AB7');
    //this.renderer.setStyle(controlMapButtonNormalCountry, 'background-color', 'rgb(56, 178, 172, 0.7)');
    document.getElementById("showMapCovidModoNormalCountry").classList.remove('active');
    document.getElementById("showMapExpositionModoNormalCountry").classList.add('active');
    const controlMapButtonRegion = this.renderer.selectRootElement('.showMapModeExpositionModoRegion', true);
    this.renderer.setStyle(controlMapButtonRegion, 'background-color', '#6D9AB7');

    this.resetLegedHospitalCovid();
    this.resetLegedHospitalCovidSedesa();

    this.toggleMapModeExpositionModeNormalCountry();

    this.generalData = JSON.parse(JSON.stringify(this.aux_generalData));
    this.pobData = JSON.parse(JSON.stringify(this.aux_pobData));
    this.pobData2020 = JSON.parse(JSON.stringify(this.aux_pobData2020));
    this.vulData = JSON.parse(JSON.stringify(this.aux_vulData));
    this.povertyData = JSON.parse(JSON.stringify(this.aux_povData));
    this.mortalityData = JSON.parse(JSON.stringify(this.aux_mortalityData));
    this.expositionData = JSON.parse(JSON.stringify(this.aux_expositionData));
    if (this.cdmx_mode) {
      this.redSedesa = JSON.parse(JSON.stringify(this.aux_redSedesa));
      this.sedesaOtrasInstituciones = JSON.parse(JSON.stringify(this.aux_sedesaOtrasInstituciones));
    }

    let restPobl = this.pobData.pobTotal.total - this.pobData.over65.total - this.pobData.under5.total;
    /* let restPoblNoRight = this.pobData.pobTotal.total - this.vulData.sinDerechoHabienciaPop.total - this.vulData.sinDerechoHabiencia.total; */

    this.poblChart.data = [
      ['Mayores de 65 años', this.pobData.over65.total],
      ['Menores de 5 años', this.pobData.under5.total],
      ['Resto de la población', restPobl]
    ];


    this.populationChartData = [
      {
        title: "Mayores de 65 años",
        count: this.pobData.over65.total
      },
      {
        title: "Menores de 5 años",
        count: this.pobData.under5.total
      },
      {
        title: "Resto de la población",
        count: restPobl
      }
    ];

    this.projectionChartData = [
      {
        title: "Mayores de 60 años",
        count: this.pobData2020.projection2020over60.total
      },
      {
        title: "Menores de 4 años",
        count: this.pobData2020.projection2020under4.total
      },
      {
        title: "Resto de la población",
        count: this.pobData2020.projection2020.total - this.pobData2020.projection2020over60.total - this.pobData2020.projection2020under4.total
      }
    ];


    this.initChartPopulation();
    this.initChartProjection();

    /* this.sinDerechoHabienteChart.data = [
      ['No derechohabientes', this.vulData.sinDerechoHabiencia.total],
      ['INSABI', this.vulData.sinDerechoHabienciaPop.total],
      ['Resto de la población', restPoblNoRight]
    ];
    this.vulnerabilityChartData = [
      {
        title: "No derechohabientes",
        count: this.vulData.sinDerechoHabiencia.total
      },
      {
        title: "Población INSABI",
        count: this.vulData.sinDerechoHabienciaPop.total
      },
      {
        title: "Resto de la población",
        count: restPoblNoRight
      }
    ];
    this.initChartVulnerability(); */

    this.povertyChartData = [
      {
        title: "Pobreza",
        count: this.povertyData.pobreza.total
      },
      {
        title: "Pobreza extrema",
        count: this.povertyData.pobrezaExtrema.total
      },
      {
        title: "Carencia en salud",
        count: this.povertyData.pobrezaSalud.total
      },
      {
        title: "Carencia en servicios",
        count: this.povertyData.pobrezaServicio.total
      },
      {
        title: "Carencia en alimentos",
        count: this.povertyData.pobrezaAlimentos.total
      }
    ];


    this.initChartPoverty();



    if (this.mortalityChart != undefined) {
      this.mortalityChart.destroy();
      this.mortalityChart = undefined
    }

    if (this.mortalityRateChart != undefined) {
      //this.mortalityRateChart.destroy();
      this.mortalityRateChart = undefined
    }

    this.infraestructureChartData = this.generalData.covidHospitals.children;
    this.initChartInfraestructure();

    //this.initChartInfra(this.infraInfoCountry)

    this.hospitalsChartData = this.hospitalsChartData_aux;
    this.ventilatorsChartData = this.ventilatorsChartData_aux;
    /* this.initChartHospitals()
    this.initChartVentilators(); */

    this.map.flyTo(L.latLng(21.95774, -101.62595), 5);
    this.nivelPolygons = 'Country';

    let that = this;
    // this.map.once('moveend', function (e) {
    // });
    setTimeout(function () {
      that.renderer.setStyle(resetMapButton, 'background-color', '#6D9AB7');
    }, 1500);

    this.showLegend = true;
    this.showLegendByMunicipalities = false;

    this.emptyInfrastructure = false;
  }

  isNumber(val) { null; return typeof val === 'number'; }
  isNoMortality(val) { return val.includes("Mortalidad"); }
  isNoPoverty(val) { return val.includes("Pobreza"); }

  changeTab(tab) {
    switch (tab) {
      case 'infra':
        this.showInfraTab = true;
        this.showCovidTab = false;
        this.showVulTab = false;
        this.projectionChart.reinit();
        break;
      case 'covid':
        this.showInfraTab = false;
        this.showCovidTab = true;
        this.showVulTab = false;
        this.covidAgesChart.reinit();
        break;
      case 'vul':
        this.showInfraTab = false;
        this.showCovidTab = false;
        this.showVulTab = true;
        this.povertyChart.reinit();
        if (this.mortalityRateChart !== undefined) {
          this.mortalityRateChart.reinit();
        }
        break;
      case 'pop':
        this.showTwitterTab = false;
        this.showWMSTab = false;
        this.showPopTab = true;
        break;
      case 'twitter':
        this.showTwitterTab = true;
        this.showWMSTab = false;
        this.showPopTab = false;
        break;
      case 'wms':
        this.showTwitterTab = false;
        this.showWMSTab = true;
        this.showPopTab = false;
        break;
    }
  }

  toggleTimeline() {
    let twitterTimeline = document.getElementById('twitterTimeline');
    if (twitterTimeline.classList.contains('hidden')) {
      twitterTimeline.classList.remove('hidden');
      setTimeout(function () {
        twitterTimeline.classList.remove('visuallyhidden');
      }, 20);
    } else {
      twitterTimeline.classList.add('visuallyhidden');
      twitterTimeline.addEventListener('transitionend', function (e) {
        twitterTimeline.classList.add('hidden');
      }, {
        capture: false,
        once: true,
        passive: false
      });
    }
  }

  toggle_accessibilidad() {

    //console.log("show accesibilidad")
    var buttonAccess = document.getElementById("toggleAccessButtton");

    if (this.map.hasLayer(this.accesibility_layer)) {
      //this.map.removeLayer(this.accesibility_layer)
      buttonAccess.innerHTML = "Mostrar";
      //this.renderer.setStyle(cdmxHospitalsButton, 'background-color', '#6D9AB7');
      //this.showLegendHospitalsDisponibility = false;
    }
    else {
      //this.map.addLayer(this.accesibility_layer)
      //this.accesibility_layer.bringToFront();
      buttonAccess.innerHTML = "Ocultar";
      // this.markerClusters['hospitalsCDMX'].disableClustering();
      // this.renderer.setStyle(cdmxHospitalsButton, 'background-color', 'rgb(178, 56, 62, 1)');
      // this.showLegendHospitalsDisponibility = true;
    }


    this.status_wms["urbanAreas"]['raster'].active = !this.status_wms["urbanAreas"]['raster'].active;
    if (this.status_wms["urbanAreas"]['raster'].active) {
      this.select_ws = {
        baseMap: this.status_wms["urbanAreas"],
        selectedMap: 'raster'
      };
      const selectedDiv = document.getElementById('raster');
      selectedDiv.classList.add('active');
    } else {
      const currentDiv = document.getElementById('raster');
      currentDiv.classList.remove('active');
    }


    this.toggleTitleMap(this.status_wms["urbanAreas"], 'raster')





  }


  resetHospitalsCDMX() {
    if (this.map.hasLayer(this.markerClusters['hospitalsCDMX'])) {
      const cdmxHospitalsButton = this.renderer.selectRootElement('.cdmxHospitalsButton', true);
      this.map.removeLayer(this.markerClusters['hospitalsCDMX'])
      this.renderer.setStyle(cdmxHospitalsButton, 'background-color', '#6D9AB7');
      this.showLegendHospitalsDisponibility = false;
    }
  }


  toggleHospitalsCDMX() {

    const cdmxHospitalsButton = this.renderer.selectRootElement('.cdmxHospitalsButton', true);

    if (this.map.hasLayer(this.markerClusters['hospitalsCDMX'])) {
      this.map.removeLayer(this.markerClusters['hospitalsCDMX'])
      this.renderer.setStyle(cdmxHospitalsButton, 'background-color', '#6D9AB7');
      this.showLegendHospitalsDisponibility = false;
    }
    else {
      this.map.addLayer(this.markerClusters['hospitalsCDMX'])
      this.markerClusters['hospitalsCDMX'].disableClustering();
      this.renderer.setStyle(cdmxHospitalsButton, 'background-color', 'rgb(178, 56, 62, 1)');
      this.showLegendHospitalsDisponibility = true;
    }


  }


  togglePolulationChart() {
    //console.log("togglePolulationChart")
    if (this.showProjectionChart === false) {
      //console.log(this.projectionChartData)
      this.populationChart.data = this.projectionChartData;
      this.showProjectionChart = true;
      this.populationChart.titles.values[0].text = "Proyección 2020"
    }
    else {
      this.populationChart.data = this.populationChartData;
      this.showProjectionChart = false;
      this.populationChart.titles.values[0].text = "Censo 2010"

    }
  }

  initChartPopulation() {
    if (this.populationChart != undefined) {
      this.populationChart.data = this.populationChartData;

      return;
    }

    am4core.useTheme(am4themes_animated);

    this.populationChart = am4core.create("chartdiv", am4charts.PieChart);
    this.populationChart.hiddenState.properties.opacity = 0; // this creates initial fade-in

    let title = this.populationChart.titles.create();
    title.text = "Censo 2010";

    this.populationChart.legend = new am4charts.Legend();
    this.populationChart.legend.position = "bottom";
    this.populationChart.legend.itemContainers.template.paddingTop = 0
    //populationChart.legend.maxWidth = 100;
    this.populationChart.legend.fontSize = 14;
    var markerTemplate = this.populationChart.legend.markers.template;
    markerTemplate.width = 10;
    markerTemplate.height = 10;

    this.populationChart.data = this.populationChartData;


    let series = this.populationChart.series.push(new am4charts.PieSeries());

    series.colors.list = ["#FC8181", "#F6AD55", "#68D391"].map(function (color) {
      return am4core.color(color);
    });

    series.dataFields.value = "count";
    series.dataFields.category = "title";
    series.ticks.template.disabled = true;
    series.slices.template.tooltipText = "{value}";
    series.alignLabels = false;
    series.labels.template.text = "{value.percent.formatNumber('#.0')}%";
    series.labels.template.radius = am4core.percent(-40);
    series.labels.template.fill = am4core.color("white");
  }

  initChartProjection() {
    if (this.projectionChart != undefined) {
      this.projectionChart.data = this.projectionChartData;

      return;
    }

    am4core.useTheme(am4themes_animated);

    this.projectionChart = am4core.create("projectionChartDiv", am4charts.PieChart);
    this.projectionChart.hiddenState.properties.opacity = 0; // this creates initial fade-in

    let title = this.projectionChart.titles.create();
    title.text = "Proyección 2020";

    this.projectionChart.legend = new am4charts.Legend();
    this.projectionChart.legend.position = "bottom";
    this.projectionChart.legend.itemContainers.template.paddingTop = 0

    this.projectionChart.legend.fontSize = 14;
    var markerTemplate = this.projectionChart.legend.markers.template;
    markerTemplate.width = 10;
    markerTemplate.height = 10;

    this.projectionChart.data = this.projectionChartData;

    let series = this.projectionChart.series.push(new am4charts.PieSeries());

    series.colors.list = ["#FC8181", "#F6AD55", "#68D391"].map(function (color) {
      return am4core.color(color);
    });

    series.dataFields.value = "count";
    series.dataFields.category = "title";
    series.ticks.template.disabled = true;
    series.slices.template.tooltipText = "{value}";
    series.alignLabels = false;
    series.labels.template.text = "{value.percent.formatNumber('#.0')}%";
    series.labels.template.radius = am4core.percent(-40);
    series.labels.template.fill = am4core.color("white");
  }

  initChartVulnerabilityState() {
    if (this.vulnerabilityStateChart != undefined) {
      this.vulnerabilityStateChart.data = this.vulnerabilityStateChartData;

      return;
    }

    am4core.useTheme(am4themes_animated);

    this.vulnerabilityStateChart = am4core.create("vulnerabilityStateChartDiv", am4charts.PieChart);
    this.vulnerabilityStateChart.hiddenState.properties.opacity = 0; // this creates initial fade-in

    let title = this.vulnerabilityStateChart.titles.create();
    title.text = "Vulnerabilidad estado";

    this.vulnerabilityStateChart.legend = new am4charts.Legend();
    this.vulnerabilityStateChart.legend.position = "bottom";
    this.vulnerabilityStateChart.legend.itemContainers.template.paddingTop = 0

    this.vulnerabilityStateChart.legend.fontSize = 14;
    var markerTemplate = this.vulnerabilityStateChart.legend.markers.template;
    markerTemplate.width = 10;
    markerTemplate.height = 10;

    this.vulnerabilityStateChart.data = this.vulnerabilityStateChartData;

    let series = this.vulnerabilityStateChart.series.push(new am4charts.PieSeries());

    series.colors.list = ["#FC8181", "#F6AD55", "#68D391", "#68D391", "#68D391"].map(function (color) {
      return am4core.color(color);
    });

    series.dataFields.value = "count";
    series.dataFields.category = "title";
    series.ticks.template.disabled = true;
    series.slices.template.tooltipText = "{value}";
    series.alignLabels = false;
    series.labels.template.text = "{value.percent.formatNumber('#.0')}%";
    series.labels.template.radius = am4core.percent(-40);
    series.labels.template.fill = am4core.color("white");
  }

  initChartVulnerability() {
    if (this.vulnerabilityChart != undefined) {

      this.vulnerabilityChart.data = this.vulnerabilityChartData;

      return;
    }

    am4core.useTheme(am4themes_animated);
    // Themes end
    //colors: ['#FC8181', '#F6AD55', '#68D391'],

    this.vulnerabilityChart = am4core.create("chartVuldiv", am4charts.PieChart);
    this.vulnerabilityChart.hiddenState.properties.opacity = 0; // this creates initial fade-in

    let title = this.vulnerabilityChart.titles.create();
    title.text = "Servicio de salud";

    this.vulnerabilityChart.legend = new am4charts.Legend();
    this.vulnerabilityChart.legend.position = "bottom";
    this.vulnerabilityChart.legend.itemContainers.template.paddingTop = 0
    //vulnerabilityChart.legend.maxWidth = 100;
    this.vulnerabilityChart.legend.fontSize = 14;
    var markerTemplate = this.vulnerabilityChart.legend.markers.template;
    markerTemplate.width = 10;
    markerTemplate.height = 10;

    this.vulnerabilityChart.data = this.vulnerabilityChartData;

    let series = this.vulnerabilityChart.series.push(new am4charts.PieSeries());

    series.colors.list = ["#dc3912", "#ff9900", "#3366cc"].map(function (color) {
      return am4core.color(color);
    });

    /* 	series.colors.list = [
        new am4core.color('#FC8181'),
        new am4core.color('#F6AD55'),
        new am4core.color('#68D391'),
      ] */
    series.dataFields.value = "count";
    series.dataFields.category = "title";
    series.ticks.template.disabled = true;
    series.slices.template.tooltipText = "{value}";
    series.alignLabels = false;
    series.labels.template.text = "{value.percent.formatNumber('#.0')}%";
    series.labels.template.radius = am4core.percent(-40);
    series.labels.template.fill = am4core.color("white");

  }

  initChartPoverty() {
    if (this.povertyChart != undefined) {

      this.povertyChart.data = this.povertyChartData;

      /* 	  console.log(this.povertyChart)
          console.log(this.povertyChart.children.values[0].text )
          console.log(this.nivelPolygons ) */

      if (this.nivelPolygons == 'Localidad' || this.nivelPolygons == 'ZonaLocalidad' || this.nivelPolygons == 'ZonaAgeb' || this.nivelPolygons == 'Ageb')
        this.povertyChart.children.values[0].text = "% de pobreza (municipio)";
      else
        this.povertyChart.children.values[0].text = "% de pobreza";

      return;
    }

    am4core.useTheme(am4themes_animated);
    // Themes end
    //colors: ['#FC8181', '#F6AD55', '#68D391'],

    this.povertyChart = am4core.create("chartPovertydiv", am4charts.XYChart);
    //this.povertyChart.scrollbarX = new am4core.Scrollbar();
    let title = this.povertyChart.titles.create();
    title.text = "% de pobreza";

    this.povertyChart.data = this.povertyChartData;


    // Create axes
    let categoryAxis = this.povertyChart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "title";
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 30;
    categoryAxis.renderer.labels.template.horizontalCenter = "right";
    categoryAxis.renderer.labels.template.verticalCenter = "middle";
    categoryAxis.renderer.labels.template.rotation = 270;
    categoryAxis.renderer.labels.template.fontSize = 12;
    categoryAxis.tooltip.disabled = true;
    categoryAxis.renderer.minHeight = 110;

    let valueAxis = this.povertyChart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.minWidth = 50;

    // Create series
    let series = this.povertyChart.series.push(new am4charts.ColumnSeries());
    series.sequencedInterpolation = true;
    series.dataFields.valueY = "count";
    series.dataFields.categoryX = "title";
    series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
    series.columns.template.strokeWidth = 0;

    series.tooltip.pointerOrientation = "vertical";

    series.columns.template.column.cornerRadiusTopLeft = 10;
    series.columns.template.column.cornerRadiusTopRight = 10;
    series.columns.template.column.fillOpacity = 0.8;

    // on hover, make corner radiuses bigger
    let hoverState = series.columns.template.column.states.create("hover");
    hoverState.properties.cornerRadiusTopLeft = 0;
    hoverState.properties.cornerRadiusTopRight = 0;
    hoverState.properties.fillOpacity = 1;

    let that = this;
    series.columns.template.adapter.add("fill", function (fill, target) {
      return that.povertyChart.colors.getIndex(target.dataItem.index);
    });

    // Cursor
    this.povertyChart.cursor = new am4charts.XYCursor();


    /* 	this.povertyChart.hiddenState.properties.opacity = 0; // this creates initial fade-in
    	
      let title = this.povertyChart.titles.create();
      title.text = "Servicio de salud";
    
      this.povertyChart.legend = new am4charts.Legend();
      this.povertyChart.legend.position = "bottom"; 
      this.povertyChart.legend.itemContainers.template.paddingTop = 0
      //vulnerabilityChart.legend.maxWidth = 100;
      this.povertyChart.legend.fontSize = 14;
      var markerTemplate = this.povertyChart.legend.markers.template;
      markerTemplate.width = 10;
      markerTemplate.height = 10;
    	
      this.povertyChart.data = this.vulnerabilityChartData;
    
      let series = this.povertyChart.series.push(new am4charts.PieSeries());
    	
      series.colors.list = ["#dc3912","#ff9900","#3366cc"].map(function(color) {
          return am4core.color(color);
      });	
    	
      series.dataFields.value = "count";
      series.dataFields.category = "title";
      series.ticks.template.disabled = true;
      series.slices.template.tooltipText = "{value}";
      series.alignLabels = false;
      series.labels.template.text = "{value.percent.formatNumber('#.0')}%";
      series.labels.template.radius = am4core.percent(-40);
      series.labels.template.fill = am4core.color("white");  */

  }



  initChartMortality() {
    if (this.mortalityRateChart != undefined) {

      this.mortalityRateChart.data = this.mortalityRateChartData;

      return;
    }

    /* Chart code */
    // Themes begin
    if (this.nivelPolygons != 'Country' && this.nivelPolygons != 'UrbanAreas') {

      am4core.useTheme(am4themes_animated);
      // Themes end

      // create chart
      this.mortalityRateChart = am4core.create("chartMortalityRatediv", am4charts.TreeMap);
      this.mortalityRateChart.hiddenState.properties.opacity = 0; // this makes initial fade in effect

      let title = this.mortalityRateChart.titles.create();
      title.text = "Tasa de mortalidad";

      this.mortalityRateChart.data = this.mortalityRateChartData;

      this.mortalityRateChart.colors.step = 2;

      // define data fields
      this.mortalityRateChart.dataFields.value = "value";
      this.mortalityRateChart.dataFields.name = "name";
      this.mortalityRateChart.dataFields.color = "color";
      //this.mortalityRateChart.dataFields.children = "children";
      this.mortalityRateChart.zoomable = false;

      this.mortalityRateChart.legend = new am4charts.Legend();
      this.mortalityRateChart.legend.position = "bottom";
      this.mortalityRateChart.legend.itemContainers.template.paddingTop = 0
      //mortalityRateChart.legend.maxWidth = 100;
      this.mortalityRateChart.legend.fontSize = 10;
      var markerTemplate = this.mortalityRateChart.legend.markers.template;
      markerTemplate.width = 10;
      markerTemplate.height = 10;

      /* Configure top-level series */
      var level1 = this.mortalityRateChart.seriesTemplates.create("0");
      var level1_column = level1.columns.template;
      level1_column.column.cornerRadius(10, 10, 10, 10);
      level1_column.fillOpacity = 0.8;
      level1_column.stroke = am4core.color("#fff");
      level1_column.strokeWidth = 5;
      level1_column.strokeOpacity = 1;

      level1.tooltip.pointerOrientation = 'down';
    }
  }

  initChartInfra(infraData) {
    if (this.infraChart != undefined) {
      this.infraChart.destroy();
      this.infraChart = undefined
    }
    let infraCanvas = document.getElementById('infraCanvas');
    let birdsData = {
      labels: ["Farmacias", "Consultorios públicos", "Consultorios privados", "Hospitales públicos", "Hospitales privados", "Ventiladores"],
      datasets: [
        {
          label: "Consultorios",
          data: [infraData[0], infraData[1], infraData[2]],
          pointBackgroundColor: ['#ff666a', '#50c5c5', '#ce82d5'],
          backgroundColor: "rgba(151,187,205,0.5)"
        },
        {
          label: "Hospitales",
          data: [, , , infraData[3], infraData[4], infraData[5]],
          pointBackgroundColor: ['#00ACEE', '#198e3c', '#781b0d'],
          backgroundColor: "rgba(151,187,205,0.5)"
        }
      ]
    };

    let chartData = {
      "labels": ["Farmacias", "Consultorios públicos", "Consultorios privados", "Hospitales públicos", "Hospitales privados", "Ventiladores"],
      "datasets": [{ "label": "Consultorios", "data": [infraData[0], infraData[1], infraData[2]], "fill": true, "backgroundColor": "rgba(255, 99, 132, 0.2)", "borderColor": "rgb(255, 99, 132)", "pointBackgroundColor": "rgb(255, 99, 132)", "pointBorderColor": "#fff", "pointHoverBackgroundColor": "#fff", "pointHoverBorderColor": "rgb(255, 99, 132)" },
      { "label": "Hospitales", "data": [, , , infraData[3], infraData[4], infraData[5]], "fill": true, "backgroundColor": "rgba(54, 162, 235, 0.2)", "borderColor": "rgb(54, 162, 235)", "pointBackgroundColor": "rgb(54, 162, 235)", "pointBorderColor": "#fff", "pointHoverBackgroundColor": "#fff", "pointHoverBorderColor": "rgb(54, 162, 235)" }
      ]

    }

    let optionsChart = {
      "elements":
      {
        "line":
        {
          "tension": 0,
          "borderWidth": 3
        }
      }

    }

    let chartOptionsRadar = {
      legend: {
        display: true
      },
      scale: {
        angleLines: {
          color: "#1A202C"
        },
        gridLines: {
          color: "#1A202C"
        },
        ticks: {
          display: false
          //backdropColor: 'rgba(255, 0, 0, 0.75)'
        },
        pointLabels: {
          fontColor: "#1A202C",
          fontSize: 10
        }
      }
    };


    this.infraChart = new Chart(infraCanvas, {
      type: 'radar',
      data: chartData,
      options: chartOptionsRadar
    });


  }


  initChartVentilators() {
    if (this.ventilatorsChart != undefined) {
      this.ventilatorsChart.data = this.ventilatorsChartData;
      return;
    }

    am4core.useTheme(am4themes_animated);

    // create chart
    this.ventilatorsChart = am4core.create("chartVentDiv", am4charts.TreeMap);
    this.ventilatorsChart.hiddenState.properties.opacity = 0; // this makes initial fade in effect

    this.ventilatorsChart.padding(0, 0, 0, 0);

    this.ventilatorsChart.data = this.ventilatorsChartData;
    //console.log(this.ventilatorsChart.data)

    // only one level visible initially
    this.ventilatorsChart.maxLevels = 1;
    // define data fields
    this.ventilatorsChart.dataFields.value = "value";
    this.ventilatorsChart.dataFields.name = "name";
    this.ventilatorsChart.dataFields.children = "children";
    this.ventilatorsChart.dataFields.color = "color";

    /*     let subtitle = this.ventilatorsChart.titles.create();
        subtitle.text = "Total de camas y ventiladores";
        subtitle.fontSize = 12; */

    let title = this.ventilatorsChart.titles.create();
    title.text = "Camas totales";

    this.ventilatorsChart.sorting = "ascending";

    this.ventilatorsChart.tooltip.zIndex = 99;
    this.ventilatorsChart.tooltip.pointerOrientation = 'down';

    // level 0 series template
    var level0SeriesTemplate = this.ventilatorsChart.seriesTemplates.create("0");
    var level1_column = level0SeriesTemplate.columns.template;

    level1_column.fillOpacity = 0.8;
    level1_column.stroke = am4core.color("#fff");
    level1_column.strokeWidth = 5;
    level1_column.strokeOpacity = 1;

    level0SeriesTemplate.strokeWidth = 2;
    level0SeriesTemplate.tooltip.disabled = true;

    let bullet0 = level0SeriesTemplate.bullets.push(new am4charts.LabelBullet());
    bullet0.locationX = 0.5;
    bullet0.locationY = 0.5;

    bullet0.label.textAlign = 'middle';
    bullet0.label.text = "{name}: {realValue}";
    bullet0.label.fill = am4core.color("#ffffff");
    bullet0.fontSize = 12;

    // level1 series template
    var level1SeriesTemplate = this.ventilatorsChart.seriesTemplates.create("1");

    var bullet1 = level1SeriesTemplate.bullets.push(new am4charts.LabelBullet());
    bullet1.locationX = 0.5;
    bullet1.locationY = 0.5;

    bullet1.label.textAlign = 'middle';
    bullet1.label.text = "{name}: {realValue}";
    bullet1.label.fill = am4core.color("#ffffff");
    bullet1.fontSize = 12;

    level1SeriesTemplate.columns.template.fillOpacity = 0;

    level1SeriesTemplate.tooltip.disabled = true;

    level1SeriesTemplate.hiddenInLegend = true;

    this.ventilatorsChart.layoutAlgorithm = this.ventilatorsChart.slice;
  }

  initChartHospitals() {
    if (this.hospitalsChart != undefined) {
      this.hospitalsChart.data = this.hospitalsChartData;
      return;
    }

    am4core.useTheme(am4themes_animated);

    // create chart
    this.hospitalsChart = am4core.create("chartHospitalsdiv", am4charts.TreeMap);
    this.hospitalsChart.hiddenState.properties.opacity = 0; // this makes initial fade in effect

    this.hospitalsChart.padding(0, 0, 0, 0);
    this.hospitalsChart.data = this.hospitalsChartData;

    // only one level visible initially
    this.hospitalsChart.maxLevels = 1;

    // define data fields
    this.hospitalsChart.dataFields.value = "value";
    this.hospitalsChart.dataFields.name = "name";
    this.hospitalsChart.dataFields.children = "children";
    this.hospitalsChart.dataFields.color = "color";

    let title = this.hospitalsChart.titles.create();
    title.text = "Hospitales";

    this.hospitalsChart.sorting = "ascending"

    // level 0 series template
    var level0SeriesTemplate = this.hospitalsChart.seriesTemplates.create("0");
    var level1_column = level0SeriesTemplate.columns.template;

    level1_column.fillOpacity = 0.8;
    level1_column.stroke = am4core.color("#fff");
    level1_column.strokeWidth = 5;
    level1_column.strokeOpacity = 1;

    level0SeriesTemplate.strokeWidth = 2;

    level0SeriesTemplate.tooltip.disabled = true;

    let bullet0 = level0SeriesTemplate.bullets.push(new am4charts.LabelBullet());
    bullet0.locationX = 0.5;
    bullet0.locationY = 0.5;

    bullet0.label.textAlign = 'middle';
    bullet0.label.text = "{name}: {realValue}";
    bullet0.label.fill = am4core.color("#ffffff");
    bullet0.fontSize = 12;

    // create hover state
    var hoverState = level0SeriesTemplate.columns.template.states.create("hover");

    // level1 series template
    var level1SeriesTemplate = this.hospitalsChart.seriesTemplates.create("1");
    var bullet1 = level1SeriesTemplate.bullets.push(
      new am4charts.LabelBullet()
    );
    bullet1.locationX = 0.5;
    bullet1.locationY = 0.5;
    bullet1.label.textAlign = 'middle';
    bullet1.label.text = "{name}: {realValue}";
    bullet1.label.fill = am4core.color("#ffffff");
    bullet1.fontSize = 12;

    level1SeriesTemplate.columns.template.fillOpacity = 0;

    level1SeriesTemplate.tooltip.disabled = true;

    level1SeriesTemplate.hiddenInLegend = true;

    this.hospitalsChart.layoutAlgorithm = this.hospitalsChart.slice;
  }

  initChartInfraestructure() {
    if (this.infraestructureChart != undefined) {
      this.infraestructureChart.data = this.infraestructureChartData;

      return;
    }

    /* Chart code */
    // Themes begin
    am4core.useTheme(am4themes_animated);
    // Themes end

    // create chart
    this.infraestructureChart = am4core.create("chartInfradiv", am4charts.TreeMap);
    this.infraestructureChart.hiddenState.properties.opacity = 0; // this makes initial fade in effect

    let title = this.infraestructureChart.titles.create();
    title.text = "Hospitales COVID";

    this.infraestructureChart.data = this.infraestructureChartData;

    // define data fields
    this.infraestructureChart.dataFields.value = "value";
    this.infraestructureChart.dataFields.name = "name";
    this.infraestructureChart.dataFields.color = "color";
    //this.infraestructureChart.dataFields.children = "children";
    this.infraestructureChart.zoomable = false;

    this.infraestructureChart.sorting = 'ascending';

    /* Configure top-level series */
    var level1 = this.infraestructureChart.seriesTemplates.create("0");
    var level1_column = level1.columns.template;
    level1_column.fillOpacity = 0.8;
    level1_column.stroke = am4core.color("#fff");
    level1_column.strokeWidth = 5;
    level1_column.strokeOpacity = 1;

    level1.tooltip.pointerOrientation = 'down';

    level1.tooltip.disabled = true;

    let bullet0 = level1.bullets.push(new am4charts.LabelBullet());
    bullet0.locationX = 0.5;
    bullet0.locationY = 0.5;

    bullet0.label.textAlign = 'middle';
    bullet0.label.text = "{name}: {realValue}";
    bullet0.label.fill = am4core.color("#ffffff");
    bullet0.fontSize = 12;

    this.infraestructureChart.layoutAlgorithm = this.infraestructureChart.slice;
  }


  initChartCovid(AgesData, total) {
    this.covidChartData = [];
    Object.keys(AgesData).forEach((key, index) => {
      let chartData: any = {};
      switch (index) {
        case 0:
          chartData.title = 'PERSONAS ENTRE 0 Y 18 AÑOS';
          chartData.icon = 'icon-young';
          break;
        case 1:
          chartData.title = 'PERSONAS ENTRE 19 Y 30 AÑOS';
          chartData.icon = 'icon-mature';
          break;
        case 2:
          chartData.title = 'PERSONAS ENTRE 31 Y 60 AÑOS';
          chartData.icon = 'icon-granny';
          break;
        case 3:
          chartData.title = 'PERSONAS DE MÁS DE 60 AÑOS';
          chartData.icon = 'icon-old';
          break;
      }

      chartData.men = AgesData[key][0];
      chartData.women = AgesData[key][1];
      chartData.total = AgesData[key][0] + AgesData[key][1];
      chartData.menPct = (AgesData[key][0]) * 100 / chartData.total;
      chartData.womenPct = (AgesData[key][1]) * 100 / chartData.total;
      chartData.tooltipMen = 'De ' + chartData.total + ' personas confirmadas, ' + chartData.men + ' son hombres (' + chartData.menPct.toFixed(2) + '%)';
      chartData.styleMen = chartData.menPct + '%';
      chartData.tooltipWomen = 'De ' + chartData.total + ' personas confirmadas, ' + chartData.women + ' son mujeres (' + chartData.womenPct.toFixed(2) + '%)';
      chartData.styleWomen = chartData.womenPct + '%';

      if (chartData.men > 0) {
        chartData.displayMen = 'inline-block';
      } else {
        chartData.displayMen = 'none';
      }

      if (chartData.women > 0) {
        chartData.displayWomen = 'inline-block';
      } else {
        chartData.displayWomen = 'none'
      };

      this.covidChartData.push(chartData);
    });

    let chartData: any = {};
    chartData.title = 'TOTAL';
    chartData.icon = 'icon-corona';
    chartData.men = this.covidData['totalMen'].total;
    chartData.women = this.covidData['totalWomen'].total;
    chartData.total = this.covidData['totalCases'].total;
    chartData.menPct = (chartData.men) * 100 / chartData.total;
    chartData.womenPct = (chartData.women) * 100 / chartData.total;
    chartData.tooltipMen = 'De ' + chartData.total + ' personas confirmadas, ' + chartData.men + ' son hombres (' + chartData.menPct.toFixed(2) + '%)';
    chartData.styleMen = chartData.menPct + '%';
    chartData.tooltipWomen = 'De ' + chartData.total + ' personas confirmadas, ' + chartData.women + ' son mujeres (' + chartData.womenPct.toFixed(2) + '%)';
    chartData.styleWomen = chartData.womenPct + '%';

    if (chartData.men > 0) {
      chartData.displayMen = 'inline-block';
    } else {
      chartData.displayMen = 'none';
    }

    if (chartData.women > 0) {
      chartData.displayWomen = 'inline-block';
    } else {
      chartData.displayWomen = 'none'
    };

    this.covidChartData.push(chartData);

  }


  initCovidAgesChart(AgesData, total) {

    if (this.covidAgesChart != undefined) {
      this.covidAgesChart.data = AgesData;
      let total_casos = new Intl.NumberFormat('en-US').format(total)
      this.covidAgesChart.children.values[1].text = "Total de casos confirmados: " + total_casos;

      return;
    }

    /* Chart code */
    // Themes begin
    am4core.useTheme(am4themes_animated);
    // Themes end

    //console.log(AgesData)

    // Create chart instance
    this.covidAgesChart = am4core.create("chartAgesCovid", am4charts.XYChart);

    let total_casos = new Intl.NumberFormat('en-US').format(total)
    let label = this.covidAgesChart.createChild(am4core.Label);
    label.text = "Total de casos confirmados: " + total_casos;
    //label.align = "center";
    label.exportable = false;
    this.covidAgesChart.zoomable = false;

    /* 	// Add data
      this.covidAgesChart.data = [{
        "age": "85+",
        "male": 0.1,
        "female": 0.3
      }, {
        "age": "80-54",
        "male": 0.2,
        "female": 0.3
      }, {
        "age": "75-79",
        "male": 0.3,
        "female": 0.6
      }, {
        "age": "70-74",
        "male": 0.5,
        "female": 0.8
      }, {
        "age": "65-69",
        "male": 0.8,
        "female": 1.0
      }, {
        "age": "60-64",
        "male": 1.1,
        "female": 1.3
      }, {
        "age": "55-59",
        "male": 1.7,
        "female": 1.9
      }, {
        "age": "50-54",
        "male": 2.2,
        "female": 2.5
      }, {
        "age": "45-49",
        "male": 2.8,
        "female": 3.0
      }, {
        "age": "40-44",
        "male": 3.4,
        "female": 3.6
      }, {
        "age": "35-39",
        "male": 4.2,
        "female": 4.1
      }, {
        "age": "30-34",
        "male": 5.2,
        "female": 4.8
      }, {
        "age": "25-29",
        "male": 5.6,
        "female": 5.1
      }, {
        "age": "20-24",
        "male": 5.1,
        "female": 5.1
      }, {
        "age": "15-19",
        "male": 3.8,
        "female": 3.8
      }, {
        "age": "10-14",
        "male": 3.2,
        "female": 3.4
      }, {
        "age": "5-9",
        "male": 4.4,
        "female": 4.1
      }, {
        "age": "0-4",
        "male": 5.0,
        "female": 4.8
      }];
    
     */
    this.covidAgesChart.data = AgesData;
    // Use only absolute numbers
    //this.covidAgesChart.numberFormatter.numberFormat = "#.#s";

    // Create axes
    let categoryAxis = this.covidAgesChart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "category";
    /* 	categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.inversed = true; */
    categoryAxis.renderer.labels.template.location = 0.5;
    //categoryAxis.renderer.labels.template.rotation = 300;
    categoryAxis.renderer.labels.template.fontSize = 10;
    categoryAxis.renderer.grid.template.strokeOpacity = 0.1;
    categoryAxis.renderer.axisFills.template.disabled = true;
    categoryAxis.renderer.minGridDistance = 30;
    categoryAxis.mouseEnabled = false;


    let valueAxis = this.covidAgesChart.xAxes.push(new am4charts.ValueAxis());
    //	valueAxis.extraMin = 0.1;
    //	valueAxis.extraMax = 0.1;
    //	valueAxis.renderer.minGridDistance = 40;
    valueAxis.renderer.labels.template.fontSize = 10;
    /*     valueAxis.renderer.ticks.template.length = 5;
        valueAxis.renderer.ticks.template.disabled = false;
        valueAxis.renderer.ticks.template.strokeOpacity = 0.4; */
    /* 	valueAxis.renderer.labels.template.adapter.add("text", function(text) {
        return text == "Male" || text == "Female" ? text : text + "%";
      }) 
     */

    //create series
    let series1 = this.covidAgesChart.series.push(new am4charts.ColumnSeries());
    series1.dataFields.valueX = "value1";
    series1.dataFields.categoryY = "category";
    series1.stacked = true;
    series1.name = "Hombres";
    series1.columns.template.stroke = am4core.color("#6D9AB7");
    series1.columns.template.fill = am4core.color("#6D9AB7");
    series1.dataFields.valueY = "total";
    series1.columns.template.tooltipText = "{valueX.value} {name} de {valueY.value}";
    series1.strokeWidth = 0;
    series1.stacked = true;
    series1.tooltip.zIndex = 99;
    series1.tooltip.pointerOrientation = 'down';

    let series2 = this.covidAgesChart.series.push(new am4charts.ColumnSeries());
    series2.dataFields.valueX = "value2";
    series2.dataFields.valueY = "total";
    series2.dataFields.categoryY = "category";
    series2.stacked = true;
    series2.name = "Mujeres";
    series2.columns.template.stroke = am4core.color("#ECC1C1");
    series2.columns.template.fill = am4core.color("#ECC1C1");
    series2.columns.template.tooltipText = "{valueX.value} {name} de {valueY.value}";
    series2.strokeWidth = 0;
    series2.stacked = true;
    series2.tooltip.zIndex = 99;
    series2.tooltip.pointerOrientation = 'down';

    this.covidAgesChart.legend = new am4charts.Legend();

  }



  initCovidAgesChart2(AgesData, total) {

    if (this.covidAgesChart != undefined) {
      this.covidAgesChart.data = AgesData;
      let total_casos = new Intl.NumberFormat('en-US').format(total)
      this.covidAgesChart.children.values[1].text = "Total de casos confirmados: " + total_casos;

      return;
    }

    am4core.useTheme(am4themes_animated);
    // Themes end

    this.covidAgesChart = am4core.create("chartAgesCovid", am4charts.RadarChart);
    this.covidAgesChart.hiddenState.properties.opacity = 0; // this creates initial fade-in

    let total_casos = new Intl.NumberFormat('en-US').format(total)
    let label = this.covidAgesChart.createChild(am4core.Label);
    label.text = "Total de casos confirmados: " + total_casos;
    //label.align = "center";
    label.exportable = false;

    this.covidAgesChart.data = AgesData;

    //console.log('chartdata', this.covidAgesChart.data)
    this.covidAgesChart.radius = am4core.percent(95);
    this.covidAgesChart.startAngle = 270 - 180;
    this.covidAgesChart.endAngle = 270 + 180;
    this.covidAgesChart.innerRadius = am4core.percent(60);

    let categoryAxis = this.covidAgesChart.xAxes.push(new am4charts.CategoryAxis() as any);
    categoryAxis.dataFields.category = "category";
    categoryAxis.renderer.labels.template.location = 0.6;
    categoryAxis.renderer.labels.template.rotation = 300;
    categoryAxis.renderer.labels.template.fontSize = 12;
    categoryAxis.renderer.grid.template.strokeOpacity = 0.1;
    categoryAxis.renderer.axisFills.template.disabled = true;
    categoryAxis.renderer.minGridDistance = 30;
    categoryAxis.mouseEnabled = false;

    let valueAxis = this.covidAgesChart.yAxes.push(new am4charts.ValueAxis() as any);
    valueAxis.tooltip.disabled = true;
    valueAxis.renderer.grid.template.strokeOpacity = 0.05;
    valueAxis.renderer.axisFills.template.disabled = true;
    valueAxis.renderer.axisAngle = 260;
    valueAxis.renderer.labels.template.horizontalCenter = "right";
    valueAxis.renderer.labels.template.fontSize = 10;
    valueAxis.min = 0;

    let series1 = this.covidAgesChart.series.push(new am4charts.RadarColumnSeries());
    series1.columns.template.radarColumn.strokeOpacity = 1;
    series1.name = "Hombres";
    series1.dataFields.categoryX = "category";
    series1.columns.template.tooltipText = "{valueY.value} {name} de {valueX.value}";
    series1.dataFields.valueY = "value1";
    series1.dataFields.valueX = "total";
    series1.strokeWidth = 0;
    series1.stacked = true;

    let series2 = this.covidAgesChart.series.push(new am4charts.RadarColumnSeries());
    series2.columns.template.radarColumn.strokeOpacity = 1;
    series2.columns.template.stroke = am4core.color("#ff0080");
    series2.columns.template.fill = am4core.color("#ff0080");
    series2.name = "Mujeres";
    series2.dataFields.categoryX = "category";
    series2.columns.template.tooltipText = "{valueY.value} {name} de {valueX.value}";
    series2.dataFields.valueY = "value2";
    series2.dataFields.valueX = "total";
    series2.strokeWidth = 0;
    series2.stacked = true;

    /* Add legend */
    //this.covidAgesChart.legend = new am4charts.Legend();	

    let slider = this.covidAgesChart.createChild(am4core.Slider);
    slider.start = 0.0;
    slider.exportable = false;
    let that = this;
    slider.events.on("rangechanged", function () {
      let start = slider.start;

      that.covidAgesChart.startAngle = 270 - start * 179 - 1;
      that.covidAgesChart.endAngle = 270 + start * 179 + 1;

      valueAxis.renderer.axisAngle = that.covidAgesChart.startAngle;
    });
  }

  gotoDashboard() {
    window.open('https://datos.covid-19.conacyt.mx/', '_blank');
  }

  toggleFlipCard(event, cardType) {
    let elementClass = event.target.className;
    let card;
    let canFlip = false;
    try {
      canFlip = elementClass.includes('can-flip');
    } catch (error) {
      canFlip = false;
    }
    if (canFlip) {
      switch (cardType) {
        case 'population':
          card = document.querySelector('#populationFlipCard');
          card.classList.toggle('is-flipped');
          break;
        case 'projection':
          card = document.querySelector('#projectionFlipCard');
          card.classList.toggle('is-flipped');
          break;
        case 'health':
          card = document.querySelector('#healthFlipCard');
          card.classList.toggle('is-flipped');
          break;
        case 'mortality':
          card = document.querySelector('#mortalityFlipCard');
          card.classList.toggle('is-flipped');
          break;
        case 'poverty':
          card = document.querySelector('#povertyFlipCard');
          card.classList.toggle('is-flipped');
          break;
      }
    }
  }

  resetTitleMapWms(baseMap, selectedMap) {
    let that = this;
    let activate = false
    for (const base of Object.keys(baseMap)) {
      if (baseMap[base].active) {
        activate = true
      }
    }

    if (activate) {
      for (const polygon of Object.keys(this.polygons)) {
        if (this.polygons[polygon] != undefined) {
          this.polygons[polygon].eachLayer(function (layer) {
            if (polygon == "select_country") {
              if (that.select_state === undefined || that.select_state.properties.entidad_cvegeo != layer.feature.properties.entidad_cvegeo) {
                layer.setStyle({
                  "color": "#000000",
                  "opacity": 0.5,
                  "fillOpacity": 0.1,
                  "weight": 1
                })
              } else {
                layer.setStyle({
                  "color": "#000000",
                  "opacity": 0.5,
                  "fillOpacity": 0.1,
                  "weight": 6
                })
              }
            } else {
              layer.setStyle({
                "color": '#000000',
                "opacity": 0.5,
                "fillOpacity": 0.1,
                "weight": 1
              })
            }
          });
        }
      };

      this.showLayerWms = true;
      this.legendWms = [];
      if (this.nivelPolygons == "Country") {
        this.showLegend = false;
      }
      if (this.nivelPolygons == "Estado") {
        this.showLegendByMunicipalities = false;
      }


      for (const base of Object.keys(baseMap)) {
        if (base == selectedMap) {
          this.map.removeLayer(baseMap[base].layer);
          let layers = baseMap[base].layer.options.layers
          let style = baseMap[base].layer.options.styles
          let url = ""
          this.map.addLayer(baseMap[base].layer);
          if (selectedMap != "raster") {
            url = "http://idegeo.centrogeo.org.mx/geoserver/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=" + layers + "&style=" + style + "&transparent=true&LEGEND_OPTIONS=fontColor:0xFFFFFF"
          }

          this.legendWms = [{
            url: url,
            name: baseMap[base].name
          }]

        } else {
          const selectedDiv = document.getElementById(base);
          selectedDiv.classList.remove('active');
          baseMap[base].active = false;
          this.map.removeLayer(baseMap[base].layer);
        }
      };
    }
  }

  toggleTitleMap(baseMap, selectedMap) {
    /* 	  console.log(this.status_wms["urbanAreas"])
        console.log(baseMap)
        console.log(selectedMap) */
    let that = this;
    let activate = false
    for (const base of Object.keys(baseMap)) {
      if (baseMap[base].active) {
        activate = true
      }
    }

    if (activate) {
      this.statusMapModeExposition = false;
      this.showLegendAreaExposition = false;

      if (this.zoneGeoJsonExposition != undefined) {
        this.map.removeLayer(this.zoneGeoJsonExposition);
        this.zoneGeoJsonExposition = undefined;
      }

      if (this.cdmx_mode) {
        if (this.polygons["select_urban_areas"] != undefined) {
          this.polygons["select_urban_areas"].eachLayer(function (layer) {
            if (that.select_metropolitan === undefined || that.select_metropolitan.properties.entidad_cvegeo != layer.feature.properties.entidad_cvegeo) {
              layer.setStyle({
                "color": '#6C3721',
                "opacity": 0.3,
                "weight": 1
              })
            } else {
              layer.setStyle({
                "color": '#6C3721',
                "opacity": 0.3,
                "weight": 6
              })
            }
          });
        };

        if (this.polygons["select_state"] != undefined) {
          this.polygons["select_state"].eachLayer(function (layer) {
            layer.setStyle({
              "color": '#2F855A',
              "opacity": 0.3,
              "weight": 1
            })
          });
        };
      } else {
        this.resetPolygonStatesExposition();
      }
      const controlMapButton = this.renderer.selectRootElement('.showMapModeExposition', true);
      this.renderer.setStyle(controlMapButton, 'background-color', '#6D9AB7');
      // const controlMapButtonNormal = this.renderer.selectRootElement('.showMapModeExpositionModoNormal', true);
      // this.renderer.setStyle(controlMapButtonNormal, 'background-color', 'rgb(56, 178, 172, 0.7)');
      const controlMapButtonNormalCountry = this.renderer.selectRootElement('.showMapModeExpositionModoNormalCountry', true);
      this.renderer.setStyle(controlMapButtonNormalCountry, 'background-color', '#6D9AB7');
      //this.renderer.setStyle(controlMapButtonNormalCountry, 'background-color', 'rgb(56, 178, 172, 0.7)');  
      const controlMapButtonRegion = this.renderer.selectRootElement('.showMapModeExpositionModoRegion', true);
      this.renderer.setStyle(controlMapButtonRegion, 'background-color', '#6D9AB7');
      
      document.getElementById("showMapExpositionModoNormalCountry").classList.remove('active');
      document.getElementById("showMapExpositionModoNormalMunicipality").classList.remove('active');
  
      document.getElementById("showMapCovidModoNormalCountry").classList.remove('active');
      document.getElementById("showMapCovidModoNormalMunicipality").classList.remove('active');

      document.getElementById("showMapCovidModoRegionCountry").classList.remove('active');
      document.getElementById("showMapExpositionModoRegionCountry").classList.remove('active');

      document.getElementById("showMapCovidModoRegionMunicipality").classList.remove('active');
      document.getElementById("showMapExpositionModoRegionMunicipality").classList.remove('active');
      
      switch (this.nivelPolygons) {
        case 'Country':
          if (this.status_wms["states"] != undefined) {
            for (const base of Object.keys(this.status_wms["states"])) {
              this.status_wms["states"][base].active = false;
              this.map.removeLayer(this.status_wms["states"][base].layer);
              const selectedDiv = document.getElementById(base);
              selectedDiv.classList.remove('active');
            }
          }
          break;
        case 'Estado':
          if (this.status_wms["country"] != undefined) {
            for (const base of Object.keys(this.status_wms["country"])) {
              this.status_wms["country"][base].active = false;
              this.map.removeLayer(this.status_wms["country"][base].layer);
              const selectedDiv = document.getElementById(base);
              selectedDiv.classList.remove('active');
            }
          }
          break;
        case 'Metropolitan':
        case 'UrbanAreas':
        case 'ZonaUrbanArea':
          if (this.status_wms["states"] != undefined) {
            for (const base of Object.keys(this.status_wms["states"])) {
              this.status_wms["states"][base].active = false;
              this.map.removeLayer(this.status_wms["states"][base].layer);
              const selectedDiv = document.getElementById(base);
              selectedDiv.classList.remove('active');
            }
          }
          break;
        case 'ZonaMunicipio':
          if (this.status_wms["urbanAreas"] != undefined) {
            for (const base of Object.keys(this.status_wms["urbanAreas"])) {
              this.status_wms["urbanAreas"][base].active = false;
              this.map.removeLayer(this.status_wms["urbanAreas"][base].layer);
              const selectedDiv = document.getElementById(base);
              selectedDiv.classList.remove('active');
            }
          }
          break;
      }

      for (const polygon of Object.keys(this.polygons)) {
        if (this.polygons[polygon] != undefined) {
          this.polygons[polygon].eachLayer(function (layer) {
            if (polygon == "select_ageb") {
              layer.setStyle({
                "color": '#000000',
                "opacity": 0.7,
              })
            }
            if (polygon != "select_ageb") {
              layer.setStyle({
                "color": '#000000',
                "opacity": 0.5,
                "fillOpacity": 0.1,
                "weight": 1
              })
            }

            if (polygon == "select_country") {
              if (that.select_state === undefined || that.select_state.properties.entidad_cvegeo != layer.feature.properties.entidad_cvegeo) {
                layer.setStyle({
                  "color": "#000000",
                  "opacity": 0.5,
                  "fillOpacity": 0.1,
                  "weight": 1
                })
              } else {
                layer.setStyle({
                  "color": "#000000",
                  "opacity": 0.5,
                  "fillOpacity": 0.1,
                  "weight": 6
                })
              }
            }

            if (polygon == "select_state") {
              if (that.select_municipality === undefined || that.select_municipality.properties.municipio_cvegeo != layer.feature.properties.municipio_cvegeo) {
                layer.setStyle({
                  "color": "#000000",
                  "opacity": 0.5,
                  "fillOpacity": 0.1,
                  "weight": 1
                })
              } else {
                layer.setStyle({
                  "color": "#000000",
                  "opacity": 0.5,
                  "fillOpacity": 0.1,
                  "weight": 6
                })
              }
            }

            if (polygon == "select_urban_areas") {
              if (that.select_metropolitan === undefined || that.select_metropolitan.properties.entidad_cvegeo != layer.feature.properties.entidad_cvegeo) {
                layer.setStyle({
                  "color": "#000000",
                  "opacity": 0.5,
                  "fillOpacity": 0.1,
                  "weight": 1
                })
              } else {
                layer.setStyle({
                  "color": "#000000",
                  "opacity": 0.5,
                  "fillOpacity": 0.1,
                  "weight": 6
                })
              }
            }
          });
        }
      };

      this.showLayerWms = true;
      this.legendWms = [];
      if (this.nivelPolygons == "Country") {
        this.showLegend = false;
      }

      for (const base of Object.keys(baseMap)) {
        if (base == selectedMap) {
          let layers = baseMap[base].layer.options.layers
          let style = baseMap[base].layer.options.styles
          let url = ""
          this.map.addLayer(baseMap[base].layer);
          if (selectedMap != "raster") {
            url = "http://idegeo.centrogeo.org.mx/geoserver/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=" + layers + "&style=" + style + "&transparent=true&LEGEND_OPTIONS=fontColor:0xFFFFFF"
          }

          this.legendWms = [{
            url: url,
            name: baseMap[base].name
          }]
        } else {
          const selectedDiv = document.getElementById(base);
          selectedDiv.classList.remove('active');
          baseMap[base].active = false;
          this.map.removeLayer(baseMap[base].layer);
        }
      };
    } else {
      this.showLayerWms = false;
      this.legendWms = [];
      if (this.nivelPolygons == "Country") {
        this.showLegend = true;
      }

      for (const polygon of Object.keys(this.polygons)) {
        if (this.polygons[polygon] != undefined) {
          switch (polygon) {
            case 'select_country':
              this.polygons[polygon].eachLayer(function (layer) {
                layer.setStyle({
                  "opacity": 0.5,
                  "fillOpacity": 0.7,
                  "weight": 1
                })
              });
              break;
            case 'select_state':
              if (this.cdmx_mode) {
                this.polygons[polygon].eachLayer(function (layer) {
                  const colorMunicipio = that.getColorByScaleMunicipalities(layer.feature.properties.num_casos_covid);
                  if (that.select_municipality == undefined || that.select_municipality.properties.municipio_cvegeo != layer.feature.properties.municipio_cvegeo) {
                    layer.setStyle({
                      "color": colorMunicipio.color,
                      "fillColor": colorMunicipio.fillColor,
                      "opacity": 1,
                      "fillOpacity": 0.9,
                      "weight": 1
                    })
                  } else {
                    layer.setStyle({
                      "color": colorMunicipio.color,
                      "fillColor": colorMunicipio.fillColor,
                      "opacity": 1,
                      "fillOpacity": 0.9,
                      "weight": 6
                    })
                  }
                });
              } else {
                this.polygons[polygon].eachLayer(function (layer) {
                  const colorMunicipio = that.getColorByScaleMunicipalities(layer.feature.properties.num_casos_covid);
                  layer.setStyle({
                    "color": colorMunicipio.color,
                    "fillColor": colorMunicipio.fillColor,
                    "opacity": 1,
                    "fillOpacity": 0.9,
                    "weight": 1
                  })
                });
              }
              break;
            case 'select_municipality':
              this.polygons[polygon].eachLayer(function (layer) {
                layer.setStyle({
                  "color": '#900dd6',
                  "opacity": 0.3,
                  "weight": 1
                })
              });
              break;
            case 'select_ageb':
              if (this.nivelPolygons == "ZonaLocalidad") {
                this.polygons[polygon].eachLayer(function (layer) {
                  layer.setStyle({
                    "color": '#d60d53',
                    "opacity": 0.7
                  })
                });
              } else {
                this.polygons[polygon].eachLayer(function (layer) {
                  layer.setStyle({
                    "color": '#a7d60d',
                    "opacity": 0.7
                  })
                });
              }
              break;
            case 'select_urban_areas':
              this.polygons[polygon].eachLayer(function (layer) {
                if (that.select_metropolitan === undefined || that.select_metropolitan.properties.entidad_cvegeo != layer.feature.properties.entidad_cvegeo) {
                  layer.setStyle({
                    "color": '#6C3721',
                    "opacity": 0.3,
                    "weight": 1
                  })
                } else {
                  layer.setStyle({
                    "color": '#6C3721',
                    "opacity": 0.3,
                    "weight": 6
                  })
                }
              });
              break;
            case 'select_categories':
              this.polygons[polygon].eachLayer(function (layer) {
                layer.setStyle({
                  "opacity": 0.5,
                  "fillOpacity": 0.7,
                  "weight": 1
                })
              });
              break;
          }
        }
      };
      this.select_ws = undefined;
      for (const base of Object.keys(baseMap)) {
        this.map.removeLayer(baseMap[base].layer);
      };

      document.getElementById("showMapCovidModoNormalCountry").classList.remove('active');
      document.getElementById("showMapExpositionModoNormalCountry").classList.add('active');
      if (!this.cdmx_mode) {
        if (this.statusMapMode) {
          this.toggleMapModeExpositionModeRegion();
        } else {
          this.toggleMapModeExpositionModeNormalCountry();
        }
      }
    }
  };

  resetWms(reset = false) {
    let that = this;
    this.showLayerWms = false;
    this.select_ws = undefined;
    this.legendWms = [];

    for (const baseMap of Object.keys(this.status_wms)) {
      if (this.status_wms[baseMap] != undefined) {
        for (const base of Object.keys(this.status_wms[baseMap])) {
          this.status_wms[baseMap][base].active = false;
          this.map.removeLayer(this.status_wms[baseMap][base].layer);
          const selectedDiv = document.getElementById(base);
          selectedDiv.classList.remove('active');
        }
      }
    }

    for (const polygon of Object.keys(this.polygons)) {
      if (this.polygons[polygon] != undefined) {
        switch (polygon) {
          case 'select_country':
            this.polygons[polygon].eachLayer(function (layer) {
              layer.setStyle({
                "opacity": 0.5,
                "fillOpacity": 0.7,
                "weight": 1
              })
            });
            break;
          case 'select_state':
            this.polygons[polygon].eachLayer(function (layer) {
              const colorMunicipio = that.getColorByScaleMunicipalities(layer.feature.properties.num_casos_covid);
              layer.setStyle({
                "color": colorMunicipio.color,
                "fillColor": colorMunicipio.fillColor,
                "opacity": 1,
                "fillOpacity": 0.9,
                "weight": 1
              })
            });
            break;
          case 'select_municipality':
            if (reset == false) {
              this.polygons[polygon].eachLayer(function (layer) {
                layer.setStyle({
                  "color": '#900dd6',
                  "opacity": 0.3,
                  "weight": 1
                })
              });
            }
            break;
          case 'select_ageb':
            if (this.nivelPolygons == "ZonaLocalidad") {
              this.polygons[polygon].eachLayer(function (layer) {
                layer.setStyle({
                  "color": '#d60d53',
                  "opacity": 0.7
                })
              });
            } else {
              this.polygons[polygon].eachLayer(function (layer) {
                layer.setStyle({
                  "color": '#a7d60d',
                  "opacity": 0.7
                })
              });
            }
            break;
          case 'select_urban_areas':
            this.polygons[polygon].eachLayer(function (layer) {
              layer.setStyle({
                "color": '#6C3721',
                "opacity": 0.3,
                "weight": 1
              })
            });
            break;
          case 'select_categories':
            this.polygons[polygon].eachLayer(function (layer) {
              layer.setStyle({
                "opacity": 0.5,
                "fillOpacity": 0.7,
                "weight": 1
              })
            });
            break;
        }
      }
    };
  }

  toggleLayerGroup(label, name, index) {
    this.casesLegendHospitalsCovid[index].enable = !this.casesLegendHospitalsCovid[index].enable;
    let enable = this.casesLegendHospitalsCovid[index].enable;

    if (enable) {
      let that = this
      this.casesLegendHospitalsCovid[index].marker.forEach((layer) => {
        that.markerClusters['covidHospitals'].addLayer(layer);
      })
    } else {
      let that = this
      that.casesLegendHospitalsCovid[index].marker = []
      this.markerClusters['covidHospitals'].eachLayer(function (layer) {
        if (index == 5) {
          if (layer.feature.properties.covid.value == 'Hospital SEDESA Designado COVID') {
            that.casesLegendHospitalsCovid[index].marker.push(layer);
            that.markerClusters['covidHospitals'].removeLayer(layer)
          }
        }
        else if (index == 6) {
          if (layer.feature.properties.covid.value != 'Hospital SEDESA Designado COVID') {
            if (layer.feature.properties.covid.value == 'Hospital Red SEDESA') {
              that.casesLegendHospitalsCovid[index].marker.push(layer);
              that.markerClusters['covidHospitals'].removeLayer(layer)
            }
          }
        } else {
          if (layer.feature.properties.institution.value.includes(name)) {
            that.casesLegendHospitalsCovid[index].marker.push(layer);
            that.markerClusters['covidHospitals'].removeLayer(layer)
          }
        }
      });
    }

    this.markerClusters['covidHospitals'].refreshClusters();
  }

  toggleLayerGroupSedesa(label, name, index) {
    this.casesLegendHospitalsSedesaCovid[index].enable = !this.casesLegendHospitalsSedesaCovid[index].enable;
    let enable = this.casesLegendHospitalsSedesaCovid[index].enable;

    if (enable) {
      let that = this
      this.casesLegendHospitalsSedesaCovid[index].marker.forEach((layer) => {
        that.markerClusters['sedesa'].addLayer(layer);
      })
    } else {
      let that = this
      that.casesLegendHospitalsSedesaCovid[index].marker = []
      this.markerClusters['sedesa'].eachLayer(function (layer) {
        if (index == 0) {
          if (layer.feature.properties.covid.value == 'Hospital SEDESA Designado COVID') {
            that.casesLegendHospitalsSedesaCovid[index].marker.push(layer);
            that.markerClusters['sedesa'].removeLayer(layer)
          }
        }
        else if (index == 1) {
          if (layer.feature.properties.covid.value != 'Hospital SEDESA Designado COVID') {
            if (layer.feature.properties.covid.value == 'Hospital Red SEDESA') {
              that.casesLegendHospitalsSedesaCovid[index].marker.push(layer);
              that.markerClusters['sedesa'].removeLayer(layer)
            }
          }
        }
      });
    }

    this.markerClusters['sedesa'].refreshClusters();
  }

  toggleLayerGroup2(label, name, index) {

    this.casesLegendHospitalsDisponibility[index].enable = !this.casesLegendHospitalsDisponibility[index].enable;
    let enableDisp = this.casesLegendHospitalsDisponibility[index].enable;



    this.markerClusters['hospitalsCDMX'].refreshClusters();

    if (enableDisp) {
      let that = this
      this.casesLegendHospitalsDisponibility[index].marker.forEach((layer) => {
        that.markerClusters['hospitalsCDMX'].addLayer(layer);
      })
    } else {
      let that = this
      that.casesLegendHospitalsDisponibility[index].marker = []
      this.markerClusters['hospitalsCDMX'].eachLayer(function (layer) {
        if (index == 0) {
          if (layer.feature.properties.disponibilidad.value.includes("Disponibilidad alta")) {
            that.casesLegendHospitalsDisponibility[index].marker.push(layer);
            that.markerClusters['hospitalsCDMX'].removeLayer(layer)
          }
        }
        else if (index == 1) {

          if (layer.feature.properties.disponibilidad.value.includes("Disponibilidad media")) {
            that.casesLegendHospitalsDisponibility[index].marker.push(layer);
            that.markerClusters['hospitalsCDMX'].removeLayer(layer)
          }

        }
        else if (index == 2) {

          if (layer.feature.properties.disponibilidad.value.includes("Sin disponibilidad")) {
            that.casesLegendHospitalsDisponibility[index].marker.push(layer);
            that.markerClusters['hospitalsCDMX'].removeLayer(layer)
          }

        } else {
          if (layer.feature.properties.disponibilidad.value.includes(name)) {
            that.casesLegendHospitalsDisponibility[index].marker.push(layer);
            that.markerClusters['hospitalsCDMX'].removeLayer(layer)
          }
        }
      });
    }


    this.markerClusters['hospitalsCDMX'].refreshClusters();
  }



  getRandomColor() {
    var color = Math.floor(0x1000000 * Math.random()).toString(16);
    return '#' + ('000000' + color).slice(-6);
  }

  showAreaExposition() {
    this.resetWms();
    let that = this;

    let municipality_style = {
      "color": '#000000',
      "opacity": 0.5,
      "fillOpacity": 0.1,
      "weight": 1
    };

    // this.clearPolygons('select_state');
    // this.clearPolygons('select_urban_areas');
    if (this.polygons["select_urban_areas"] != undefined) {
      this.polygons["select_urban_areas"].eachLayer(function (layer) {
        layer.setStyle({
          "color": "#000000",
          "opacity": 0.5,
          "fillOpacity": 0.1,
          "weight": 1
        })
      });
    };

    if (this.polygons["select_state"] != undefined) {
      this.polygons["select_state"].eachLayer(function (layer) {
        if (that.select_municipality == undefined || that.select_municipality.properties.municipio_cvegeo != layer.feature.properties.municipio_cvegeo) {
          layer.setStyle({
            "color": '#000000',
            "opacity": 0.5,
            "fillOpacity": 0.1,
            "weight": 1
          })
        } else {
          layer.setStyle({
            "color": '#000000',
            "opacity": 0.5,
            "fillOpacity": 0.1,
            "weight": 6
          })
        }
      });
    };

    this.zoneGeoJsonExposition = L.geoJSON(this.zoneExposition, {
      style: municipality_style,
      onEachFeature: function (feature, layer) {
        that.casesAreaExposition.forEach((data) => {
          if (data.max == feature.properties.index_gen) {
            layer.setStyle({
              "color": data.color,
              "opacity": 0.5,
              "fillOpacity": 0.7,
              "weight": 1
            });
          }

          if (data.min <= feature.properties.index_gen && feature.properties.index_gen < data.max) {
            layer.setStyle({
              "color": data.color,
              "opacity": 0.5,
              "fillOpacity": 0.7,
              "weight": 1
            });
          }
        })

        layer.on('mouseover', (e) => {
          layer.setStyle({
            "weight": 2
          });
          let municipality = feature.properties.municipio_nombre
        });

        layer.on('mouseout', (e) => {
          layer.setStyle({
            "weight": 1
          });

          let municipality = "";
          that.info.update_exponential(municipality);
        });
      }
    }).addTo(that.map);

    this.zoneGeoJsonExposition.bringToBack();
  }

  showAreaExpositionModeNormal() {
    this.resetWms();
    let that = this;

    let municipality_style = {
      "color": '#000000',
      "opacity": 0.5,
      "fillOpacity": 0.1,
      "weight": 1
    };

    for (const polygon of Object.keys(this.polygons)) {
      if (this.polygons[polygon] != undefined) {
        this.polygons[polygon].eachLayer(function (layer) {
          if (polygon == "select_country" ||
            polygon == "select_state" && that.select_state.properties.entidad_cvegeo == layer.feature.properties.entidad_cvegeo) {
            layer.setStyle({
              "color": "#000000",
              "opacity": 0.5,
              "fillOpacity": 0.1,
              "weight": 1
            })
          }

          // if (polygon == "select_state" && that.select_state.properties.entidad_cvegeo == layer.feature.properties.entidad_cvegeo){
          //   const colorMunicipio = that.getColorByScaleMunicipalities(layer.feature.properties.num_casos_covid);
          //   layer.setStyle({
          //     "color": colorMunicipio.color,
          //     "fillColor": colorMunicipio.fillColor,
          //     "opacity": 1,
          //     "fillOpacity": 0.9,
          //     "weight": 1
          //   })
          // }
        });
      }
    };

    this.zoneGeoJsonExposition = L.geoJSON(this.zoneExposition, {
      style: municipality_style,
      onEachFeature: function (feature, layer) {
        const colorMunicipio = that.getColorByScaleMapExposition(feature.properties.index_gen);
        layer.setStyle({
          "color": colorMunicipio,
          "opacity": 0.5,
          "fillOpacity": 0.7,
          "weight": 1
        });

        layer.on('mouseover', (e) => {
          if (that.select_municipality === undefined || that.select_municipality.properties.municipio_cvegeo != feature.properties.municipio_cvegeo) {
            if (!that.showLayerWms && !that.showLegendAreaExposition) {
              layer.setStyle({
                "color": colorMunicipio,
                "opacity": 0.5,
                "fillOpacity": 0.7,
                "weight": 2
              });
            } else {
              layer.setStyle({
                "weight": 2
              });
            }
            let municipality = feature.properties.municipio_nombre;
            //let index_gen = feature.properties.index_gen;
            let index_gen = that.getLabelForExposition(feature.properties.index_gen)
            that.info.update_exponential(municipality, index_gen);
          }
        });

        layer.on('mouseout', (e) => {
          if (!that.showLayerWms && !that.showLegendAreaExposition) {
            layer.setStyle({
              "color": "#FFFFFF",
              "fullColor": colorMunicipio,
              "opacity": 0.5,
              "fillOpacity": 0.7,
              "weight": 1
            });
          } else {
            layer.setStyle({
              "weight": 1
            });
          }
          let municipality = "";
          that.info.update_exponential(municipality);
        });

        layer.on('click', (e) => {
          if (that.select_municipality == undefined || that.select_municipality.properties.municipio_cvegeo != feature.properties.municipio_cvegeo) {
            that.select_locality = undefined;
            that.select_ageb = undefined;
            that.spinner.show();
            that.map.flyToBounds(layer.getBounds(), { paddingBottomRight: [10, 10] })
            that.map.once('moveend', function (e) {
              that.loadGeoJsonMunicipies(feature, layer, that)
            });
          }
        });
      }
    }).addTo(that.map);

    this.zoneGeoJsonExposition.bringToBack();
    this.polygons['select_state'].bringToBack();
    this.polygons["select_country"].bringToBack();
  }

  showAreaExpositionModeNormalCountry() {
    this.resetWms();
    let that = this;

    let municipality_style = {
      "color": '#000000',
      "opacity": 0.5,
      "fillOpacity": 0.1,
      "weight": 1
    };

    for (const polygon of Object.keys(this.polygons)) {
      if (this.polygons[polygon] != undefined) {
        this.polygons[polygon].eachLayer(function (layer) {
          if (polygon == "select_country") {
            if (that.select_state === undefined || that.select_state.properties.entidad_cvegeo != layer.feature.properties.entidad_cvegeo) {
              layer.setStyle({
                "color": "#000000",
                "opacity": 0.5,
                "fillOpacity": 0.1,
                "weight": 1
              })
            } else {
              layer.setStyle({
                "color": "#000000",
                "opacity": 0.5,
                "fillOpacity": 0.1,
                "weight": 6
              })
            }
          }

          if (polygon == "select_state") {
            if (that.select_municipality === undefined || that.select_municipality.properties.municipio_cvegeo != layer.feature.properties.municipio_cvegeo) {
              layer.setStyle({
                "color": "#000000",
                "opacity": 0.5,
                "fillOpacity": 0.1,
                "weight": 1
              })
            } else {
              layer.setStyle({
                "color": "#000000",
                "opacity": 0.5,
                "fillOpacity": 0.1,
                "weight": 6
              })
            }
          }
        });
      }
    };

    this.zoneGeoJsonExposition = L.geoJSON(this.zoneExposition, {
      style: municipality_style,
      onEachFeature: function (feature, layer) {
        const colorMunicipio = that.getColorByScaleMapExposition(feature.properties.index_gen);
        layer.setStyle({
          "color": colorMunicipio,
          "opacity": 0.5,
          "fillOpacity": 0.7,
          "weight": 1
        });

        layer.on('mouseover', (e) => {
          if (that.select_municipality === undefined || that.select_municipality.properties.municipio_cvegeo != feature.properties.municipio_cvegeo) {
            if (!that.showLayerWms && !that.showLegendAreaExposition) {
              layer.setStyle({
                "color": colorMunicipio,
                "opacity": 0.5,
                //"fillOpacity": 0.7,
                "fill": false,
                "weight": 2
              });
            } else {
              layer.setStyle({
                "weight": 2
              });
            }
            let municipality = feature.properties.municipio_nombre;
            //let index_gen = feature.properties.index_gen;
            let index_gen = that.getLabelForExposition(feature.properties.index_gen)
            that.info.update_exponential(municipality, index_gen);
          }
        });

        layer.on('mouseout', (e) => {
          if (!that.showLayerWms && !that.showLegendAreaExposition) {
            layer.setStyle({
              "color": "#FFFFFF",
              "fullColor": colorMunicipio,
              "opacity": 0.5,
              "fillOpacity": 0.7,
              "weight": 1
            });
          } else {
            layer.setStyle({
              "weight": 1
            });
          }
          let municipality = "";
          that.info.update_exponential(municipality);
        });

        layer.on('click', (e) => {
          if (that.select_municipality == undefined || that.select_municipality.properties.municipio_cvegeo != feature.properties.municipio_cvegeo) {
            that.select_locality = undefined;
            that.select_ageb = undefined;
            that.spinner.show();
            that.map.flyToBounds(layer.getBounds(), { paddingBottomRight: [10, 10] })
            that.map.once('moveend', function (e) {
              that.loadGeoJsonMunicipies(feature, layer, that)
            });
          }
        });
      }
    }).addTo(that.map);

    this.zoneGeoJsonExposition.bringToBack();
  }

  showAreaExpositionModeRegion() {
    this.resetWms();

    let that = this;

    let municipality_style = {
      "color": '#000000',
      "opacity": 0.5,
      "fillOpacity": 0.1,
      "weight": 1
    };

    for (const polygon of Object.keys(this.polygons)) {
      if (this.polygons[polygon] != undefined) {
        this.polygons[polygon].eachLayer(function (layer) {
          if (polygon == "select_categories" ||
            polygon == "select_urban_areas" && that.select_urban_areas.properties.region_urbana_cve == layer.feature.properties.region_urbana_cve)
            layer.setStyle({
              "color": "#000000",
              "opacity": 0.5,
              "fillOpacity": 0.1,
              "weight": 1
            })
          if (polygon == "select_state") {
            if (that.select_municipality == undefined || that.select_municipality.properties.municipio_cvegeo != layer.feature.properties.municipio_cvegeo) {
              layer.setStyle({
                "color": "#000000",
                "opacity": 0.5,
                "fillOpacity": 0.1,
                "weight": 1
              })
            } else {
              layer.setStyle({
                "color": "#000000",
                "opacity": 0.5,
                "fillOpacity": 0.1,
                "weight": 6
              })
            }
          }
        });
      }
    };

    this.zoneGeoJsonExposition = L.geoJSON(this.zoneExposition, {
      style: municipality_style,
      onEachFeature: function (feature, layer) {
        const colorMunicipio = that.getColorByScaleMapExposition(feature.properties.index_gen);
        layer.setStyle({
          "color": colorMunicipio,
          "opacity": 0.5,
          "fillOpacity": 0.7,
          "weight": 1
        });
      }
    }).addTo(that.map);

    this.zoneGeoJsonExposition.bringToBack();
  }

  showCovidModeRegion() {
    this.resetWms();

    let that = this;

    let municipality_style = {
      "color": '#000000',
      "opacity": 0.5,
      "fillOpacity": 0.1,
      "weight": 1
    };

    for (const polygon of Object.keys(this.polygons)) {
      if (this.polygons[polygon] != undefined) {
        this.polygons[polygon].eachLayer(function (layer) {
          if (polygon == "select_categories" ||
            polygon == "select_urban_areas" && that.select_urban_areas.properties.region_urbana_cve == layer.feature.properties.region_urbana_cve)
            layer.setStyle({
              "color": "#000000",
              "opacity": 0.5,
              "fillOpacity": 0.1,
              "weight": 1
            })
          if (polygon == "select_state") {
            if (that.select_municipality == undefined || that.select_municipality.properties.municipio_cvegeo != layer.feature.properties.municipio_cvegeo) {
              layer.setStyle({
                "color": "#000000",
                "opacity": 0.5,
                "fillOpacity": 0.1,
                "weight": 1
              })
            } else {
              layer.setStyle({
                "color": "#000000",
                "opacity": 0.5,
                "fillOpacity": 0.1,
                "weight": 6
              })
            }
          }
        });
      }
    };

    this.zoneGeoJsonExposition = L.geoJSON(this.zoneCovid, {
      style: municipality_style,
      onEachFeature: function (feature, layer) {
        const colorMunicipio = that.getColorByScaleMunicipalities(feature.properties.total);
        layer.setStyle({
          "color": colorMunicipio.fillColor,
          "opacity": 0.5,
          "fillOpacity": 0.7,
          "weight": 1
        });
      }
    }).addTo(that.map);

    this.zoneGeoJsonExposition.bringToBack();
  }

  resetLegedHospitalCovid() {
    this.casesLegendHospitalsCovid.forEach((data) => {
      data.enable = true;
      data.marker = [];
    });
  }

  resetLegedHospitalCovidSedesa() {
    this.casesLegendHospitalsSedesaCovid.forEach((data) => {
      data.enable = true;
      data.marker = [];
    });
  }

  resetPolygonStatesExposition() {
    let that = this;
    for (const polygon of Object.keys(this.polygons)) {
      if (this.polygons[polygon] != undefined) {
        this.polygons[polygon].eachLayer(function (layer) {
          if (polygon == "select_country") {
            const colors = that.getColorByScale(layer.feature.properties.covid);
            if (that.select_state === undefined || that.select_state.properties.entidad_cvegeo != layer.feature.properties.entidad_cvegeo) {
              layer.setStyle({
                "color": colors.color,
                'fillColor': colors.fillColor,
                "opacity": 0.5,
                "fillOpacity": 0.7,
                "weight": 1
              });
            } else {
              layer.setStyle({
                "color": colors.color,
                'fillColor': colors.fillColor,
                "opacity": 0.5,
                "fillOpacity": 0.9,
                "weight": 6
              });
            }
          }
          if (that.statusMapMode) {
            //if (polygon == "select_state" && that.select_metropolitan.properties.entidad_cvegeo == layer.feature.properties.entidad_cvegeo) {              
            if (polygon == "select_state") {
              const colorMunicipio = that.getColorByScaleMunicipalities(layer.feature.properties.num_casos_covid);
              layer.setStyle({
                "color": colorMunicipio.color,
                "fillColor": colorMunicipio.fillColor,
                "opacity": 1,
                "fillOpacity": 0.7,
                "weight": 1
              })
            }
          }

          if (!that.statusMapMode) {
            if (polygon == "select_state" && that.select_state.properties.entidad_cvegeo == layer.feature.properties.entidad_cvegeo) {
              const colorMunicipio = that.getColorByScaleMunicipalities(layer.feature.properties.num_casos_covid);
              layer.setStyle({
                "color": colorMunicipio.color,
                "fillColor": colorMunicipio.fillColor,
                "opacity": 1,
                "fillOpacity": 0.9,
                "weight": 1
              })
              // let colorMapExposition = that.getColorByScaleMapExposition(layer.feature.properties.index_gen);
              // layer.setStyle({
              //   "color": "#000000",
              //   "fillColor": colorMapExposition,
              //   "opacity": 0.5,
              //   "fillOpacity": 0.7,
              //   "weight": 1
              // });
            }
          }

          if (polygon == "select_categories") {
            let colors = that.getColorByCategory(layer.feature.properties.region_urbana_cve);
            layer.setStyle({
              "color": colors.color,
              'fillColor': colors.fillColor,
              "opacity": 0.5,
              "fillOpacity": 0.7,
              "weight": 1
            });
          }

          if (polygon == "select_urban_areas" && that.select_urban_areas.properties.region_urbana_cve == layer.feature.properties.region_urbana_cve) {
            layer.setStyle({
              "color": "#6C3721",
              "opacity": 0.3,
              "weight": 1
            })
          }
        });
      }
    };
  }

  toggleDataChild(cardType) {
    switch (cardType) {
      case 'covidHospitals':
        this.generalData.covidHospitals.showChildren = !this.generalData.covidHospitals.showChildren;
        break;
      case 'ventilators':
        this.generalData.ventilators.showChildren = !this.generalData.ventilators.showChildren;
        this.generalData.ventilatorsClues.showChildren = !this.generalData.ventilatorsClues.showChildren;
        break;
      case 'beds':
        this.generalData.camas.showChildren = !this.generalData.camas.showChildren;
        break;
      case 'medicos':
        this.generalData.medicos.showChildren = !this.generalData.medicos.showChildren;
        break;
    }
  }


  toggleDataChildSedesa(cardType) {
    switch (cardType) {
      case 'beds':
        this.redSedesa.camas.showChildren = !this.redSedesa.camas.showChildren;
        break;
      case 'recursosHum':
        this.redSedesa.recursosHum.showChildren = !this.redSedesa.recursosHum.showChildren;
        break;
      case 'consultorios':
        this.redSedesa.consultorios.showChildren = !this.redSedesa.consultorios.showChildren;
        break;
    }
  }

  clearSedesa(type = '') {



    if (this.cdmxModeSedesa != undefined) {
      this.map.removeLayer(this.cdmxModeSedesa);
      this.cdmxModeSedesa = undefined;
    }
    if (type != '') {
      if (this.map.hasLayer(this.markerClusters[type])) {
        this.map.removeLayer(this.markerClusters[type])
        this.markerClusters[type].clearLayers();
      }
      this.markerClusters[type].enableClustering();
    }
    else {
      if (this.map.hasLayer(this.markerClusters["sedesa"])) {
        this.map.removeLayer(this.markerClusters["sedesa"])
        this.markerClusters["sedesa"].clearLayers();
      }
      this.markerClusters["sedesa"].enableClustering();

      if (this.map.hasLayer(this.markerClusters["sedesaTemp"])) {
        this.map.removeLayer(this.markerClusters["sedesaTemp"])
        this.markerClusters["sedesaTemp"].clearLayers();
      }
      this.markerClusters["sedesaTemp"].enableClustering();
    }
  }


  readMoreIntro() {
    var dotsInfo = document.getElementById("dots");
    var moreInfo = document.getElementById("more");
    var buttonInfo = document.getElementById("readMoreBtn");

    if (dotsInfo.style.display === "none") {
      dotsInfo.style.display = "inline";
      buttonInfo.innerHTML = "Leer más";
      moreInfo.style.display = "none";
    } else {
      dotsInfo.style.display = "none";
      buttonInfo.innerHTML = "Leer menos";
      moreInfo.style.display = "inline";
    }
  }
  closeModal() {
    let that = this;
    if (that.rendererTableSedesa) {
      that.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        that.dtTrigger.next();
      });
    } else {
      that.dtTrigger.next();
      that.rendererTableSedesa = true
    }
  }

  restartTutorial() {
    let steps = [];
    if (this.statusMapMode) {
      steps = [
        {
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>Bienvenido al Explorador de Vulnerabilidad COVID-19 en México</span>
        </div>
        `,
          stepNumber: 0
        },
        {
          element: document.querySelector('#step1'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>En esta parte puedes explorar por municipio el grado de vulnerabilidad a COVID-2019, al dar clic en el municipio de lado derecho aparecerán datos relevantes sobre el tema</span>
        </div>
        `,
          stepNumber: 1
        },
        {
          element: document.querySelector('#step1'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>En esta sección puedes ver la información en tiempo real de Twitter de la secretaría de salud y otros medios oficiales</span>
        </div>
        `,
          stepNumber: 2
        },
        {
          element: document.querySelector('#step1'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>Aquí puedes activar y desactivar en el mapa, las capas disponibles relacionadas con la vulnerabilidad a COVID-19</span>
        </div>
        `,
          stepNumber: 3
        },
        {
          element: document.querySelector('#step2'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>Información actualizada diariamente sobre la evolución espacio temporal del virus</span>
        </div>
        `,
          stepNumber: 4
        },
        {
          element: document.querySelector('#step2'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>En esta sección podrás explorar variables socioeconómicas y demográficas a nivel municipal</span>
        </div>
        `,
          stepNumber: 5
        },
        {
          element: document.querySelector('#step2'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>Aquí encontrarás los factores de riesgo que son relevantes para incrementar la vulnerabilidad al virus</span>
        </div>
        `,
          stepNumber: 6
        },
        {
          element: document.querySelector('#step3'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>Aquí podrás identificar dónde y cuantos hospitales y laboratorios COVID hay por municipio</span>
        </div>
        `,
          stepNumber: 7
        },
        {
          element: document.querySelector('#step4'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>Aquí puedes activar y desactivar en el mapa, la vista por regiones urbanas</span>
        </div>
        `,
          stepNumber: 8
        },
        {
          element: document.querySelector('#step5'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>Aquí puedes cambiar el estilo del mapa base</span>
        </div>
        `,
          stepNumber: 9
        },
        {
          element: document.querySelector('#step7'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>Aquí puedes volver a centrar el mapa en la pantalla</span>
        </div>
        `,
          stepNumber: 10
        },
        {
          element: document.querySelector('#step8_2'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>Aquí puedes volver al inicio del mapa</span>
        </div>
        `,
          stepNumber: 11
        },
        {
          element: document.querySelector('#step9'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>Aquí puedes volver a iniciar esta introducción</span>
        </div>
        `,
          stepNumber: 12
        }
      ]
    } else {
      steps = [
        {
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>Bienvenido al Explorador de Vulnerabilidad COVID-19 en México</span>
        </div>
        `,
          stepNumber: 0
        },
        {
          element: document.querySelector('#step1'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>En esta parte puedes explorar por municipio el grado de vulnerabilidad a COVID-2019, al dar clic en el municipio de lado derecho aparecerán datos relevantes sobre el tema</span>
        </div>
        `,
          stepNumber: 1
        },
        {
          element: document.querySelector('#step1'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>En esta sección puedes ver la información en tiempo real de Twitter de la secretaría de salud y otros medios oficiales</span>
        </div>
        `,
          stepNumber: 2
        },
        {
          element: document.querySelector('#step1'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>Aquí puedes activar y desactivar en el mapa, las capas disponibles relacionadas con la vulnerabilidad a COVID-19</span>
        </div>
        `,
          stepNumber: 3
        },
        {
          element: document.querySelector('#step2'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>Información actualizada diariamente sobre la evolución espacio temporal del virus</span>
        </div>
        `,
          stepNumber: 4
        },
        {
          element: document.querySelector('#step2'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>En esta sección podrás explorar variables socioeconómicas y demográficas a nivel municipal</span>
        </div>
        `,
          stepNumber: 5
        },
        {
          element: document.querySelector('#step2'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>Aquí encontrarás los factores de riesgo que son relevantes para incrementar la vulnerabilidad al virus</span>
        </div>
        `,
          stepNumber: 6
        },
        {
          element: document.querySelector('#step3'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>Aquí podrás identificar dónde y cuantos hospitales y laboratorios COVID hay por municipio</span>
        </div>
        `,
          stepNumber: 7
        },
        {
          element: document.querySelector('#step4'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>Aquí puedes activar y desactivar en el mapa, la vista por regiones urbanas</span>
        </div>
        `,
          stepNumber: 8
        },
        {
          element: document.querySelector('#step5'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>Aquí puedes cambiar el estilo del mapa base</span>
        </div>
        `,
          stepNumber: 9
        },
        {
          element: document.querySelector('#step6'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>Aquí puedes activar y desactivar en el mapa, la visualización de casos COVID por estado</span>
        </div>
        `,
          stepNumber: 10
        },
        {
          element: document.querySelector('#step7'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>Aquí puedes volver a centrar el mapa en la pantalla</span>
        </div>
        `,
          stepNumber: 11
        },
        {
          element: document.querySelector('#step8'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>Aquí puedes volver al inicio del mapa</span>
        </div>
        `,
          stepNumber: 12
        },
        {
          element: document.querySelector('#step9'),
          intro: `
        <div>
          <i class="fas fa-info-circle fa-lg"></i>
          <span>Aquí puedes volver a iniciar esta introducción</span>
        </div>
        `,
          stepNumber: 13
        }
      ];
    }

    this.introJS.setOption("steps", steps);

    this.introJS.start();
    this.infoLayers[0].display = true;
    this.infoLayers[1].display = true;
    this.infoLayers[0].visible = false;
    this.infoLayers[1].visible = false;

    let actionContainer = document.querySelector('.action-container');
    actionContainer.classList.add('tutorial');
  }

  flyToLayer(coordinates) {
    this.map.flyTo([coordinates[1], coordinates[0]], 15);
  }

  initSearchMunicipality() {
    let newAllelements = []
    archive_municipio['features'].forEach(element => {
      archive_entidades["features"].forEach(states => {
        if (element["properties"]['municipi_1'] && element["properties"]['entidad_cv'] == states["properties"]['entidad_cv'] && element.geometry != null) {
          let newOptionMunicipality = {
            "name": element["properties"]['municipi_1'] + ", " + states["properties"]['entidad_no'],
            "id": element["properties"]['entidad_cv'],
            "municipio_cvegeo": element["properties"]['municipio_'],
            "entidad_cvegeo": element["properties"]['entidad_cv']
          }
          newAllelements.push(newOptionMunicipality)
        }
      });
    });

    newAllelements = newAllelements.sort(function (a, b) {
      const bandA = a.name.toUpperCase();
      const bandB = b.name.toUpperCase();

      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    });
    this.allMunicipality = newAllelements
  }

  onChange(event) {
    let that = this;
    if (event != undefined) {
      this.selecteOneCountry(event);
    }
  }

  selecteOneCountry(event) {
    let that = this;
    this.polygons["select_country"].eachLayer(function (layer) {
      if (layer.feature.properties.entidad_cvegeo == event.entidad_cvegeo) {
        that.select_locality = undefined;
        that.select_municipality = undefined;
        that.select_ageb = undefined;
        that.spinner.show();
        let levelZoom = that.map.getBoundsZoom(layer.getBounds());
        if (levelZoom == 9) {
          that.map.flyToBounds(layer.getBounds(), { paddingBottomRight: [0, 0], maxZoom: levelZoom - 1 })
        } else {
          that.map.flyToBounds(layer.getBounds(), { paddingBottomRight: [0, 0], maxZoom: levelZoom })
        }
        that.map.once('moveend', function (e) {
          layer.setStyle({
            "weight": 6
          });

          that.selectOneStates(layer.feature, layer, that, event)
        });
      }
    });
  }

  selectOneStates(feature, layer, that, event) {
    this.showLegend = false;

    that.estadoCOVID = feature.properties.entidad_nombre
    that.nivelPolygons = "Estado";
    that.select_state = feature;

    if (that.layer['select_state'] != undefined) {
      that.layer["select_state"].setStyle({
        "weight": 1
      })
    }

    that.layer["select_state"] = layer;
    that.clearPolygons('select_state');
    that.clearPolygons('select_municipality');
    that.clearPolygons('select_locality');
    that.clearPolygons('select_ageb');
    that.clearAllMarkers();
    that.resetbutton()

    const entidad_cvegeo = feature.properties.entidad_cvegeo;
    that.dataEntityName = feature.properties.entidad_nombre + ", " + "México";
    this.current_state = feature.properties.entidad_nombre

    that.polygonService.getStates(entidad_cvegeo).subscribe(data => {
      that.spinner.hide()
      that.showButton();

      that.showlegendInfo["projection2020"] = false;
      that.showlegendInfo["poverty"] = false;
      that.showlegendInfo["mortality"] = false;
      that.showlegendInfo["covid"] = true;
      that.showlegendInfo["mortalityLocation"] = false;
      that.showlegendInfo["generalData"] = false;

      let covid_mun = data['casosCOVID_mun']
      let polygon_array = [];
      archive_municipio['features'].forEach(element => {
        if (element["properties"]['municipi_1'] && element["properties"]['entidad_cv'] == entidad_cvegeo && element.geometry != null) {
          let newPolygon = {
            "type": "Feature",
            "properties": {
              "entidad_cvegeo": element["properties"]['entidad_cv'],
              "municipio_cvegeo": element["properties"]['municipio_'],
              "municipio_nombre": element["properties"]['municipi_1'],
              "num_casos_covid": covid_mun[element["properties"]['municipio_']]
            },
            "geometry": element.geometry
          }
          polygon_array.push(newPolygon);
        }
      });


      that.clearPolygons('select_state');
      that.clearAllMarkers();

      that.polygons['select_state'] = L.geoJSON(polygon_array, {
        onEachFeature: function (feature, layer) {
          let colors = that.getColorByScaleMunicipalities(feature.properties.num_casos_covid);
          if (!that.showLayerWms && !that.showLegendAreaExposition) {
            layer.setStyle({
              "color": colors.color,
              'fillColor': colors.fillColor,
              "opacity": 1,
              "fillOpacity": 0.9,
              "weight": 1
            });
          } else {
            layer.setStyle({
              "color": '#000000',
              "opacity": 0.5,
              "fillOpacity": 0.01,
              "weight": 1
            });
          }

          layer.on('mouseover', (e) => {
            if (that.select_municipality === undefined || that.select_municipality.properties.municipio_cvegeo != feature.properties.municipio_cvegeo) {
              if (!that.showLayerWms && !that.showLegendAreaExposition) {
                layer.setStyle({
                  "color": colors.color,
                  'fillColor': colors.fillColor,
                  "opacity": 1,
                  "fillOpacity": 0.9,
                  "weight": 2
                });
                let municipality = feature.properties.municipio_nombre;
                let num_casos_covid = feature.properties.num_casos_covid;
                that.info.update_municipalities_covid(municipality, num_casos_covid);
              } else {
                layer.setStyle({
                  "weight": 2
                });
                let municipality = feature.properties.municipio_nombre;
                that.info.update_municipalities(municipality);
              }
            }
          });

          layer.on('mouseout', (e) => {
            if (that.select_municipality === undefined || that.select_municipality.properties.municipio_cvegeo != feature.properties.municipio_cvegeo) {
              if (!that.showLayerWms && !that.showLegendAreaExposition) {
                layer.setStyle({
                  "color": colors.color,
                  'fillColor': colors.fillColor,
                  "opacity": 1,
                  "fillOpacity": 0.9,
                  "weight": 1
                });
                that.info.update_municipalities_covid();
              } else {
                layer.setStyle({
                  "weight": 1
                });
                that.info.update_municipalities();
              }
            }
          });

          layer.on('click', (e) => {
            if (that.select_municipality == undefined || that.select_municipality.properties.municipio_cvegeo != feature.properties.municipio_cvegeo) {
              that.select_locality = undefined;
              that.select_ageb = undefined;
              that.spinner.show();
              that.map.flyToBounds(layer.getBounds(), { paddingBottomRight: [10, 10] })
              that.map.once('moveend', function (e) {
                layer.setStyle({
                  "weight": 6
                });
                that.loadGeoJsonMunicipies(feature, layer, that)
              });
            }
          });

          if (feature.properties.municipio_cvegeo == event.municipio_cvegeo) {
            that.select_locality = undefined;
            that.select_ageb = undefined;
            that.spinner.show();
            that.map.flyToBounds(layer.getBounds(), { paddingBottomRight: [10, 10] })
            that.map.once('moveend', function (e) {
              layer.setStyle({
                "weight": 6
              });
              that.loadGeoJsonMunicipies(feature, layer, that)
            });
          }
        },
      }).addTo(that.map);
      that.showLegendByMunicipalities = true;
    });
  }
}


